import * as i0 from '@angular/core';
import { EventEmitter, Component, Input, Output, Inject, Renderer2, HostBinding, Injectable, Directive, HostListener, ElementRef, NgModule, Pipe } from '@angular/core';
import { DOCUMENT, CommonModule } from '@angular/common';
import * as i1 from '@angular/router';
import { RouterModule, Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { filter, startWith } from 'rxjs/operators';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { DomSanitizer } from '@angular/platform-browser';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from 'ngx-bootstrap/dropdown';
import * as ɵngcc2 from 'ngx-perfect-scrollbar';
import * as ɵngcc3 from '@angular/router';
import * as ɵngcc4 from '@angular/common';
import * as ɵngcc5 from '@angular/platform-browser';

function AdminComponent_div_14_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 21);
    ɵngcc0.ɵɵelementStart(1, "div", 22);
    ɵngcc0.ɵɵelementStart(2, "strong");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "a", 23);
    ɵngcc0.ɵɵlistener("click", function AdminComponent_div_14_Template_a_click_4_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.logout.emit(); });
    ɵngcc0.ɵɵelement(5, "i", 24);
    ɵngcc0.ɵɵtext(6, " Logout");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.nameUserPerfil);
} }
function AppHeaderAdminComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "button", 2);
    ɵngcc0.ɵɵelement(1, "span", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("navbar-toggler ", ctx_r0.sidebarTogglerMobileClass, "");
} }
function AppHeaderAdminComponent_ng_template_2_img_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "img", 5);
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("appHtmlAttr", ctx_r4.navbarBrand)("ngClass", "navbar-brand");
} }
function AppHeaderAdminComponent_ng_template_2_img_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "img", 5);
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("appHtmlAttr", ctx_r5.navbarBrandFull)("ngClass", "navbar-brand-full");
} }
function AppHeaderAdminComponent_ng_template_2_img_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "img", 5);
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("appHtmlAttr", ctx_r6.navbarBrandMinimized)("ngClass", "navbar-brand-minimized");
} }
function AppHeaderAdminComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, AppHeaderAdminComponent_ng_template_2_img_0_Template, 1, 2, "img", 4);
    ɵngcc0.ɵɵtemplate(1, AppHeaderAdminComponent_ng_template_2_img_1_Template, 1, 2, "img", 4);
    ɵngcc0.ɵɵtemplate(2, AppHeaderAdminComponent_ng_template_2_img_2_Template, 1, 2, "img", 4);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.navbarBrand);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.navbarBrandFull);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.navbarBrandMinimized);
} }
function AppHeaderAdminComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 6);
    ɵngcc0.ɵɵelement(1, "div", 7);
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("innerHTML", ctx_r2.navbarBrandText.text, ɵngcc0.ɵɵsanitizeHtml);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("innerHTML", ctx_r2.navbarBrandText.icon, ɵngcc0.ɵɵsanitizeHtml);
} }
function AppHeaderAdminComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 8);
    ɵngcc0.ɵɵlistener("click", function AppHeaderAdminComponent_ng_template_4_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.openClose(); });
    ɵngcc0.ɵɵelement(1, "span", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("navbar-toggler ", ctx_r3.sidebarTogglerClass, "");
    ɵngcc0.ɵɵproperty("appSidebarToggler", ctx_r3.sidebarToggler);
} }
const _c0 = ["*"];
function AppSidebarNavDropdownComponent_i_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 3);
    ɵngcc0.ɵɵpipe(1, "appSidebarNavIcon");
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpipeBind1(1, 1, ctx_r0.item));
} }
function AppSidebarNavDropdownComponent_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 3);
    ɵngcc0.ɵɵpipe(1, "appSidebarNavBadge");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpipeBind1(1, 2, ctx_r1.item));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.item.badge.text);
} }
function AppSidebarNavItemsComponent_ng_container_0_app_sidebar_nav_dropdown_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "app-sidebar-nav-dropdown", 7);
    ɵngcc0.ɵɵpipe(1, "appSidebarNavItemClass");
} if (rf & 2) {
    const item_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("open", ctx_r2.helper.isActive(ctx_r2.router, item_r1));
    ɵngcc0.ɵɵproperty("item", item_r1)("ngClass", ɵngcc0.ɵɵpipeBind1(1, 4, item_r1));
} }
function AppSidebarNavItemsComponent_ng_container_0_app_sidebar_nav_divider_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "app-sidebar-nav-divider", 8);
    ɵngcc0.ɵɵpipe(1, "appSidebarNavItemClass");
} if (rf & 2) {
    const item_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("item", item_r1)("ngClass", ɵngcc0.ɵɵpipeBind1(1, 3, item_r1))("appHtmlAttr", item_r1.attributes);
} }
function AppSidebarNavItemsComponent_ng_container_0_app_sidebar_nav_title_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "app-sidebar-nav-title", 8);
    ɵngcc0.ɵɵpipe(1, "appSidebarNavItemClass");
} if (rf & 2) {
    const item_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("item", item_r1)("ngClass", ɵngcc0.ɵɵpipeBind1(1, 3, item_r1))("appHtmlAttr", item_r1.attributes);
} }
function AppSidebarNavItemsComponent_ng_container_0_app_sidebar_nav_label_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "app-sidebar-nav-label", 9);
    ɵngcc0.ɵɵpipe(1, "appSidebarNavItemClass");
} if (rf & 2) {
    const item_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("item", item_r1)("ngClass", ɵngcc0.ɵɵpipeBind1(1, 2, item_r1));
} }
function AppSidebarNavItemsComponent_ng_container_0_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function AppSidebarNavItemsComponent_ng_container_0_app_sidebar_nav_link_7_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "app-sidebar-nav-link", 10);
    ɵngcc0.ɵɵlistener("linkClick", function AppSidebarNavItemsComponent_ng_container_0_app_sidebar_nav_link_7_Template_app_sidebar_nav_link_linkClick_0_listener() { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r12 = ɵngcc0.ɵɵnextContext(2); return ctx_r12.hideMobile(); });
    ɵngcc0.ɵɵpipe(1, "appSidebarNavItemClass");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("item", item_r1)("ngClass", ɵngcc0.ɵɵpipeBind1(1, 2, item_r1));
} }
function AppSidebarNavItemsComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementContainerStart(1, 1);
    ɵngcc0.ɵɵtemplate(2, AppSidebarNavItemsComponent_ng_container_0_app_sidebar_nav_dropdown_2_Template, 2, 6, "app-sidebar-nav-dropdown", 2);
    ɵngcc0.ɵɵtemplate(3, AppSidebarNavItemsComponent_ng_container_0_app_sidebar_nav_divider_3_Template, 2, 5, "app-sidebar-nav-divider", 3);
    ɵngcc0.ɵɵtemplate(4, AppSidebarNavItemsComponent_ng_container_0_app_sidebar_nav_title_4_Template, 2, 5, "app-sidebar-nav-title", 3);
    ɵngcc0.ɵɵtemplate(5, AppSidebarNavItemsComponent_ng_container_0_app_sidebar_nav_label_5_Template, 2, 4, "app-sidebar-nav-label", 4);
    ɵngcc0.ɵɵtemplate(6, AppSidebarNavItemsComponent_ng_container_0_ng_container_6_Template, 1, 0, "ng-container", 5);
    ɵngcc0.ɵɵtemplate(7, AppSidebarNavItemsComponent_ng_container_0_app_sidebar_nav_link_7_Template, 2, 4, "app-sidebar-nav-link", 6);
    ɵngcc0.ɵɵelementContainerEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r1 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitch", ctx_r0.helper.itemType(item_r1));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "dropdown");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "divider");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "title");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "label");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "empty");
} }
function AppSidebarNavLinkContentComponent_ng_container_0_i_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 2);
    ɵngcc0.ɵɵpipe(1, "appSidebarNavIcon");
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpipeBind1(1, 1, ctx_r1.item));
} }
function AppSidebarNavLinkContentComponent_ng_container_0_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 2);
    ɵngcc0.ɵɵpipe(1, "appSidebarNavBadge");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpipeBind1(1, 2, ctx_r2.item));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.item.badge.text);
} }
function AppSidebarNavLinkContentComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, AppSidebarNavLinkContentComponent_ng_container_0_i_1_Template, 2, 3, "i", 1);
    ɵngcc0.ɵɵelementContainerStart(2);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementContainerEnd();
    ɵngcc0.ɵɵtemplate(4, AppSidebarNavLinkContentComponent_ng_container_0_span_4_Template, 3, 4, "span", 1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.helper.hasIcon(ctx_r0.item));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.item.name);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.helper.hasBadge(ctx_r0.item));
} }
function AppSidebarNavLinkComponent_a_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 4);
    ɵngcc0.ɵɵpipe(1, "appSidebarNavLink");
    ɵngcc0.ɵɵelement(2, "app-sidebar-nav-link-content", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpipeBind1(1, 3, ctx_r0.item))("appHtmlAttr", ctx_r0.item.attributes);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("item", ctx_r0.item);
} }
function AppSidebarNavLinkComponent_a_2_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 6);
    ɵngcc0.ɵɵlistener("click", function AppSidebarNavLinkComponent_a_2_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.linkClicked(); });
    ɵngcc0.ɵɵpipe(1, "appSidebarNavLink");
    ɵngcc0.ɵɵelement(2, "app-sidebar-nav-link-content", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpipeBind1(1, 4, ctx_r1.item))("href", ctx_r1.href, ɵngcc0.ɵɵsanitizeUrl)("appHtmlAttr", ctx_r1.item.attributes);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("item", ctx_r1.item);
} }
function AppSidebarNavLinkComponent_a_3_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 7);
    ɵngcc0.ɵɵlistener("click", function AppSidebarNavLinkComponent_a_3_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.linkClicked(); });
    ɵngcc0.ɵɵpipe(1, "appSidebarNavLink");
    ɵngcc0.ɵɵelement(2, "app-sidebar-nav-link-content", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("active", ctx_r2.linkActive);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpipeBind1(1, 14, ctx_r2.item))("appHtmlAttr", ctx_r2.item.attributes)("target", ctx_r2.item.attributes == null ? null : ctx_r2.item.attributes.target)("queryParams", ctx_r2.item.linkProps == null ? null : ctx_r2.item.linkProps.queryParams)("fragment", ctx_r2.item.linkProps == null ? null : ctx_r2.item.linkProps.fragment)("queryParamsHandling", ctx_r2.item.linkProps == null ? null : ctx_r2.item.linkProps.queryParamsHandling)("preserveFragment", ctx_r2.item.linkProps == null ? null : ctx_r2.item.linkProps.preserveFragment)("skipLocationChange", ctx_r2.item.linkProps == null ? null : ctx_r2.item.linkProps.skipLocationChange)("replaceUrl", ctx_r2.item.linkProps == null ? null : ctx_r2.item.linkProps.replaceUrl)("state", ctx_r2.item.linkProps == null ? null : ctx_r2.item.linkProps.state)("routerLink", ctx_r2.item.url);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("item", ctx_r2.item);
} }
function AppSidebarNavLabelComponent_i_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 2);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ctx_r0.getLabelIconClass());
} }
function AppSidebarNavLabelComponent_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 2);
    ɵngcc0.ɵɵpipe(1, "appSidebarNavBadge");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpipeBind1(1, 2, ctx_r1.item));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.item.badge.text);
} }
function AppBreadcrumbComponent_ng_template_1_li_0_a_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 5);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const breadcrumb_r1 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵproperty("routerLink", breadcrumb_r1.url);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(breadcrumb_r1.label.title);
} }
function AppBreadcrumbComponent_ng_template_1_li_0_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 5);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const breadcrumb_r1 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵproperty("routerLink", breadcrumb_r1.url);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(breadcrumb_r1.label.title);
} }
const _c1 = function (a0) { return { active: a0 }; };
function AppBreadcrumbComponent_ng_template_1_li_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 3);
    ɵngcc0.ɵɵtemplate(1, AppBreadcrumbComponent_ng_template_1_li_0_a_1_Template, 2, 2, "a", 4);
    ɵngcc0.ɵɵtemplate(2, AppBreadcrumbComponent_ng_template_1_li_0_span_2_Template, 2, 2, "span", 4);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const last_r2 = ɵngcc0.ɵɵnextContext().last;
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(3, _c1, last_r2));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !last_r2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", last_r2);
} }
function AppBreadcrumbComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, AppBreadcrumbComponent_ng_template_1_li_0_Template, 3, 5, "li", 2);
} if (rf & 2) {
    const breadcrumb_r1 = ctx.$implicit;
    const last_r2 = ctx.last;
    ɵngcc0.ɵɵproperty("ngIf", breadcrumb_r1.label.title && (breadcrumb_r1.url.slice(-1) == "/" || last_r2));
} }
function LandingComponent_ngx_footer_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "ngx-footer");
} }
function HeaderComponent_nav_6_ul_1_li_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 13);
    ɵngcc0.ɵɵelementStart(1, "a", 14);
    ɵngcc0.ɵɵelementStart(2, "button", 15);
    ɵngcc0.ɵɵtext(3, "Entrar");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("href", ctx_r4.loginURL, ɵngcc0.ɵɵsanitizeUrl);
} }
function HeaderComponent_nav_6_ul_1_li_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 16);
    ɵngcc0.ɵɵelementStart(1, "a", 14);
    ɵngcc0.ɵɵelementStart(2, "button", 17);
    ɵngcc0.ɵɵtext(3, "Cadastrar");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("href", ctx_r5.signupURL, ɵngcc0.ɵɵsanitizeUrl);
} }
function HeaderComponent_nav_6_ul_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ul", 10);
    ɵngcc0.ɵɵtemplate(1, HeaderComponent_nav_6_ul_1_li_1_Template, 4, 1, "li", 11);
    ɵngcc0.ɵɵtemplate(2, HeaderComponent_nav_6_ul_1_li_2_Template, 4, 1, "li", 12);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.showLoginButton);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.showSignupButton);
} }
function HeaderComponent_nav_6_ul_2_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 24);
    ɵngcc0.ɵɵelementStart(1, "app-toogle-information", 25);
    ɵngcc0.ɵɵlistener("onLogout", function HeaderComponent_nav_6_ul_2_div_7_Template_app_toogle_information_onLogout_1_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(3); return ctx_r7.onLogout.emit(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("isLoggedIn", ctx_r6.isLoggedIn)("defaultRoute", ctx_r6.defaultRoute)("username", ctx_r6.username)("signupURL", ctx_r6.signupURL)("loginURL", ctx_r6.loginURL)("isButtonEnable", ctx_r6.isButtonEnable);
} }
function HeaderComponent_nav_6_ul_2_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ul", 18);
    ɵngcc0.ɵɵlistener("click", function HeaderComponent_nav_6_ul_2_Template_ul_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r9 = ɵngcc0.ɵɵnextContext(2); return ctx_r9.showToggle(); });
    ɵngcc0.ɵɵelementStart(1, "li", 19);
    ɵngcc0.ɵɵelementStart(2, "div", 20);
    ɵngcc0.ɵɵelement(3, "img", 21);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "li", 22);
    ɵngcc0.ɵɵelementStart(5, "p");
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(7, HeaderComponent_nav_6_ul_2_div_7_Template, 2, 6, "div", 23);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵtextInterpolate1("Ol\u00E1 ", ctx_r3.username, "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.showToogle);
} }
function HeaderComponent_nav_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "nav", 7);
    ɵngcc0.ɵɵtemplate(1, HeaderComponent_nav_6_ul_1_Template, 3, 2, "ul", 8);
    ɵngcc0.ɵɵtemplate(2, HeaderComponent_nav_6_ul_2_Template, 8, 2, "ul", 9);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.isLoggedIn);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.isLoggedIn);
} }
function HeaderComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 26);
    ɵngcc0.ɵɵelementStart(1, "app-toogle-information", 25);
    ɵngcc0.ɵɵlistener("onLogout", function HeaderComponent_div_7_Template_app_toogle_information_onLogout_1_listener() { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.onLogout.emit(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("isLoggedIn", ctx_r1.isLoggedIn)("defaultRoute", ctx_r1.defaultRoute)("username", ctx_r1.username)("signupURL", ctx_r1.signupURL)("loginURL", ctx_r1.loginURL)("isButtonEnable", ctx_r1.isButtonEnable);
} }
function ValidatorComponent_div_0_ul_1_p_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const error_r4 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", error_r4 == null ? null : error_r4.message, "");
} }
function ValidatorComponent_div_0_ul_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ul");
    ɵngcc0.ɵɵelementStart(1, "li");
    ɵngcc0.ɵɵtemplate(2, ValidatorComponent_div_0_ul_1_p_2_Template, 2, 1, "p", 2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const errorItem_r2 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", errorItem_r2 == null ? null : errorItem_r2.errors);
} }
function ValidatorComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵtemplate(1, ValidatorComponent_div_0_ul_1_Template, 3, 1, "ul", 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("alert alert-", ctx_r0.class, "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.formErrors);
} }
function InputCheckComponent_small_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "small", 1);
    ɵngcc0.ɵɵtext(1, "\u2713");
    ɵngcc0.ɵɵelementEnd();
} }
const navItems = [
    {
        name: 'Dashboard',
        url: '/dashboard',
        icon: 'icon-speedometer',
        badge: {
            variant: 'info',
            text: 'NEW'
        }
    },
    {
        name: 'Disabled',
        url: '/dashboard',
        icon: 'icon-ban',
        attributes: { disabled: true },
    },
    {
        name: 'Download CoreUI',
        url: 'http://coreui.io/angular/',
        icon: 'icon-cloud-download',
        class: 'mt-auto',
        variant: 'success',
        attributes: { target: '_blank', rel: 'noopener' }
    },
    {
        name: 'Try CoreUI PRO',
        url: 'http://coreui.io/pro/angular/',
        icon: 'icon-layers',
        variant: 'danger',
        attributes: { target: '_blank', rel: 'noopener' }
    }
];

class AdminComponent {
    constructor() {
        this.projectName = 'Dharma Common';
        this.nameUser = 'Usuário de Sistema';
        this.nameUserPerfil = 'Administrador';
        this.urlImageUser = './assets/dotz-images/icon_user_profile.png';
        this.sidebarItems = navItems;
        this.fixed = true;
        this.navbarBrandFull = { src: 'assets/dotz-images/logo-dotz-full.png', alt: 'Dotz Logo', class: 'img-fluid' };
        this.navbarBrandMinimized = { src: 'assets/dotz-images/logo-dotz.png', alt: 'Dotz Logo', class: 'img-fluid' };
        this.navbarBrandText = { icon: 'Dotz', text: 'Dotz' };
        this.navbarBrandRouterLink = '';
        this.sidebarToggler = 'lg';
        this.logout = new EventEmitter();
        this.minimized = false;
    }
    toggleMinimize(e) {
        this.minimized = e;
    }
}
AdminComponent.ɵfac = function AdminComponent_Factory(t) { return new (t || AdminComponent)(); };
AdminComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AdminComponent, selectors: [["admin"]], inputs: { projectName: "projectName", nameUser: "nameUser", nameUserPerfil: "nameUserPerfil", urlImageUser: "urlImageUser", sidebarItems: "sidebarItems", fixed: "fixed", navbarBrandFull: "navbarBrandFull", navbarBrandMinimized: "navbarBrandMinimized", navbarBrandText: "navbarBrandText", navbarBrandRouterLink: "navbarBrandRouterLink", sidebarToggler: "sidebarToggler", minimized: "minimized", navbarBrand: "navbarBrand", mobileSidebarToggler: "mobileSidebarToggler" }, outputs: { logout: "logout" }, decls: 35, vars: 13, consts: [[3, "navbarBrandRouterLink", "fixed", "navbarBrandFull", "navbarBrandMinimized", "sidebarToggler"], [1, "nav", "navbar-nav"], [1, "nav-item"], [1, "nav-link"], [1, "nav", "navbar-nav", "ml-auto"], [1, "nav-item", "d-md-down-none"], [1, "username"], ["dropdown", "", "placement", "bottom right", 1, "nav-item", "dropdown"], ["data-toggle", "dropdown", "href", "#", "role", "button", "aria-haspopup", "true", "aria-expanded", "false", "dropdownToggle", "", 1, "nav-link", 3, "click"], ["alt", "", 1, "img-avatar", 3, "src"], ["class", "dropdown-menu dropdown-menu-right", "aria-labelledby", "simple-dropdown", 4, "dropdownMenu"], [1, "app-body"], [3, "fixed", "display", "minimized", "minimizedChange"], ["sidebar", ""], [3, "navItems", "perfectScrollbar", "disabled"], [1, "main"], [1, "breadcrumb-menu", "d-md-down-none"], ["role", "group", "aria-label", "Button group with nested dropdown", 1, "btn-group"], [1, "container-fluid"], ["href", "http://www.dotz.com.br"], [1, "ml-auto"], ["aria-labelledby", "simple-dropdown", 1, "dropdown-menu", "dropdown-menu-right"], [1, "dropdown-header", "text-center"], [1, "dropdown-item", "dropdown", 2, "cursor", "pointer", 3, "click"], [1, "fa", "fa-sign-out"]], template: function AdminComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "app-header-admin", 0);
        ɵngcc0.ɵɵelementStart(1, "ul", 1);
        ɵngcc0.ɵɵelementStart(2, "li", 2);
        ɵngcc0.ɵɵelementStart(3, "a", 3);
        ɵngcc0.ɵɵelementStart(4, "h4");
        ɵngcc0.ɵɵtext(5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "ul", 4);
        ɵngcc0.ɵɵelementStart(7, "li", 5);
        ɵngcc0.ɵɵelementStart(8, "label", 6);
        ɵngcc0.ɵɵelementStart(9, "span");
        ɵngcc0.ɵɵtext(10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "li", 7);
        ɵngcc0.ɵɵelementStart(12, "a", 8);
        ɵngcc0.ɵɵlistener("click", function AdminComponent_Template_a_click_12_listener() { return false; });
        ɵngcc0.ɵɵelement(13, "img", 9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(14, AdminComponent_div_14_Template, 7, 1, "div", 10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(15, "div", 11);
        ɵngcc0.ɵɵelementStart(16, "app-sidebar", 12, 13);
        ɵngcc0.ɵɵlistener("minimizedChange", function AdminComponent_Template_app_sidebar_minimizedChange_16_listener($event) { return ctx.toggleMinimize($event); });
        ɵngcc0.ɵɵelement(18, "app-sidebar-nav", 14);
        ɵngcc0.ɵɵelement(19, "app-sidebar-minimizer");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(20, "main", 15);
        ɵngcc0.ɵɵelementStart(21, "cui-breadcrumb");
        ɵngcc0.ɵɵelementStart(22, "li", 16);
        ɵngcc0.ɵɵelement(23, "div", 17);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(24, "div", 18);
        ɵngcc0.ɵɵelement(25, "router-outlet");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(26, "app-footer-admin");
        ɵngcc0.ɵɵelementStart(27, "span");
        ɵngcc0.ɵɵelementStart(28, "a", 19);
        ɵngcc0.ɵɵtext(29, "Dotz");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(30, " \u00A9 2020.");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(31, "span", 20);
        ɵngcc0.ɵɵtext(32, "Powered by ");
        ɵngcc0.ɵɵelementStart(33, "a", 19);
        ɵngcc0.ɵɵtext(34, " Dotz");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(17);
        ɵngcc0.ɵɵproperty("navbarBrandRouterLink", ctx.navbarBrandRouterLink)("fixed", ctx.fixed)("navbarBrandFull", ctx.navbarBrandFull)("navbarBrandMinimized", ctx.navbarBrandMinimized)("sidebarToggler", ctx.sidebarToggler);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate(ctx.projectName);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate(ctx.nameUser);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("src", ctx.urlImageUser, ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("fixed", true)("display", "lg")("minimized", ctx.minimized);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("navItems", ctx.sidebarItems)("disabled", _r1.minimized);
    } }, directives: function () { return [AppHeaderAdminComponent, ɵngcc1.BsDropdownDirective, ɵngcc1.BsDropdownToggleDirective, ɵngcc1.BsDropdownMenuDirective, AppSidebarComponent, AppSidebarNavComponent, ɵngcc2.PerfectScrollbarDirective, AppSidebarMinimizerComponent, AppBreadcrumbComponent, ɵngcc3.RouterOutlet, AppFooterComponent]; }, styles: [".nav-link[_ngcontent-%COMP%]   h4[_ngcontent-%COMP%]{margin-top:15px;font-weight:700}.username[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{margin-top:15px;font-family:30px}"] });
AdminComponent.propDecorators = {
    projectName: [{ type: Input }],
    nameUser: [{ type: Input }],
    nameUserPerfil: [{ type: Input }],
    urlImageUser: [{ type: Input }],
    sidebarItems: [{ type: Input }],
    fixed: [{ type: Input }],
    navbarBrand: [{ type: Input }],
    navbarBrandFull: [{ type: Input }],
    navbarBrandMinimized: [{ type: Input }],
    navbarBrandText: [{ type: Input }],
    navbarBrandRouterLink: [{ type: Input }],
    sidebarToggler: [{ type: Input }],
    mobileSidebarToggler: [{ type: Input }],
    logout: [{ type: Output }],
    minimized: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AdminComponent, [{
        type: Component,
        args: [{
                selector: 'admin',
                template: "<app-header-admin [navbarBrandRouterLink]=\"navbarBrandRouterLink\" [fixed]=\"fixed\" [navbarBrandFull]=\"navbarBrandFull\"\n  [navbarBrandMinimized]=\"navbarBrandMinimized\" [sidebarToggler]=\"sidebarToggler\">\n  <ul class=\"nav navbar-nav\">\n    <li class=\"nav-item\">      \n        <a class=\"nav-link\"><h4>{{projectName}}</h4></a>\n    </li>\n  </ul>\n  <ul class=\"nav navbar-nav ml-auto\">\n    <li class=\"nav-item d-md-down-none\">\n      <label class=\"username\"><span>{{nameUser}}</span></label>\n    </li>\n    <li class=\"nav-item dropdown\" dropdown placement=\"bottom right\">\n      <a class=\"nav-link\" data-toggle=\"dropdown\" href=\"#\" role=\"button\" aria-haspopup=\"true\" aria-expanded=\"false\"\n        dropdownToggle (click)=\"false\">\n        <img [src]=\"urlImageUser\" class=\"img-avatar\" alt=\"\" />\n      </a>\n      <div class=\"dropdown-menu dropdown-menu-right\" *dropdownMenu aria-labelledby=\"simple-dropdown\">\n        <div class=\"dropdown-header text-center\"><strong>{{nameUserPerfil}}</strong></div>\n        <a class=\"dropdown-item dropdown\" style=\"cursor: pointer;\" (click)=\"logout.emit()\"><i class=\"fa fa-sign-out\"></i> Logout</a>\n      </div>\n    </li>\n  </ul>\n</app-header-admin>\n<div class=\"app-body\">\n  <app-sidebar [fixed]=\"true\" [display]=\"'lg'\" [minimized]=\"minimized\" #sidebar\n    (minimizedChange)=\"toggleMinimize($event)\">\n    <app-sidebar-nav [navItems]=\"sidebarItems\" [perfectScrollbar] [disabled]=\"sidebar.minimized\"></app-sidebar-nav>\n    <app-sidebar-minimizer></app-sidebar-minimizer>\n  </app-sidebar>\n  <!-- Main content -->\n  <main class=\"main\">\n    <cui-breadcrumb>\n      <!-- Breadcrumb Menu-->\n      <li class=\"breadcrumb-menu d-md-down-none\">\n        <div class=\"btn-group\" role=\"group\" aria-label=\"Button group with nested dropdown\">\n\n        </div>\n      </li>\n    </cui-breadcrumb>\n    <div class=\"container-fluid\">\n      <router-outlet></router-outlet>\n    </div>\n  </main>\n</div>\n<app-footer-admin>\n  <span><a href=\"http://www.dotz.com.br\">Dotz</a> &copy; 2020.</span>\n  <span class=\"ml-auto\">Powered by <a href=\"http://www.dotz.com.br\"> Dotz</a></span>\n</app-footer-admin>",
                styles: [".nav-link h4{margin-top:15px;font-weight:700}.username span{margin-top:15px;font-family:30px}"]
            }]
    }], function () { return []; }, { projectName: [{
            type: Input
        }], nameUser: [{
            type: Input
        }], nameUserPerfil: [{
            type: Input
        }], urlImageUser: [{
            type: Input
        }], sidebarItems: [{
            type: Input
        }], fixed: [{
            type: Input
        }], navbarBrandFull: [{
            type: Input
        }], navbarBrandMinimized: [{
            type: Input
        }], navbarBrandText: [{
            type: Input
        }], navbarBrandRouterLink: [{
            type: Input
        }], sidebarToggler: [{
            type: Input
        }], logout: [{
            type: Output
        }], minimized: [{
            type: Input
        }], navbarBrand: [{
            type: Input
        }], mobileSidebarToggler: [{
            type: Input
        }] }); })();

class AppHeaderAdminComponent {
    constructor(document, renderer) {
        this.document = document;
        this.renderer = renderer;
        this.onCloseOpen = new EventEmitter();
        this.navbarBrandText = { icon: 'Dotz', text: 'Dotz' };
        this.navbarBrandRouterLink = '';
        this.fixedClass = 'header-fixed';
        this._header = true;
        this._navbar = true;
        this.breakpoints = ['xl', 'lg', 'md', 'sm', 'xs'];
        this.sidebarTogglerClass = 'd-none d-md-block';
        this.sidebarTogglerMobileClass = 'd-lg-none';
    }
    ngOnInit() {
        this.isFixed(this.fixed);
        this.navbarBrandImg = Boolean(this.navbarBrand || this.navbarBrandFull || this.navbarBrandMinimized);
        this.navbarBrandRouterLink = this.navbarBrandRouterLink;
        this.sidebarTogglerClass = this.setToggerBreakpointClass(this.sidebarToggler);
        this.sidebarTogglerMobileClass = this.setToggerMobileBreakpointClass(this.sidebarToggler);
    }
    ngOnDestroy() {
        this.renderer.removeClass(this.document.body, this.fixedClass);
    }
    isFixed(fixed = this.fixed) {
        if (fixed) {
            this.renderer.addClass(this.document.body, this.fixedClass);
        }
    }
    setToggerBreakpointClass(breakpoint = 'md') {
        let togglerClass = 'd-none d-md-block';
        if (this.breakpoints.includes(breakpoint)) {
            const breakpointIndex = this.breakpoints.indexOf(breakpoint);
            togglerClass = `d-none d-${breakpoint}-block`;
        }
        return togglerClass;
    }
    setToggerMobileBreakpointClass(breakpoint = 'lg') {
        let togglerClass = 'd-lg-none';
        if (this.breakpoints.includes(breakpoint)) {
            togglerClass = `d-${breakpoint}-none`;
        }
        return togglerClass;
    }
    openClose() {
        this.onCloseOpen.emit();
    }
}
AppHeaderAdminComponent.ɵfac = function AppHeaderAdminComponent_Factory(t) { return new (t || AppHeaderAdminComponent)(ɵngcc0.ɵɵdirectiveInject(DOCUMENT), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
AppHeaderAdminComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AppHeaderAdminComponent, selectors: [["app-header-admin"]], hostVars: 4, hostBindings: function AppHeaderAdminComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("app-header", ctx._header)("navbar", ctx._navbar);
    } }, inputs: { navbarBrandText: "navbarBrandText", navbarBrandRouterLink: "navbarBrandRouterLink", fixed: "fixed", navbarBrand: "navbarBrand", navbarBrandFull: "navbarBrandFull", navbarBrandMinimized: "navbarBrandMinimized", sidebarToggler: "sidebarToggler", mobileSidebarToggler: "mobileSidebarToggler" }, outputs: { onCloseOpen: "onCloseOpen" }, ngContentSelectors: _c0, decls: 6, vars: 5, consts: [[3, "ngIf"], [1, "navbar-brand", 3, "routerLink"], ["type", "button", "appSidebarToggler", ""], [1, "navbar-toggler-icon"], [3, "appHtmlAttr", "ngClass", 4, "ngIf"], [3, "appHtmlAttr", "ngClass"], [1, "navbar-brand-full", 3, "innerHTML"], [1, "navbar-brand-minimized", 3, "innerHTML"], ["type", "button", 3, "appSidebarToggler", "click"]], template: function AppHeaderAdminComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, AppHeaderAdminComponent_ng_template_0_Template, 2, 3, "ng-template", 0);
        ɵngcc0.ɵɵelementStart(1, "a", 1);
        ɵngcc0.ɵɵtemplate(2, AppHeaderAdminComponent_ng_template_2_Template, 3, 3, "ng-template", 0);
        ɵngcc0.ɵɵtemplate(3, AppHeaderAdminComponent_ng_template_3_Template, 2, 2, "ng-template", 0);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(4, AppHeaderAdminComponent_ng_template_4_Template, 2, 4, "ng-template", 0);
        ɵngcc0.ɵɵprojection(5);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.mobileSidebarToggler != false);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("routerLink", ctx.navbarBrandRouterLink);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.navbarBrandImg);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.navbarBrandImg);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.sidebarToggler != false);
    } }, directives: function () { return [ɵngcc4.NgIf, ɵngcc3.RouterLinkWithHref, SidebarToggleDirective, HtmlAttributesDirective, ɵngcc4.NgClass]; }, styles: [".navbar-brand-full{max-width:65px}"] });
AppHeaderAdminComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] },
    { type: Renderer2 }
];
AppHeaderAdminComponent.propDecorators = {
    onCloseOpen: [{ type: Output }],
    fixed: [{ type: Input }],
    navbarBrand: [{ type: Input }],
    navbarBrandFull: [{ type: Input }],
    navbarBrandMinimized: [{ type: Input }],
    navbarBrandText: [{ type: Input }],
    navbarBrandRouterLink: [{ type: Input }],
    sidebarToggler: [{ type: Input }],
    mobileSidebarToggler: [{ type: Input }],
    _header: [{ type: HostBinding, args: ['class.app-header',] }],
    _navbar: [{ type: HostBinding, args: ['class.navbar',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AppHeaderAdminComponent, [{
        type: Component,
        args: [{
                selector: 'app-header-admin',
                template: "<ng-template [ngIf]=\"mobileSidebarToggler != false\">\n  <button class=\"navbar-toggler {{sidebarTogglerMobileClass}}\" type=\"button\" appSidebarToggler>\n    <span class=\"navbar-toggler-icon\"></span>\n  </button>\n</ng-template>\n<a class=\"navbar-brand\" [routerLink]=\"navbarBrandRouterLink\">\n  <ng-template [ngIf]=\"navbarBrandImg\">\n    <img *ngIf=\"navbarBrand\"\n         [appHtmlAttr]=\"navbarBrand\"\n         [ngClass]=\"'navbar-brand'\">\n    <img *ngIf=\"navbarBrandFull\"\n         [appHtmlAttr]=\"navbarBrandFull\"\n         [ngClass]=\"'navbar-brand-full'\">\n    <img *ngIf=\"navbarBrandMinimized\"\n         [appHtmlAttr]=\"navbarBrandMinimized\"\n         [ngClass]=\"'navbar-brand-minimized'\">\n  </ng-template>\n  <ng-template [ngIf]=\"!navbarBrandImg\">\n    <div class=\"navbar-brand-full\" [innerHTML]=\"navbarBrandText.text\"></div>\n    <div class=\"navbar-brand-minimized\" [innerHTML]=\"navbarBrandText.icon\"></div>\n  </ng-template>\n</a>\n<ng-template [ngIf]=\"sidebarToggler != false\">\n  <button class=\"navbar-toggler {{sidebarTogglerClass}}\" type=\"button\" (click)=\"openClose()\" [appSidebarToggler]=\"sidebarToggler\">\n    <span class=\"navbar-toggler-icon\"></span>\n  </button>\n</ng-template>\n\n<ng-content></ng-content>\n",
                styles: ["::ng-deep .navbar-brand-full{max-width:65px}"]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }, { type: ɵngcc0.Renderer2 }]; }, { onCloseOpen: [{
            type: Output
        }], navbarBrandText: [{
            type: Input
        }], navbarBrandRouterLink: [{
            type: Input
        }], _header: [{
            type: HostBinding,
            args: ['class.app-header']
        }], _navbar: [{
            type: HostBinding,
            args: ['class.navbar']
        }], fixed: [{
            type: Input
        }], navbarBrand: [{
            type: Input
        }], navbarBrandFull: [{
            type: Input
        }], navbarBrandMinimized: [{
            type: Input
        }], sidebarToggler: [{
            type: Input
        }], mobileSidebarToggler: [{
            type: Input
        }] }); })();

/* tslint:disable */
/**
 * Service com funções comuns para serem utilizadas no projeto inteiro.
 */
class CommonFunctionsService {
    constructor() {
    }
    /**
     * A função recebe um email (tipo String)
     * @param {String} email
     * @returns {Boolean} retorna um boolean informando se o email é valido ou não.
     */
    isEmail(email) {
        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
            // valid email
            return (true);
        }
        // invalid email
        return (false);
    }
    /**
     * A função recebe um objeto
     * @param {Object} obj
     * @returns {Boolean} retorna um boolean informando se o objeto é vazio ou não.
     */
    isEmptyObject(obj) {
        for (const prop in obj) {
            if (obj.hasOwnProperty(prop)) {
                return false;
            }
        }
        return true;
    }
    /**
     * @returns A função retorna o horário atual na forma de string.
     * @example const time = this.commonFunctions.getTime();
     */
    getTime() {
        const currentdate = new Date();
        let hours = String(currentdate.getHours());
        let minutes = String(currentdate.getMinutes());
        if (hours.length < 2)
            hours = '0' + hours;
        if (minutes.length < 2)
            minutes = '0' + minutes;
        const time = hours + ':'
            + minutes;
        return time;
    }
    /**
     * @returns A função retorna a data atual.
     * @example const date = this.commonFunctions.getDate();
     * @returns Irá retornar a data atual na forma de string.
     */
    getDate() {
        const d = new Date();
        let month = String(d.getMonth() + 1);
        let day = String(d.getDate());
        const year = String(d.getFullYear());
        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;
        return `${month}/${day}/${year}`;
    }
    removeDuplicateArray(array) {
        return array.filter((v, i) => array.indexOf(v) === i);
    }
    /**
     * Função para checar se uma data é do dia atual ou se é uma data de dias anteriores.
     * @returns A função retorna uma string informando caso seja do dia atual ou mensagem antiga.
     * @example
     * this.checkDate("02/03/18"); #dataAntiga
     * @example
     * this.checkDate("03/03/18"); #hoje
     */
    checkDate(date) {
        // checar se a mensagem eh de hoje ou se eh antiga
        const dateFormat = new Date(date);
        const currentDate = new Date();
        dateFormat.setHours(0, 0, 0, 0);
        currentDate.setHours(0, 0, 0, 0);
        if (dateFormat.getTime() === currentDate.getTime()) {
            return 'Hoje';
        }
        else {
            return 'data antiga';
        }
    }
    /**
     *
     * @param originalArray
     * @param prop
     */
    removeDuplicateObject(originalArray, prop) {
        const newArray = [];
        const lookupObject = {};
        for (const i in originalArray) {
            lookupObject[originalArray[i][prop]] = originalArray[i];
        }
        for (const i in lookupObject) {
            newArray.push(lookupObject[i]);
        }
        return newArray;
    }
    /**
     * Funcão que recebe um array de objetos, o nome da propriedade que não pode ter duplicidade e uma excessão (string)
     * @example
     * const newArray = this.removeDuplicateObjectExclude([{foods: "macarrão", "Lasanha", "lasanha"}], "foods", "macarrão"); #[{ foods: "macarrão"}]
     * @param originalArray
     * @param prop
     * @param exclude
     */
    removeDuplicateObjectExclude(originalArray, prop, exclude) {
        const newArray = [];
        const lookupObject = {};
        for (const i in originalArray) {
            lookupObject[originalArray[i][prop]] = originalArray[i];
        }
        for (const i in lookupObject) {
            newArray.push(lookupObject[i]);
        }
        originalArray.map(element => {
            if (element[prop] === exclude) {
                newArray.push(element);
            }
        });
        return newArray;
    }
    /**
     * Diferença de dias entre duas datas
     * @param date1
     * @param date2
     */
    diffDays(date1, date2) {
        const diff = Math.abs(date1.getTime() - date2.getTime());
        const diffDays = Math.ceil(diff / (1000 * 3600 * 24));
        return diffDays;
    }
    /**
     * Número de ocorrências de um item no array
     * @param Array1
     * @param findItem
     * @param prop
     */
    numberOccurenciesArray(Array1, findItem, prop) {
        let numberOcurrences = 0;
        const itens = [];
        Array1.map((item, index) => {
            if (item[prop] === findItem) {
                item.index = index;
                itens.push(item);
                numberOcurrences++;
            }
        });
        return {
            numberOcurrences: numberOcurrences,
            itens: itens
        };
    }
    /**
     * Gera um token aleatório
     * @returns Exemplo: 9312039203912
     */
    generateToken() {
        return Math.floor(100000 + Math.random() * 900000);
    }
    /**
     *
     * @param arr
     * @param prefix
     */
    sumObject(arr, prefix) {
        return arr.reduce((sum, x) => parseInt(sum[prefix]) + parseInt(x[prefix]));
    }
    /**
     * Retorna se data é um array ou não
     * @param data
     * @returns Irá retornar um boolean
     * @example this.commonFunctions.isArray(["1", "2"]); #true
     * @example this.commonFunctions.isArray("Olá"); #false
     */
    isArray(data) {
        return (Object.prototype.toString.call(data) === '[object Array]');
    }
    /**
     * Função que retorna se a data é um form group
     * @param data
     * @returns Irá retornar um boolean
     */
    isFormGroup(data) {
        return (data && data.controls) ? true : false;
    }
    /**
     * Arredonda um número
     * @param number
     */
    roundNumber(number) {
        if (Number.isNaN(number)) {
            number = 0;
        }
        return number ? Math.round(number) : 0;
    }
    removeSpacesFromString(string) {
        return string.replace(/\s+/g, '');
    }
    /**
     * Adicionar zero a esquerda
     * @param number
     */
    addZero(number) {
        const length = 2;
        let my_string = '' + number;
        while (my_string.length < length) {
            my_string = '0' + my_string;
        }
        return my_string;
    }
    /**
     * Remove itens null no objeto
     * @returns irá retornar o próprio objecto modificado
     */
    removeNullObject(object) {
        if (this.isEmptyObject(object) || !object || !Object.keys(object)) {
            return {};
        }
        const keys = Object.keys(object);
        keys.map(key => {
            if (!object[key] || object[key] === 'null') {
                delete object[key];
            }
        });
        return object;
    }
    /**
     * Retorna o ultima elemento do array
     * @param array
     */
    getLastItemOfArray(array) {
        if (this.isArray(array)) {
            return array ? array[array.length - 1] : [];
        }
        else {
            return [];
        }
    }
    /**
     * Scroll to top
     */
    scrollToTop() {
        window.scrollTo(0, 0);
    }
    /**
     * Scroll to bottom
     */
    scrollToBottom() {
        window.scrollTo(0, document.body.scrollHeight);
    }
    /**
     * Scroll to element
     * @param elementId
     */
    scrollToElement(elementId) {
        try {
            document.getElementById(elementId).scrollIntoView();
        }
        catch (err) { }
    }
    /**
     * Função que verifica se o sistema está sendo utilizado em dispositivo mobile
     * @returns retorna um boolean (true se for mobile) (false se for desktop)
     */
    isMobile() {
        if (window.innerWidth > 991) {
            return false;
        }
        return true;
    }
    isPhone() {
        if (window.innerWidth > 500) {
            return false;
        }
        return true;
    }
    /**
     * Função para converter base 64 em imagem
     * @param base64 imagem em base64
     */
    convertBase64ToImage(base64) {
        const date = new Date().valueOf();
        let text = '';
        const possibleText = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        for (let i = 0; i < 5; i++) {
            text += possibleText.charAt(Math.floor(Math.random() * possibleText.length));
        }
        // Replace extension according to your media type
        const imageName = date + '.' + text + '.jpeg';
        // call method that creates a blob from dataUri
        const imageBlob = this.dataURItoBlob(base64);
        const imageFile = new File([imageBlob], imageName, { type: 'image/jpeg' });
        return imageFile;
    }
    dataURItoBlob(dataURI) {
        const byteString = atob(dataURI);
        const arrayBuffer = new ArrayBuffer(byteString.length);
        const int8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < byteString.length; i++) {
            int8Array[i] = byteString.charCodeAt(i);
        }
        const blob = new Blob([arrayBuffer], { type: 'image/jpeg' });
        return blob;
    }
    /**
     * Retorna um array com os 7 ultimos anos
     */
    getYears() {
        const year = new Date().getFullYear();
        const range = [];
        range.push(year);
        for (let i = 1; i < 7; i++) {
            range.push(year - i);
        }
        return range;
    }
    /**
     * Function to transform string to hash
     * @example
     * encode("Olá como vc está ?")
     * @returns 4f6ce120636f6d6f20766320657374e1203f
     * @param { String } string
     */
    encode(string = '') {
        let hash = '';
        const length = string.length;
        for (let i = 0; i < length; i++)
            hash += string.charCodeAt(i).toString(16);
        return hash;
    }
    deepIndexOf(arr, obj) {
        return arr.findIndex(cur => {
            return Object.keys(obj).every(function (key) {
                return obj[key] === cur[key];
            });
        });
    }
    /**
     * Function to remove null items on array
     * @param array
     */
    removeNullItemsInArray(array) {
        return array.filter(item => item);
    }
}
CommonFunctionsService.ɵfac = function CommonFunctionsService_Factory(t) { return new (t || CommonFunctionsService)(); };
CommonFunctionsService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: CommonFunctionsService, factory: CommonFunctionsService.ɵfac });
CommonFunctionsService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CommonFunctionsService, [{
        type: Injectable
    }], function () { return []; }, null); })();

const sidebarCssClasses = [
    'sidebar-show',
    'sidebar-sm-show',
    'sidebar-md-show',
    'sidebar-lg-show',
    'sidebar-xl-show'
];

const RemoveClasses = (NewClassNames) => {
    const MatchClasses = NewClassNames.map((Class) => document.body.classList.contains(Class));
    return MatchClasses.indexOf(true) !== -1;
};
const ɵ0$3 = RemoveClasses;
const ToggleClasses = (Toggle, ClassNames) => {
    const Level = ClassNames.indexOf(Toggle);
    const NewClassNames = ClassNames.slice(0, Level + 1);
    if (RemoveClasses(NewClassNames)) {
        NewClassNames.map((Class) => document.body.classList.remove(Class));
    }
    else {
        document.body.classList.add(Toggle);
    }
};
class ClassToggler {
    constructor(document, renderer) {
        this.document = document;
        this.renderer = renderer;
    }
    removeClasses(NewClassNames) {
        const MatchClasses = NewClassNames.map((Class) => this.document.body.classList.contains(Class));
        return MatchClasses.indexOf(true) !== -1;
    }
    toggleClasses(Toggle, ClassNames) {
        const Level = ClassNames.indexOf(Toggle);
        const NewClassNames = ClassNames.slice(0, Level + 1);
        if (this.removeClasses(NewClassNames)) {
            NewClassNames.map((Class) => this.renderer.removeClass(this.document.body, Class));
        }
        else {
            this.renderer.addClass(this.document.body, Toggle);
        }
    }
}
ClassToggler.ɵfac = function ClassToggler_Factory(t) { return new (t || ClassToggler)(ɵngcc0.ɵɵinject(DOCUMENT), ɵngcc0.ɵɵinject(ɵngcc0.Renderer2)); };
ClassToggler.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: ClassToggler, factory: ClassToggler.ɵfac });
ClassToggler.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] },
    { type: Renderer2 }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ClassToggler, [{
        type: Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }, { type: ɵngcc0.Renderer2 }]; }, null); })();

/**
* Allows the sidebar to be toggled via click.
*/
class SidebarToggleDirective {
    constructor(classToggler) {
        this.classToggler = classToggler;
    }
    ngOnInit() {
        this.bp = this.breakpoint;
    }
    toggleOpen($event) {
        $event.preventDefault();
        const cssClass = this.bp ? `sidebar-${this.bp}-show` : sidebarCssClasses[0];
        this.classToggler.toggleClasses(cssClass, sidebarCssClasses);
    }
}
SidebarToggleDirective.ɵfac = function SidebarToggleDirective_Factory(t) { return new (t || SidebarToggleDirective)(ɵngcc0.ɵɵdirectiveInject(ClassToggler)); };
SidebarToggleDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: SidebarToggleDirective, selectors: [["", "appSidebarToggler", ""]], hostBindings: function SidebarToggleDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function SidebarToggleDirective_click_HostBindingHandler($event) { return ctx.toggleOpen($event); });
    } }, inputs: { breakpoint: ["appSidebarToggler", "breakpoint"] }, features: [ɵngcc0.ɵɵProvidersFeature([ClassToggler])] });
SidebarToggleDirective.ctorParameters = () => [
    { type: ClassToggler }
];
SidebarToggleDirective.propDecorators = {
    breakpoint: [{ type: Input, args: ['appSidebarToggler',] }],
    toggleOpen: [{ type: HostListener, args: ['click', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SidebarToggleDirective, [{
        type: Directive,
        args: [{
                selector: '[appSidebarToggler]',
                providers: [ClassToggler]
            }]
    }], function () { return [{ type: ClassToggler }]; }, { toggleOpen: [{
            type: HostListener,
            args: ['click', ['$event']]
        }], breakpoint: [{
            type: Input,
            args: ['appSidebarToggler']
        }] }); })();
class SidebarMinimizeDirective {
    constructor(document, renderer) {
        this.document = document;
        this.renderer = renderer;
    }
    toggleOpen($event) {
        $event.preventDefault();
        const body = this.document.body;
        body.classList.contains('sidebar-minimized') ?
            this.renderer.removeClass(body, 'sidebar-minimized') :
            this.renderer.addClass(body, 'sidebar-minimized');
    }
}
SidebarMinimizeDirective.ɵfac = function SidebarMinimizeDirective_Factory(t) { return new (t || SidebarMinimizeDirective)(ɵngcc0.ɵɵdirectiveInject(DOCUMENT), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
SidebarMinimizeDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: SidebarMinimizeDirective, selectors: [["", "appSidebarMinimizer", ""]], hostBindings: function SidebarMinimizeDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function SidebarMinimizeDirective_click_HostBindingHandler($event) { return ctx.toggleOpen($event); });
    } } });
SidebarMinimizeDirective.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] },
    { type: Renderer2 }
];
SidebarMinimizeDirective.propDecorators = {
    toggleOpen: [{ type: HostListener, args: ['click', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SidebarMinimizeDirective, [{
        type: Directive,
        args: [{
                selector: '[appSidebarMinimizer]'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }, { type: ɵngcc0.Renderer2 }]; }, { toggleOpen: [{
            type: HostListener,
            args: ['click', ['$event']]
        }] }); })();
class MobileSidebarToggleDirective {
    constructor(document, renderer) {
        this.document = document;
        this.renderer = renderer;
    }
    toggleOpen($event) {
        $event.preventDefault();
        const body = this.document.body;
        body.classList.contains('sidebar-show') ?
            this.renderer.removeClass(body, 'sidebar-show') :
            this.renderer.addClass(body, 'sidebar-show');
    }
}
MobileSidebarToggleDirective.ɵfac = function MobileSidebarToggleDirective_Factory(t) { return new (t || MobileSidebarToggleDirective)(ɵngcc0.ɵɵdirectiveInject(DOCUMENT), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
MobileSidebarToggleDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MobileSidebarToggleDirective, selectors: [["", "appMobileSidebarToggler", ""]], hostBindings: function MobileSidebarToggleDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function MobileSidebarToggleDirective_click_HostBindingHandler($event) { return ctx.toggleOpen($event); });
    } } });
MobileSidebarToggleDirective.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] },
    { type: Renderer2 }
];
MobileSidebarToggleDirective.propDecorators = {
    toggleOpen: [{ type: HostListener, args: ['click', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MobileSidebarToggleDirective, [{
        type: Directive,
        args: [{
                selector: '[appMobileSidebarToggler]'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }, { type: ɵngcc0.Renderer2 }]; }, { toggleOpen: [{
            type: HostListener,
            args: ['click', ['$event']]
        }] }); })();
/**
* Allows the off-canvas sidebar to be closed via click.
*/
class SidebarOffCanvasCloseDirective {
    constructor(document, renderer) {
        this.document = document;
        this.renderer = renderer;
    }
    toggleOpen($event) {
        $event.preventDefault();
        const body = this.document.body;
        if (body.classList.contains('sidebar-off-canvas')) {
            body.classList.contains('sidebar-show') ?
                this.renderer.removeClass(body, 'sidebar-show') :
                this.renderer.addClass(body, 'sidebar-show');
        }
    }
}
SidebarOffCanvasCloseDirective.ɵfac = function SidebarOffCanvasCloseDirective_Factory(t) { return new (t || SidebarOffCanvasCloseDirective)(ɵngcc0.ɵɵdirectiveInject(DOCUMENT), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
SidebarOffCanvasCloseDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: SidebarOffCanvasCloseDirective, selectors: [["", "appSidebarClose", ""]], hostBindings: function SidebarOffCanvasCloseDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function SidebarOffCanvasCloseDirective_click_HostBindingHandler($event) { return ctx.toggleOpen($event); });
    } } });
SidebarOffCanvasCloseDirective.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] },
    { type: Renderer2 }
];
SidebarOffCanvasCloseDirective.propDecorators = {
    toggleOpen: [{ type: HostListener, args: ['click', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SidebarOffCanvasCloseDirective, [{
        type: Directive,
        args: [{
                selector: '[appSidebarClose]'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }, { type: ɵngcc0.Renderer2 }]; }, { toggleOpen: [{
            type: HostListener,
            args: ['click', ['$event']]
        }] }); })();
class BrandMinimizeDirective {
    constructor(document, renderer) {
        this.document = document;
        this.renderer = renderer;
    }
    toggleOpen($event) {
        $event.preventDefault();
        const body = this.document.body;
        body.classList.contains('brand-minimized') ?
            this.renderer.removeClass(body, 'brand-minimized') :
            this.renderer.addClass(body, 'brand-minimized');
    }
}
BrandMinimizeDirective.ɵfac = function BrandMinimizeDirective_Factory(t) { return new (t || BrandMinimizeDirective)(ɵngcc0.ɵɵdirectiveInject(DOCUMENT), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
BrandMinimizeDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: BrandMinimizeDirective, selectors: [["", "appBrandMinimizer", ""]], hostBindings: function BrandMinimizeDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function BrandMinimizeDirective_click_HostBindingHandler($event) { return ctx.toggleOpen($event); });
    } } });
BrandMinimizeDirective.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] },
    { type: Renderer2 }
];
BrandMinimizeDirective.propDecorators = {
    toggleOpen: [{ type: HostListener, args: ['click', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BrandMinimizeDirective, [{
        type: Directive,
        args: [{
                selector: '[appBrandMinimizer]'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }, { type: ɵngcc0.Renderer2 }]; }, { toggleOpen: [{
            type: HostListener,
            args: ['click', ['$event']]
        }] }); })();
class HtmlAttributesDirective {
    constructor(renderer, el) {
        this.renderer = renderer;
        this.el = el;
    }
    ngOnInit() {
        const attribs = this.appHtmlAttr;
        for (const attr in attribs) {
            if (attr === 'style' && typeof (attribs[attr]) === 'object') {
                this.setStyle(attribs[attr]);
            }
            else if (attr === 'class') {
                this.addClass(attribs[attr]);
            }
            else {
                this.setAttrib(attr, attribs[attr]);
            }
        }
    }
    setStyle(styles) {
        for (const style in styles) {
            this.renderer.setStyle(this.el.nativeElement, style, styles[style]);
        }
    }
    addClass(classes) {
        const classArray = (Array.isArray(classes) ? classes : classes.split(' '));
        classArray.filter((element) => element.length > 0).forEach(element => {
            this.renderer.addClass(this.el.nativeElement, element);
        });
    }
    setAttrib(key, value) {
        value !== null ?
            this.renderer.setAttribute(this.el.nativeElement, key, value) :
            this.renderer.removeAttribute(this.el.nativeElement, key);
    }
}
HtmlAttributesDirective.ɵfac = function HtmlAttributesDirective_Factory(t) { return new (t || HtmlAttributesDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
HtmlAttributesDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: HtmlAttributesDirective, selectors: [["", "appHtmlAttr", ""]], inputs: { appHtmlAttr: "appHtmlAttr" } });
HtmlAttributesDirective.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef }
];
HtmlAttributesDirective.propDecorators = {
    appHtmlAttr: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HtmlAttributesDirective, [{
        type: Directive,
        args: [{
                selector: '[appHtmlAttr]'
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }]; }, { appHtmlAttr: [{
            type: Input
        }] }); })();

class LayoutModule {
}
LayoutModule.ɵfac = function LayoutModule_Factory(t) { return new (t || LayoutModule)(); };
LayoutModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: LayoutModule });
LayoutModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ providers: [
        ClassToggler
    ], imports: [[
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(LayoutModule, { declarations: function () { return [BrandMinimizeDirective, MobileSidebarToggleDirective, SidebarToggleDirective, SidebarMinimizeDirective, SidebarOffCanvasCloseDirective, HtmlAttributesDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [BrandMinimizeDirective, MobileSidebarToggleDirective, SidebarToggleDirective, SidebarMinimizeDirective, SidebarOffCanvasCloseDirective, HtmlAttributesDirective]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LayoutModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule
                ],
                exports: [
                    BrandMinimizeDirective,
                    MobileSidebarToggleDirective,
                    SidebarToggleDirective,
                    SidebarMinimizeDirective,
                    SidebarOffCanvasCloseDirective,
                    HtmlAttributesDirective
                ],
                declarations: [
                    BrandMinimizeDirective,
                    MobileSidebarToggleDirective,
                    SidebarToggleDirective,
                    SidebarMinimizeDirective,
                    SidebarOffCanvasCloseDirective,
                    HtmlAttributesDirective
                ],
                providers: [
                    ClassToggler
                ]
            }]
    }], null, null); })();

class AppHeaderAdminModule {
}
AppHeaderAdminModule.ɵfac = function AppHeaderAdminModule_Factory(t) { return new (t || AppHeaderAdminModule)(); };
AppHeaderAdminModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: AppHeaderAdminModule });
AppHeaderAdminModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ providers: [CommonFunctionsService], imports: [[
            CommonModule,
            RouterModule,
            LayoutModule
        ], LayoutModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AppHeaderAdminModule, { declarations: function () { return [AppHeaderAdminComponent]; }, imports: function () { return [CommonModule,
        RouterModule, LayoutModule]; }, exports: function () { return [AppHeaderAdminComponent, LayoutModule]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AppHeaderAdminModule, [{
        type: NgModule,
        args: [{
                declarations: [AppHeaderAdminComponent],
                imports: [
                    CommonModule,
                    RouterModule,
                    LayoutModule
                ],
                providers: [CommonFunctionsService],
                exports: [
                    AppHeaderAdminComponent,
                    LayoutModule
                ]
            }]
    }], null, null); })();

class AppSidebarService {
    constructor() {
        this.events = new BehaviorSubject({});
        this.events$ = this.events.asObservable();
    }
    toggle(action) {
        this.events.next(action);
    }
}
AppSidebarService.ɵfac = function AppSidebarService_Factory(t) { return new (t || AppSidebarService)(); };
AppSidebarService.ɵprov = i0.ɵɵdefineInjectable({ factory: function AppSidebarService_Factory() { return new AppSidebarService(); }, token: AppSidebarService, providedIn: "root" });
AppSidebarService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AppSidebarService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class AppSidebarComponent {
    constructor(document, renderer, sidebarService) {
        this.document = document;
        this.renderer = renderer;
        this.sidebarService = sidebarService;
        this._minimized = false;
        /**
         * Emits whenever the minimized state of the sidebar changes.
         * Primarily used to facilitate two-way binding.
         */
        this.minimizedChange = new EventEmitter();
        this._sidebar = true;
    }
    get minimized() {
        return this._minimized;
    }
    set minimized(value) {
        // only update / emit events when the value changes
        if (this._minimized !== value) {
            this._minimized = value;
            this._updateMinimized(value);
            this.minimizedChange.emit(value);
            this.sidebarService.toggle({ minimize: value });
        }
    }
    ngOnInit() {
        this.displayBreakpoint(this.display);
        this.isCompact(this.compact);
        this.isFixed(this.fixed);
        this.isOffCanvas(this.offCanvas);
        this.sidebarService.toggle({ minimize: this.minimized });
        this.subscriptionEvents = this.sidebarService.events$.subscribe(action => {
            if (action.minimize !== undefined) {
                action.minimize === 'toggle' ? this.toggleMinimized() : this.minimized = !!action.minimize;
            }
        });
    }
    ngOnDestroy() {
        this.subscriptionEvents.unsubscribe();
        this.minimizedChange.complete();
        this.renderer.removeClass(this.document.body, 'sidebar-fixed');
        this._updateMinimized(false);
    }
    isCompact(compact = this.compact) {
        if (compact) {
            this.renderer.addClass(this.document.body, 'sidebar-compact');
        }
    }
    isFixed(fixed = this.fixed) {
        if (fixed) {
            this.renderer.addClass(this.document.body, 'sidebar-fixed');
        }
    }
    toggleMinimized() {
        this.minimized = !this._minimized;
    }
    isOffCanvas(offCanvas = this.offCanvas) {
        if (offCanvas) {
            this.renderer.addClass(this.document.body, 'sidebar-off-canvas');
        }
    }
    displayBreakpoint(display = this.display) {
        if (display !== false) {
            const cssClass = display ? `sidebar-${display}-show` : sidebarCssClasses[0];
            this.renderer.addClass(this.document.body, cssClass);
        }
    }
    _updateMinimized(minimized) {
        const body = this.document.body;
        if (minimized) {
            this.renderer.addClass(body, 'sidebar-minimized');
            this.renderer.addClass(body, 'brand-minimized');
        }
        else {
            this.renderer.removeClass(body, 'sidebar-minimized');
            this.renderer.removeClass(body, 'brand-minimized');
        }
    }
}
AppSidebarComponent.ɵfac = function AppSidebarComponent_Factory(t) { return new (t || AppSidebarComponent)(ɵngcc0.ɵɵdirectiveInject(DOCUMENT), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(AppSidebarService)); };
AppSidebarComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AppSidebarComponent, selectors: [["app-sidebar"], ["cui-sidebar"]], hostVars: 2, hostBindings: function AppSidebarComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("sidebar", ctx._sidebar);
    } }, inputs: { minimized: "minimized", compact: "compact", display: "display", fixed: "fixed", offCanvas: "offCanvas" }, outputs: { minimizedChange: "minimizedChange" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function AppSidebarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2 });
AppSidebarComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] },
    { type: Renderer2 },
    { type: AppSidebarService }
];
AppSidebarComponent.propDecorators = {
    compact: [{ type: Input }],
    display: [{ type: Input }],
    fixed: [{ type: Input }],
    offCanvas: [{ type: Input }],
    minimized: [{ type: Input }],
    minimizedChange: [{ type: Output }],
    _sidebar: [{ type: HostBinding, args: ['class.sidebar',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AppSidebarComponent, [{
        type: Component,
        args: [{
                selector: 'app-sidebar, cui-sidebar',
                template: `<ng-content></ng-content>`
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }, { type: ɵngcc0.Renderer2 }, { type: AppSidebarService }]; }, { minimizedChange: [{
            type: Output
        }], _sidebar: [{
            type: HostBinding,
            args: ['class.sidebar']
        }], minimized: [{
            type: Input
        }], compact: [{
            type: Input
        }], display: [{
            type: Input
        }], fixed: [{
            type: Input
        }], offCanvas: [{
            type: Input
        }] }); })();

class AppSidebarFooterComponent {
    constructor() {
        this._sidebarFooter = true;
    }
}
AppSidebarFooterComponent.ɵfac = function AppSidebarFooterComponent_Factory(t) { return new (t || AppSidebarFooterComponent)(); };
AppSidebarFooterComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AppSidebarFooterComponent, selectors: [["app-sidebar-footer"], ["cui-sidebar-footer"]], hostVars: 2, hostBindings: function AppSidebarFooterComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("sidebar-footer", ctx._sidebarFooter);
    } }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function AppSidebarFooterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2 });
AppSidebarFooterComponent.ctorParameters = () => [];
AppSidebarFooterComponent.propDecorators = {
    _sidebarFooter: [{ type: HostBinding, args: ['class.sidebar-footer',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AppSidebarFooterComponent, [{
        type: Component,
        args: [{
                selector: 'app-sidebar-footer, cui-sidebar-footer',
                template: `<ng-content></ng-content>`
            }]
    }], function () { return []; }, { _sidebarFooter: [{
            type: HostBinding,
            args: ['class.sidebar-footer']
        }] }); })();

class AppSidebarFormComponent {
    constructor() {
        this._sidebarForm = true;
    }
}
AppSidebarFormComponent.ɵfac = function AppSidebarFormComponent_Factory(t) { return new (t || AppSidebarFormComponent)(); };
AppSidebarFormComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AppSidebarFormComponent, selectors: [["app-sidebar-form"], ["cui-sidebar-form"]], hostVars: 2, hostBindings: function AppSidebarFormComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("sidebar-form", ctx._sidebarForm);
    } }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function AppSidebarFormComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2 });
AppSidebarFormComponent.ctorParameters = () => [];
AppSidebarFormComponent.propDecorators = {
    _sidebarForm: [{ type: HostBinding, args: ['class.sidebar-form',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AppSidebarFormComponent, [{
        type: Component,
        args: [{
                selector: 'app-sidebar-form, cui-sidebar-form',
                template: `<ng-content></ng-content>`
            }]
    }], function () { return []; }, { _sidebarForm: [{
            type: HostBinding,
            args: ['class.sidebar-form']
        }] }); })();

class AppSidebarHeaderComponent {
    constructor() {
        this._sidebarHeader = true;
    }
}
AppSidebarHeaderComponent.ɵfac = function AppSidebarHeaderComponent_Factory(t) { return new (t || AppSidebarHeaderComponent)(); };
AppSidebarHeaderComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AppSidebarHeaderComponent, selectors: [["app-sidebar-header"], ["cui-sidebar-header"]], hostVars: 2, hostBindings: function AppSidebarHeaderComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("sidebar-header", ctx._sidebarHeader);
    } }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function AppSidebarHeaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2 });
AppSidebarHeaderComponent.ctorParameters = () => [];
AppSidebarHeaderComponent.propDecorators = {
    _sidebarHeader: [{ type: HostBinding, args: ['class.sidebar-header',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AppSidebarHeaderComponent, [{
        type: Component,
        args: [{
                selector: 'app-sidebar-header, cui-sidebar-header',
                template: `<ng-content></ng-content>`
            }]
    }], function () { return []; }, { _sidebarHeader: [{
            type: HostBinding,
            args: ['class.sidebar-header']
        }] }); })();

class AppSidebarMinimizerComponent {
    constructor(sidebarService) {
        this.sidebarService = sidebarService;
        this.role = 'button';
        this._minimizer = true;
    }
    toggleOpen($event) {
        $event.preventDefault();
        this.sidebarService.toggle({ minimize: 'toggle' });
    }
}
AppSidebarMinimizerComponent.ɵfac = function AppSidebarMinimizerComponent_Factory(t) { return new (t || AppSidebarMinimizerComponent)(ɵngcc0.ɵɵdirectiveInject(AppSidebarService)); };
AppSidebarMinimizerComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AppSidebarMinimizerComponent, selectors: [["app-sidebar-minimizer"], ["cui-sidebar-minimizer"]], hostVars: 3, hostBindings: function AppSidebarMinimizerComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function AppSidebarMinimizerComponent_click_HostBindingHandler($event) { return ctx.toggleOpen($event); });
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("role", ctx.role);
        ɵngcc0.ɵɵclassProp("sidebar-minimizer", ctx._minimizer);
    } }, inputs: { role: "role" }, decls: 0, vars: 0, template: function AppSidebarMinimizerComponent_Template(rf, ctx) { }, encapsulation: 2 });
AppSidebarMinimizerComponent.ctorParameters = () => [
    { type: AppSidebarService }
];
AppSidebarMinimizerComponent.propDecorators = {
    role: [{ type: HostBinding, args: ['attr.role',] }, { type: Input }],
    _minimizer: [{ type: HostBinding, args: ['class.sidebar-minimizer',] }],
    toggleOpen: [{ type: HostListener, args: ['click', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AppSidebarMinimizerComponent, [{
        type: Component,
        args: [{
                selector: 'app-sidebar-minimizer, cui-sidebar-minimizer',
                template: ``
            }]
    }], function () { return [{ type: AppSidebarService }]; }, { role: [{
            type: HostBinding,
            args: ['attr.role']
        }, {
            type: Input
        }], _minimizer: [{
            type: HostBinding,
            args: ['class.sidebar-minimizer']
        }], toggleOpen: [{
            type: HostListener,
            args: ['click', ['$event']]
        }] }); })();

class NavDropdownDirective {
    constructor(el) {
        this.el = el;
    }
    toggle() {
        this.el.nativeElement.classList.toggle('open');
    }
}
NavDropdownDirective.ɵfac = function NavDropdownDirective_Factory(t) { return new (t || NavDropdownDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
NavDropdownDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: NavDropdownDirective, selectors: [["", "appNavDropdown", ""]] });
NavDropdownDirective.ctorParameters = () => [
    { type: ElementRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NavDropdownDirective, [{
        type: Directive,
        args: [{
                selector: '[appNavDropdown]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, null); })();
/**
 * Allows the dropdown to be toggled via click.
 */
class NavDropdownToggleDirective {
    constructor(dropdown) {
        this.dropdown = dropdown;
    }
    toggleOpen($event) {
        $event.preventDefault();
        this.dropdown.toggle();
    }
}
NavDropdownToggleDirective.ɵfac = function NavDropdownToggleDirective_Factory(t) { return new (t || NavDropdownToggleDirective)(ɵngcc0.ɵɵdirectiveInject(NavDropdownDirective)); };
NavDropdownToggleDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: NavDropdownToggleDirective, selectors: [["", "appNavDropdownToggle", ""]], hostBindings: function NavDropdownToggleDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function NavDropdownToggleDirective_click_HostBindingHandler($event) { return ctx.toggleOpen($event); });
    } } });
NavDropdownToggleDirective.ctorParameters = () => [
    { type: NavDropdownDirective }
];
NavDropdownToggleDirective.propDecorators = {
    toggleOpen: [{ type: HostListener, args: ['click', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NavDropdownToggleDirective, [{
        type: Directive,
        args: [{
                selector: '[appNavDropdownToggle]'
            }]
    }], function () { return [{ type: NavDropdownDirective }]; }, { toggleOpen: [{
            type: HostListener,
            args: ['click', ['$event']]
        }] }); })();

class AppSidebarNavComponent {
    constructor(router) {
        this.router = router;
        this.navItems = [];
        this._sidebarBav = true;
        this.role = 'nav';
        this.navItemsArray = [];
    }
    ngOnChanges(changes) {
        this.navItemsArray = Array.isArray(this.navItems) ? this.navItems.slice() : [];
    }
}
AppSidebarNavComponent.ɵfac = function AppSidebarNavComponent_Factory(t) { return new (t || AppSidebarNavComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.Router)); };
AppSidebarNavComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AppSidebarNavComponent, selectors: [["app-sidebar-nav"], ["cui-sidebar-nav"]], hostVars: 3, hostBindings: function AppSidebarNavComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("role", ctx.role);
        ɵngcc0.ɵɵclassProp("sidebar-nav", ctx._sidebarBav);
    } }, inputs: { navItems: "navItems", role: "role" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [[1, "nav", 3, "items"]], template: function AppSidebarNavComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "app-sidebar-nav-items", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("items", ctx.navItemsArray);
    } }, directives: function () { return [AppSidebarNavItemsComponent]; }, encapsulation: 2 });
AppSidebarNavComponent.ctorParameters = () => [
    { type: Router }
];
AppSidebarNavComponent.propDecorators = {
    navItems: [{ type: Input }],
    _sidebarBav: [{ type: HostBinding, args: ['class.sidebar-nav',] }],
    role: [{ type: HostBinding, args: ['attr.role',] }, { type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AppSidebarNavComponent, [{
        type: Component,
        args: [{
                selector: 'app-sidebar-nav, cui-sidebar-nav',
                template: "<app-sidebar-nav-items\n  class=\"nav\"\n  [items]=\"navItemsArray\">\n</app-sidebar-nav-items>\n"
            }]
    }], function () { return [{ type: ɵngcc3.Router }]; }, { navItems: [{
            type: Input
        }], _sidebarBav: [{
            type: HostBinding,
            args: ['class.sidebar-nav']
        }], role: [{
            type: HostBinding,
            args: ['attr.role']
        }, {
            type: Input
        }] }); })();

class AppSidebarNavDividerComponent {
    constructor() { }
    ngOnInit() { }
}
AppSidebarNavDividerComponent.ɵfac = function AppSidebarNavDividerComponent_Factory(t) { return new (t || AppSidebarNavDividerComponent)(); };
AppSidebarNavDividerComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AppSidebarNavDividerComponent, selectors: [["app-sidebar-nav-divider"], ["cui-sidebar-nav-divider"]], inputs: { item: "item" }, decls: 0, vars: 0, template: function AppSidebarNavDividerComponent_Template(rf, ctx) { }, encapsulation: 2 });
AppSidebarNavDividerComponent.ctorParameters = () => [];
AppSidebarNavDividerComponent.propDecorators = {
    item: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AppSidebarNavDividerComponent, [{
        type: Component,
        args: [{
                selector: 'app-sidebar-nav-divider, cui-sidebar-nav-divider',
                template: ``
            }]
    }], function () { return []; }, { item: [{
            type: Input
        }] }); })();

class SidebarNavService {
}
SidebarNavService.ɵfac = function SidebarNavService_Factory(t) { return new (t || SidebarNavService)(); };
SidebarNavService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: SidebarNavService, factory: SidebarNavService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SidebarNavService, [{
        type: Injectable
    }], null, null); })();
class SidebarNavHelper {
    constructor() {
        this.hasBadge = (item) => Boolean(item.badge);
        this.hasIcon = (item) => Boolean(item.icon);
    }
    itemType(item) {
        if (item.divider) {
            return 'divider';
        }
        else if (item.title) {
            return 'title';
        }
        else if (item.children) {
            return 'dropdown';
        }
        else if (item.label) {
            return 'label';
        }
        else if (!Object.keys(item).length) {
            return 'empty';
        }
        else {
            return 'link';
        }
    }
    isActive(router, item) {
        if (item.url)
            return router.isActive(item.url, false);
        return item.children.findIndex(element => router.isActive(element.url, false)) !== -1;
    }
    getIconClass(item) {
        const classes = {
            'nav-icon': true
        };
        const icon = item.icon;
        classes[icon] = this.hasIcon(item);
        return classes;
    }
}
SidebarNavHelper.ɵfac = function SidebarNavHelper_Factory(t) { return new (t || SidebarNavHelper)(); };
SidebarNavHelper.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: SidebarNavHelper, factory: SidebarNavHelper.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SidebarNavHelper, [{
        type: Injectable
    }], function () { return []; }, null); })();

class AppSidebarNavDropdownComponent {
    constructor(helper) {
        this.helper = helper;
    }
}
AppSidebarNavDropdownComponent.ɵfac = function AppSidebarNavDropdownComponent_Factory(t) { return new (t || AppSidebarNavDropdownComponent)(ɵngcc0.ɵɵdirectiveInject(SidebarNavHelper)); };
AppSidebarNavDropdownComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AppSidebarNavDropdownComponent, selectors: [["app-sidebar-nav-dropdown"], ["cui-sidebar-nav-dropdown"]], inputs: { item: "item" }, features: [ɵngcc0.ɵɵProvidersFeature([SidebarNavHelper])], decls: 6, vars: 5, consts: [["appNavDropdownToggle", "", 1, "nav-link", "nav-dropdown-toggle", 3, "appHtmlAttr"], [3, "ngClass", 4, "ngIf"], [1, "nav-dropdown-items", 3, "items"], [3, "ngClass"]], template: function AppSidebarNavDropdownComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "a", 0);
        ɵngcc0.ɵɵtemplate(1, AppSidebarNavDropdownComponent_i_1_Template, 2, 3, "i", 1);
        ɵngcc0.ɵɵelementContainerStart(2);
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵelementContainerEnd();
        ɵngcc0.ɵɵtemplate(4, AppSidebarNavDropdownComponent_span_4_Template, 3, 4, "span", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(5, "app-sidebar-nav-items", 2);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("appHtmlAttr", ctx.item.attributes);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.helper.hasIcon(ctx.item));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.item.name);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.helper.hasBadge(ctx.item));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("items", ctx.item.children);
    } }, directives: function () { return [NavDropdownToggleDirective, HtmlAttributesDirective, ɵngcc4.NgIf, AppSidebarNavItemsComponent, ɵngcc4.NgClass]; }, pipes: function () { return [AppSidebarNavIconPipe, AppSidebarNavBadgePipe]; }, styles: [".nav-dropdown-toggle[_ngcontent-%COMP%] { cursor: pointer; }", ".nav-dropdown-items[_ngcontent-%COMP%] { display: block; }"] });
AppSidebarNavDropdownComponent.ctorParameters = () => [
    { type: SidebarNavHelper }
];
AppSidebarNavDropdownComponent.propDecorators = {
    item: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AppSidebarNavDropdownComponent, [{
        type: Component,
        args: [{
                selector: 'app-sidebar-nav-dropdown, cui-sidebar-nav-dropdown',
                template: `
    <a class="nav-link nav-dropdown-toggle"
       appNavDropdownToggle
       [appHtmlAttr]="item.attributes">
      <i *ngIf="helper.hasIcon(item)" [ngClass]="item | appSidebarNavIcon"></i>
      <ng-container>{{item.name}}</ng-container>
      <span *ngIf="helper.hasBadge(item)" [ngClass]="item | appSidebarNavBadge">{{ item.badge.text }}</span>
    </a>
    <app-sidebar-nav-items
      class="nav-dropdown-items"
      [items]="item.children">
    </app-sidebar-nav-items>
  `,
                providers: [SidebarNavHelper],
                styles: ['.nav-dropdown-toggle { cursor: pointer; }',
                    '.nav-dropdown-items { display: block; }']
            }]
    }], function () { return [{ type: SidebarNavHelper }]; }, { item: [{
            type: Input
        }] }); })();

class AppSidebarNavItemsComponent {
    constructor(document, renderer, router, helper) {
        this.document = document;
        this.renderer = renderer;
        this.router = router;
        this.helper = helper;
    }
    set items(items) {
        this._items = [...items];
    }
    get items() {
        return this._items;
    }
    hideMobile() {
        if (this.document.body.classList.contains('sidebar-show')) {
            this.renderer.removeClass(this.document.body, 'sidebar-show');
        }
    }
}
AppSidebarNavItemsComponent.ɵfac = function AppSidebarNavItemsComponent_Factory(t) { return new (t || AppSidebarNavItemsComponent)(ɵngcc0.ɵɵdirectiveInject(DOCUMENT), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.Router), ɵngcc0.ɵɵdirectiveInject(SidebarNavHelper)); };
AppSidebarNavItemsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AppSidebarNavItemsComponent, selectors: [["app-sidebar-nav-items"], ["cui-sidebar-nav-items"]], inputs: { items: "items" }, decls: 1, vars: 1, consts: [[4, "ngFor", "ngForOf"], [3, "ngSwitch"], ["appNavDropdown", "", "routerLinkActive", "", 3, "item", "open", "ngClass", 4, "ngSwitchCase"], [3, "item", "ngClass", "appHtmlAttr", 4, "ngSwitchCase"], ["class", "nav-item", 3, "item", "ngClass", 4, "ngSwitchCase"], [4, "ngSwitchCase"], ["class", "nav-item", 3, "item", "ngClass", "linkClick", 4, "ngSwitchDefault"], ["appNavDropdown", "", "routerLinkActive", "", 3, "item", "ngClass"], [3, "item", "ngClass", "appHtmlAttr"], [1, "nav-item", 3, "item", "ngClass"], [1, "nav-item", 3, "item", "ngClass", "linkClick"]], template: function AppSidebarNavItemsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, AppSidebarNavItemsComponent_ng_container_0_Template, 8, 6, "ng-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngForOf", ctx.items);
    } }, directives: function () { return [ɵngcc4.NgForOf, ɵngcc4.NgSwitch, ɵngcc4.NgSwitchCase, ɵngcc4.NgSwitchDefault, AppSidebarNavDropdownComponent, NavDropdownDirective, ɵngcc3.RouterLinkActive, ɵngcc4.NgClass, AppSidebarNavDividerComponent, HtmlAttributesDirective, AppSidebarNavTitleComponent, AppSidebarNavLabelComponent, AppSidebarNavLinkComponent]; }, pipes: function () { return [AppSidebarNavItemClassPipe]; }, encapsulation: 2 });
AppSidebarNavItemsComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] },
    { type: Renderer2 },
    { type: Router },
    { type: SidebarNavHelper }
];
AppSidebarNavItemsComponent.propDecorators = {
    items: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AppSidebarNavItemsComponent, [{
        type: Component,
        args: [{
                selector: 'app-sidebar-nav-items, cui-sidebar-nav-items',
                template: `
    <ng-container *ngFor="let item of items">
      <ng-container [ngSwitch]="helper.itemType(item)">
        <app-sidebar-nav-dropdown
          *ngSwitchCase="'dropdown'"
          [item]="item"
          [class.open]="helper.isActive(router, item)"
          [ngClass]="item | appSidebarNavItemClass"
          appNavDropdown
          routerLinkActive="">
        </app-sidebar-nav-dropdown>
        <app-sidebar-nav-divider
          *ngSwitchCase="'divider'"
          [item]="item"
          [ngClass]="item | appSidebarNavItemClass"
          [appHtmlAttr]="item.attributes">
        </app-sidebar-nav-divider>
        <app-sidebar-nav-title
          *ngSwitchCase="'title'"
          [item]="item"
          [ngClass]="item | appSidebarNavItemClass"
          [appHtmlAttr]="item.attributes">
        </app-sidebar-nav-title>
        <app-sidebar-nav-label
          *ngSwitchCase="'label'"
          [item]="item"
          class="nav-item"
          [ngClass]="item | appSidebarNavItemClass">
        </app-sidebar-nav-label>
        <ng-container
          *ngSwitchCase="'empty'">
        </ng-container>
        <app-sidebar-nav-link
          *ngSwitchDefault
          [item]="item"
          class="nav-item"
          [ngClass]="item | appSidebarNavItemClass"
          (linkClick)="hideMobile()"
        >
        </app-sidebar-nav-link>
      </ng-container>
    </ng-container>
  `
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc3.Router }, { type: SidebarNavHelper }]; }, { items: [{
            type: Input
        }] }); })();

class AppSidebarNavLinkContentComponent {
    constructor(helper) {
        this.helper = helper;
    }
}
AppSidebarNavLinkContentComponent.ɵfac = function AppSidebarNavLinkContentComponent_Factory(t) { return new (t || AppSidebarNavLinkContentComponent)(ɵngcc0.ɵɵdirectiveInject(SidebarNavHelper)); };
AppSidebarNavLinkContentComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AppSidebarNavLinkContentComponent, selectors: [["app-sidebar-nav-link-content"], ["cui-sidebar-nav-link-content"]], inputs: { item: "item" }, features: [ɵngcc0.ɵɵProvidersFeature([SidebarNavHelper])], decls: 1, vars: 1, consts: [[4, "ngIf"], [3, "ngClass", 4, "ngIf"], [3, "ngClass"]], template: function AppSidebarNavLinkContentComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, AppSidebarNavLinkContentComponent_ng_container_0_Template, 5, 3, "ng-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", true);
    } }, directives: function () { return [ɵngcc4.NgIf, ɵngcc4.NgClass]; }, pipes: function () { return [AppSidebarNavIconPipe, AppSidebarNavBadgePipe]; }, encapsulation: 2 });
AppSidebarNavLinkContentComponent.ctorParameters = () => [
    { type: SidebarNavHelper }
];
AppSidebarNavLinkContentComponent.propDecorators = {
    item: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AppSidebarNavLinkContentComponent, [{
        type: Component,
        args: [{
                selector: 'app-sidebar-nav-link-content, cui-sidebar-nav-link-content',
                template: `
    <ng-container *ngIf="true">
      <i *ngIf="helper.hasIcon(item)" [ngClass]="item | appSidebarNavIcon"></i>
      <ng-container>{{item.name}}</ng-container>
      <span *ngIf="helper.hasBadge(item)" [ngClass]="item | appSidebarNavBadge">{{ item.badge.text }}</span>
    </ng-container>
  `,
                providers: [SidebarNavHelper]
            }]
    }], function () { return [{ type: SidebarNavHelper }]; }, { item: [{
            type: Input
        }] }); })();
class AppSidebarNavLinkComponent {
    constructor(router) {
        this.router = router;
        this.linkClick = new EventEmitter();
        this.navigationEndObservable = router.events.pipe(filter(event => {
            return event instanceof NavigationEnd;
        }));
    }
    set item(item) {
        this._item = JSON.parse(JSON.stringify(item));
    }
    get item() {
        return this._item;
    }
    ngOnInit() {
        this.url = typeof this.item.url === 'string' ? this.item.url : this.router.serializeUrl(this.router.createUrlTree(this.item.url));
        this.linkType = this.getLinkType();
        this.href = this.isDisabled() ? '' : (this.item.href || this.url);
        this.linkActive = this.router.url.split(/[?#(;]/)[0] === this.href.split(/[?#(;]/)[0];
        this.navSubscription = this.navigationEndObservable.subscribe(event => {
            const itemUrlArray = this.href.split(/[?#(;]/)[0].split('/');
            const urlArray = event.urlAfterRedirects.split(/[?#(;]/)[0].split('/');
            this.linkActive = itemUrlArray.every((value, index) => value === urlArray[index]);
        });
    }
    ngOnDestroy() {
        this.navSubscription.unsubscribe();
    }
    getLinkType() {
        return this.isDisabled() ? 'disabled' : this.isExternalLink() ? 'external' : 'link';
    }
    isDisabled() {
        return (this.item.attributes && this.item.attributes.disabled) ? true : null;
    }
    isExternalLink() {
        return !!this.item.href || this.url.substring(0, 4) === 'http';
    }
    linkClicked() {
        this.linkClick.emit();
    }
}
AppSidebarNavLinkComponent.ɵfac = function AppSidebarNavLinkComponent_Factory(t) { return new (t || AppSidebarNavLinkComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.Router)); };
AppSidebarNavLinkComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AppSidebarNavLinkComponent, selectors: [["app-sidebar-nav-link"], ["cui-sidebar-nav-link"]], inputs: { item: "item" }, outputs: { linkClick: "linkClick" }, features: [ɵngcc0.ɵɵProvidersFeature([SidebarNavHelper])], decls: 4, vars: 3, consts: [[3, "ngSwitch"], [3, "ngClass", "appHtmlAttr", 4, "ngSwitchCase"], [3, "ngClass", "href", "appHtmlAttr", "click", 4, "ngSwitchCase"], [3, "ngClass", "appHtmlAttr", "target", "queryParams", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "routerLink", "active", "click", 4, "ngSwitchDefault"], [3, "ngClass", "appHtmlAttr"], [3, "item"], [3, "ngClass", "href", "appHtmlAttr", "click"], [3, "ngClass", "appHtmlAttr", "target", "queryParams", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "routerLink", "click"]], template: function AppSidebarNavLinkComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementContainerStart(0, 0);
        ɵngcc0.ɵɵtemplate(1, AppSidebarNavLinkComponent_a_1_Template, 3, 5, "a", 1);
        ɵngcc0.ɵɵtemplate(2, AppSidebarNavLinkComponent_a_2_Template, 3, 6, "a", 2);
        ɵngcc0.ɵɵtemplate(3, AppSidebarNavLinkComponent_a_3_Template, 3, 16, "a", 3);
        ɵngcc0.ɵɵelementContainerEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngSwitch", ctx.linkType);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", "disabled");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", "external");
    } }, directives: function () { return [ɵngcc4.NgSwitch, ɵngcc4.NgSwitchCase, ɵngcc4.NgSwitchDefault, ɵngcc4.NgClass, HtmlAttributesDirective, AppSidebarNavLinkContentComponent, ɵngcc3.RouterLinkWithHref]; }, pipes: function () { return [AppSidebarNavLinkPipe]; }, encapsulation: 2 });
AppSidebarNavLinkComponent.ctorParameters = () => [
    { type: Router }
];
AppSidebarNavLinkComponent.propDecorators = {
    item: [{ type: Input }],
    linkClick: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AppSidebarNavLinkComponent, [{
        type: Component,
        args: [{
                selector: 'app-sidebar-nav-link, cui-sidebar-nav-link',
                template: "<ng-container [ngSwitch]=\"linkType\">\n  <a *ngSwitchCase=\"'disabled'\"\n     [ngClass]=\"item | appSidebarNavLink\"\n     [appHtmlAttr]=\"item.attributes\"\n  >\n    <app-sidebar-nav-link-content [item]=\"item\"></app-sidebar-nav-link-content>\n  </a>\n  <a *ngSwitchCase=\"'external'\"\n     [ngClass]=\"item | appSidebarNavLink\"\n     [href]=\"href\"\n     [appHtmlAttr]=\"item.attributes\"\n     (click)=\"linkClicked()\"\n  >\n    <app-sidebar-nav-link-content [item]=\"item\"></app-sidebar-nav-link-content>\n  </a>\n  <a *ngSwitchDefault\n     [ngClass]=\"item | appSidebarNavLink\"\n     [appHtmlAttr]=\"item.attributes\"\n     [target]=\"item.attributes?.target\"\n     [queryParams]=\"item.linkProps?.queryParams\"\n     [fragment]=\"item.linkProps?.fragment\"\n     [queryParamsHandling]=\"item.linkProps?.queryParamsHandling\"\n     [preserveFragment]=\"item.linkProps?.preserveFragment\"\n     [skipLocationChange]=\"item.linkProps?.skipLocationChange\"\n     [replaceUrl]=\"item.linkProps?.replaceUrl\"\n     [state]=\"item.linkProps?.state\"\n     [routerLink]=\"item.url\"\n     [class.active]=\"linkActive\"\n     (click)=\"linkClicked()\"\n  >\n    <app-sidebar-nav-link-content [item]=\"item\"></app-sidebar-nav-link-content>\n  </a>\n</ng-container>\n",
                providers: [SidebarNavHelper]
            }]
    }], function () { return [{ type: ɵngcc3.Router }]; }, { linkClick: [{
            type: Output
        }], item: [{
            type: Input
        }] }); })();

class AppSidebarNavTitleComponent {
    constructor(el, renderer) {
        this.el = el;
        this.renderer = renderer;
    }
    ngOnInit() {
        const nativeElement = this.el.nativeElement;
        const name = this.renderer.createText(this.item.name);
        if (this.item.class) {
            const classes = this.item.class;
            this.renderer.addClass(nativeElement, classes);
        }
        if (this.item.wrapper) {
            const wrapper = this.renderer.createElement(this.item.wrapper.element);
            this.addAttribs(this.item.wrapper.attributes, wrapper);
            this.renderer.appendChild(wrapper, name);
            this.renderer.appendChild(nativeElement, wrapper);
        }
        else {
            this.renderer.appendChild(nativeElement, name);
        }
    }
    addAttribs(attribs, element) {
        if (attribs) {
            for (const attr in attribs) {
                if (attr === 'style' && typeof (attribs[attr]) === 'object') {
                    this.setStyle(attribs[attr], element);
                }
                else if (attr === 'class') {
                    this.addClass(attribs[attr], element);
                }
                else {
                    this.setAttrib(attr, attribs[attr], element);
                }
            }
        }
    }
    setStyle(styles, el) {
        for (const style in styles) {
            this.renderer.setStyle(el, style, styles[style]);
        }
    }
    addClass(classes, el) {
        const classArray = (Array.isArray(classes) ? classes : classes.split(' '));
        classArray.filter((element) => element.length > 0).forEach(element => {
            this.renderer.addClass(el, element);
        });
    }
    setAttrib(key, value, el) {
        this.renderer.setAttribute(el, key, value);
    }
}
AppSidebarNavTitleComponent.ɵfac = function AppSidebarNavTitleComponent_Factory(t) { return new (t || AppSidebarNavTitleComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
AppSidebarNavTitleComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AppSidebarNavTitleComponent, selectors: [["app-sidebar-nav-title"], ["cui-sidebar-nav-title"]], inputs: { item: "item" }, decls: 0, vars: 0, template: function AppSidebarNavTitleComponent_Template(rf, ctx) { }, encapsulation: 2 });
AppSidebarNavTitleComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 }
];
AppSidebarNavTitleComponent.propDecorators = {
    item: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AppSidebarNavTitleComponent, [{
        type: Component,
        args: [{
                selector: 'app-sidebar-nav-title, cui-sidebar-nav-title',
                template: ''
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }]; }, { item: [{
            type: Input
        }] }); })();

class AppSidebarNavLabelComponent {
    constructor(helper) {
        this.helper = helper;
        this.classes = {
            'nav-label': true,
            'active': true
        };
        this.iconClasses = {};
    }
    ngOnInit() {
        this.iconClasses = this.helper.getIconClass(this.item);
    }
    getItemClass() {
        const itemClass = this.item.class;
        this.classes[itemClass] = !!itemClass;
        return this.classes;
    }
    getLabelIconClass() {
        const variant = `text-${this.item.label.variant}`;
        this.iconClasses[variant] = !!this.item.label.variant;
        const labelClass = this.item.label.class;
        this.iconClasses[labelClass] = !!labelClass;
        return this.iconClasses;
    }
}
AppSidebarNavLabelComponent.ɵfac = function AppSidebarNavLabelComponent_Factory(t) { return new (t || AppSidebarNavLabelComponent)(ɵngcc0.ɵɵdirectiveInject(SidebarNavHelper)); };
AppSidebarNavLabelComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AppSidebarNavLabelComponent, selectors: [["app-sidebar-nav-label"], ["cui-sidebar-nav-label"]], inputs: { item: "item" }, decls: 5, vars: 6, consts: [[3, "ngClass", "href", "appHtmlAttr"], [3, "ngClass", 4, "ngIf"], [3, "ngClass"]], template: function AppSidebarNavLabelComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "a", 0);
        ɵngcc0.ɵɵtemplate(1, AppSidebarNavLabelComponent_i_1_Template, 1, 1, "i", 1);
        ɵngcc0.ɵɵelementContainerStart(2);
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵelementContainerEnd();
        ɵngcc0.ɵɵtemplate(4, AppSidebarNavLabelComponent_span_4_Template, 3, 4, "span", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵpropertyInterpolate("href", ctx.item.url, ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵproperty("ngClass", ctx.getItemClass())("appHtmlAttr", ctx.item.attributes);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.helper.hasIcon(ctx.item));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.item.name);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.helper.hasBadge(ctx.item));
    } }, directives: function () { return [ɵngcc4.NgClass, HtmlAttributesDirective, ɵngcc4.NgIf]; }, pipes: function () { return [AppSidebarNavBadgePipe]; }, encapsulation: 2 });
AppSidebarNavLabelComponent.ctorParameters = () => [
    { type: SidebarNavHelper }
];
AppSidebarNavLabelComponent.propDecorators = {
    item: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AppSidebarNavLabelComponent, [{
        type: Component,
        args: [{
                selector: 'app-sidebar-nav-label, cui-sidebar-nav-label',
                template: "<a [ngClass]=\"getItemClass()\"\n   href=\"{{item.url}}\"\n   [appHtmlAttr]=\"item.attributes\">\n  <i *ngIf=\"helper.hasIcon(item)\" [ngClass]=\"getLabelIconClass()\"></i>\n  <ng-container>{{item.name}}</ng-container>\n  <span *ngIf=\"helper.hasBadge(item)\" [ngClass]=\"item | appSidebarNavBadge\">{{ item.badge.text }}</span>\n</a>\n"
            }]
    }], function () { return [{ type: SidebarNavHelper }]; }, { item: [{
            type: Input
        }] }); })();

class AppSidebarNavIconPipe {
    transform(item, args) {
        const classes = {
            'nav-icon': true
        };
        const icon = item.icon;
        classes[icon] = !!item.icon;
        return classes;
    }
}
AppSidebarNavIconPipe.ɵfac = function AppSidebarNavIconPipe_Factory(t) { return new (t || AppSidebarNavIconPipe)(); };
AppSidebarNavIconPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "appSidebarNavIcon", type: AppSidebarNavIconPipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AppSidebarNavIconPipe, [{
        type: Pipe,
        args: [{
                name: 'appSidebarNavIcon'
            }]
    }], null, null); })();

class AppSidebarNavBadgePipe {
    transform(item, args) {
        const classes = {
            'badge': true
        };
        const variant = `badge-${item.badge.variant}`;
        classes[variant] = !!item.badge.variant;
        classes[item.badge.class] = !!item.badge.class;
        return classes;
    }
}
AppSidebarNavBadgePipe.ɵfac = function AppSidebarNavBadgePipe_Factory(t) { return new (t || AppSidebarNavBadgePipe)(); };
AppSidebarNavBadgePipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "appSidebarNavBadge", type: AppSidebarNavBadgePipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AppSidebarNavBadgePipe, [{
        type: Pipe,
        args: [{
                name: 'appSidebarNavBadge'
            }]
    }], null, null); })();

class AppSidebarNavLinkPipe {
    transform(item) {
        const classes = { 'nav-link': true };
        const disabled = item.attributes && item.attributes.disabled;
        classes['disabled'] = disabled;
        classes['btn-link'] = disabled;
        classes[`nav-link-${item.variant}`] = !!item.variant;
        return classes;
    }
}
AppSidebarNavLinkPipe.ɵfac = function AppSidebarNavLinkPipe_Factory(t) { return new (t || AppSidebarNavLinkPipe)(); };
AppSidebarNavLinkPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "appSidebarNavLink", type: AppSidebarNavLinkPipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AppSidebarNavLinkPipe, [{
        type: Pipe,
        args: [{
                name: 'appSidebarNavLink'
            }]
    }], null, null); })();

class AppSidebarNavItemClassPipe {
    constructor(helper) {
        this.helper = helper;
    }
    transform(item, ...args) {
        const itemType = this.helper.itemType(item);
        let itemClass;
        if (['divider', 'title'].includes(itemType)) {
            itemClass = `nav-${itemType}`;
        }
        else if (itemType === 'dropdown') {
            itemClass = 'nav-item nav-dropdown';
        }
        else {
            itemClass = 'nav-item';
        }
        return item.class ? `${itemClass} ${item.class}` : itemClass;
    }
}
AppSidebarNavItemClassPipe.ɵfac = function AppSidebarNavItemClassPipe_Factory(t) { return new (t || AppSidebarNavItemClassPipe)(ɵngcc0.ɵɵdirectiveInject(SidebarNavHelper)); };
AppSidebarNavItemClassPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "appSidebarNavItemClass", type: AppSidebarNavItemClassPipe, pure: true });
AppSidebarNavItemClassPipe.ctorParameters = () => [
    { type: SidebarNavHelper }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AppSidebarNavItemClassPipe, [{
        type: Pipe,
        args: [{
                name: 'appSidebarNavItemClass'
            }]
    }], function () { return [{ type: SidebarNavHelper }]; }, null); })();

class AppSidebarModule {
}
AppSidebarModule.ɵfac = function AppSidebarModule_Factory(t) { return new (t || AppSidebarModule)(); };
AppSidebarModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: AppSidebarModule });
AppSidebarModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ providers: [
        SidebarNavHelper,
        AppSidebarService
    ], imports: [[
            CommonModule,
            RouterModule,
            LayoutModule
        ], LayoutModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AppSidebarModule, { declarations: function () { return [AppSidebarFooterComponent, AppSidebarFormComponent, AppSidebarHeaderComponent, AppSidebarMinimizerComponent, AppSidebarMinimizerComponent, AppSidebarComponent, AppSidebarNavItemsComponent, AppSidebarNavComponent, AppSidebarNavDividerComponent, AppSidebarNavDropdownComponent, AppSidebarNavLinkComponent, AppSidebarNavLinkContentComponent, AppSidebarNavTitleComponent, NavDropdownDirective, NavDropdownToggleDirective, AppSidebarNavLabelComponent, AppSidebarNavIconPipe, AppSidebarNavBadgePipe, AppSidebarNavLinkPipe, AppSidebarNavItemClassPipe]; }, imports: function () { return [CommonModule,
        RouterModule, LayoutModule]; }, exports: function () { return [AppSidebarFooterComponent, AppSidebarFormComponent, AppSidebarHeaderComponent, AppSidebarMinimizerComponent, AppSidebarComponent, AppSidebarNavItemsComponent, AppSidebarNavComponent, AppSidebarNavDividerComponent, AppSidebarNavDropdownComponent, AppSidebarNavLinkComponent, AppSidebarNavLinkContentComponent, AppSidebarNavTitleComponent, NavDropdownDirective, NavDropdownToggleDirective, LayoutModule]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AppSidebarModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    RouterModule,
                    LayoutModule
                ],
                exports: [
                    AppSidebarFooterComponent,
                    AppSidebarFormComponent,
                    AppSidebarHeaderComponent,
                    AppSidebarMinimizerComponent,
                    AppSidebarComponent,
                    AppSidebarNavItemsComponent,
                    AppSidebarNavComponent,
                    AppSidebarNavDividerComponent,
                    AppSidebarNavDropdownComponent,
                    AppSidebarNavLinkComponent,
                    AppSidebarNavLinkContentComponent,
                    AppSidebarNavTitleComponent,
                    NavDropdownDirective,
                    NavDropdownToggleDirective,
                    LayoutModule
                ],
                declarations: [
                    AppSidebarFooterComponent,
                    AppSidebarFormComponent,
                    AppSidebarHeaderComponent,
                    AppSidebarMinimizerComponent,
                    AppSidebarMinimizerComponent,
                    AppSidebarComponent,
                    AppSidebarNavItemsComponent,
                    AppSidebarNavComponent,
                    AppSidebarNavDividerComponent,
                    AppSidebarNavDropdownComponent,
                    AppSidebarNavLinkComponent,
                    AppSidebarNavLinkContentComponent,
                    AppSidebarNavTitleComponent,
                    NavDropdownDirective,
                    NavDropdownToggleDirective,
                    AppSidebarNavLabelComponent,
                    AppSidebarNavIconPipe,
                    AppSidebarNavBadgePipe,
                    AppSidebarNavLinkPipe,
                    AppSidebarNavItemClassPipe
                ],
                providers: [
                    SidebarNavHelper,
                    AppSidebarService
                ]
            }]
    }], null, null); })();

class AppBreadcrumbService {
    constructor(router, route) {
        this.router = router;
        this.route = route;
        this._breadcrumbs = new BehaviorSubject(new Array());
        this.breadcrumbs = this._breadcrumbs.asObservable();
        this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event) => {
            const breadcrumbs = [];
            let currentRoute = this.route.root, url = '';
            do {
                const childrenRoutes = currentRoute.children;
                currentRoute = null;
                // tslint:disable-next-line:no-shadowed-variable
                childrenRoutes.forEach(route => {
                    if (route.outlet === 'primary') {
                        const routeSnapshot = route.snapshot;
                        url += '/' + routeSnapshot.url.map(segment => segment.path).join('/');
                        breadcrumbs.push({
                            label: route.snapshot.data,
                            url: url
                        });
                        currentRoute = route;
                    }
                });
            } while (currentRoute);
            this._breadcrumbs.next(Object.assign([], breadcrumbs));
            return breadcrumbs;
        });
    }
}
AppBreadcrumbService.ɵfac = function AppBreadcrumbService_Factory(t) { return new (t || AppBreadcrumbService)(ɵngcc0.ɵɵinject(ɵngcc3.Router), ɵngcc0.ɵɵinject(ɵngcc3.ActivatedRoute)); };
AppBreadcrumbService.ɵprov = i0.ɵɵdefineInjectable({ factory: function AppBreadcrumbService_Factory() { return new AppBreadcrumbService(i0.ɵɵinject(i1.Router), i0.ɵɵinject(i1.ActivatedRoute)); }, token: AppBreadcrumbService, providedIn: "root" });
AppBreadcrumbService.ctorParameters = () => [
    { type: Router },
    { type: ActivatedRoute }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AppBreadcrumbService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc3.Router }, { type: ɵngcc3.ActivatedRoute }]; }, null); })();

class AppBreadcrumbComponent {
    constructor(document, renderer, service) {
        this.document = document;
        this.renderer = renderer;
        this.service = service;
        this.fixedClass = 'breadcrumb-fixed';
    }
    ngOnInit() {
        this.isFixed(this.fixed);
        this.breadcrumbs = this.service.breadcrumbs;
    }
    ngOnDestroy() {
        this.renderer.removeClass(this.document.body, this.fixedClass);
    }
    isFixed(fixed = this.fixed) {
        if (fixed) {
            this.renderer.addClass(this.document.body, this.fixedClass);
        }
    }
}
AppBreadcrumbComponent.ɵfac = function AppBreadcrumbComponent_Factory(t) { return new (t || AppBreadcrumbComponent)(ɵngcc0.ɵɵdirectiveInject(DOCUMENT), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(AppBreadcrumbService)); };
AppBreadcrumbComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AppBreadcrumbComponent, selectors: [["cui-breadcrumb"]], inputs: { fixed: "fixed" }, ngContentSelectors: _c0, decls: 4, vars: 3, consts: [[1, "breadcrumb"], ["ngFor", "", 3, "ngForOf"], ["class", "breadcrumb-item", 3, "ngClass", 4, "ngIf"], [1, "breadcrumb-item", 3, "ngClass"], [3, "routerLink", 4, "ngIf"], [3, "routerLink"]], template: function AppBreadcrumbComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "ol", 0);
        ɵngcc0.ɵɵtemplate(1, AppBreadcrumbComponent_ng_template_1_Template, 1, 1, "ng-template", 1);
        ɵngcc0.ɵɵpipe(2, "async");
        ɵngcc0.ɵɵprojection(3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind1(2, 1, ctx.breadcrumbs));
    } }, directives: [ɵngcc4.NgForOf, ɵngcc4.NgIf, ɵngcc4.NgClass, ɵngcc3.RouterLinkWithHref, ɵngcc3.RouterLink], pipes: [ɵngcc4.AsyncPipe], encapsulation: 2 });
AppBreadcrumbComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] },
    { type: Renderer2 },
    { type: AppBreadcrumbService }
];
AppBreadcrumbComponent.propDecorators = {
    fixed: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AppBreadcrumbComponent, [{
        type: Component,
        args: [{
                selector: 'app-breadcrumb cui-breadcrumb',
                template: "<ol class=\"breadcrumb\">\n  <ng-template ngFor let-breadcrumb [ngForOf]=\"breadcrumbs | async\" let-last = last>\n    <li class=\"breadcrumb-item\"\n        *ngIf=\"breadcrumb.label.title && (breadcrumb.url.slice(-1) == '/' || last)\"\n        [ngClass]=\"{active: last}\">\n      <a *ngIf=\"!last\" [routerLink]=\"breadcrumb.url\">{{breadcrumb.label.title}}</a>\n      <span *ngIf=\"last\" [routerLink]=\"breadcrumb.url\">{{breadcrumb.label.title}}</span>\n    </li>\n  </ng-template>\n  <ng-content></ng-content>\n</ol>"
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }, { type: ɵngcc0.Renderer2 }, { type: AppBreadcrumbService }]; }, { fixed: [{
            type: Input
        }] }); })();

// @dynamic
class AppBreadcrumbModule {
    static forRoot(config) {
        return {
            ngModule: AppBreadcrumbModule,
            providers: [
                AppBreadcrumbService
            ]
        };
    }
}
AppBreadcrumbModule.ɵfac = function AppBreadcrumbModule_Factory(t) { return new (t || AppBreadcrumbModule)(); };
AppBreadcrumbModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: AppBreadcrumbModule });
AppBreadcrumbModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, RouterModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AppBreadcrumbModule, { declarations: function () { return [AppBreadcrumbComponent]; }, imports: function () { return [CommonModule, RouterModule]; }, exports: function () { return [AppBreadcrumbComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AppBreadcrumbModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, RouterModule],
                exports: [AppBreadcrumbComponent],
                declarations: [AppBreadcrumbComponent]
            }]
    }], null, null); })();

class AppFooterComponent {
    constructor(document, renderer) {
        this.document = document;
        this.renderer = renderer;
        this.fixedClass = 'footer-fixed';
        this._footer = true;
    }
    ngOnInit() {
        this.isFixed(this.fixed);
    }
    ngOnDestroy() {
        this.renderer.removeClass(this.document.body, this.fixedClass);
    }
    isFixed(fixed = this.fixed) {
        if (fixed) {
            this.renderer.addClass(this.document.body, this.fixedClass);
        }
    }
}
AppFooterComponent.ɵfac = function AppFooterComponent_Factory(t) { return new (t || AppFooterComponent)(ɵngcc0.ɵɵdirectiveInject(DOCUMENT), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
AppFooterComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AppFooterComponent, selectors: [["app-footer-admin"]], hostVars: 2, hostBindings: function AppFooterComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("app-footer", ctx._footer);
    } }, inputs: { fixed: "fixed" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function AppFooterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2 });
AppFooterComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] },
    { type: Renderer2 }
];
AppFooterComponent.propDecorators = {
    fixed: [{ type: Input }],
    _footer: [{ type: HostBinding, args: ['class.app-footer',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AppFooterComponent, [{
        type: Component,
        args: [{
                selector: 'app-footer-admin',
                template: `<ng-content></ng-content>`
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }, { type: ɵngcc0.Renderer2 }]; }, { _footer: [{
            type: HostBinding,
            args: ['class.app-footer']
        }], fixed: [{
            type: Input
        }] }); })();

class AppFooterModule {
}
AppFooterModule.ɵfac = function AppFooterModule_Factory(t) { return new (t || AppFooterModule)(); };
AppFooterModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: AppFooterModule });
AppFooterModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AppFooterModule, { declarations: function () { return [AppFooterComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [AppFooterComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AppFooterModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                exports: [AppFooterComponent],
                declarations: [AppFooterComponent]
            }]
    }], null, null); })();

const DEFAULT_PERFECT_SCROLLBAR_CONFIG = {
    suppressScrollX: true
};
class AdminModule {
}
AdminModule.ɵfac = function AdminModule_Factory(t) { return new (t || AdminModule)(); };
AdminModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: AdminModule });
AdminModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ providers: [
        CommonFunctionsService,
    ], imports: [[
            CommonModule,
            AppHeaderAdminModule,
            AppSidebarModule,
            AppBreadcrumbModule.forRoot(),
            AppFooterModule,
            LayoutModule,
            RouterModule,
            PerfectScrollbarModule,
            BsDropdownModule.forRoot()
        ], LayoutModule, AppBreadcrumbModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AdminModule, { declarations: function () { return [AdminComponent]; }, imports: function () { return [CommonModule, AppHeaderAdminModule, AppSidebarModule, AppBreadcrumbModule, AppFooterModule, LayoutModule, RouterModule,
        PerfectScrollbarModule, ɵngcc1.BsDropdownModule]; }, exports: function () { return [AdminComponent, LayoutModule, AppBreadcrumbModule]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AdminModule, [{
        type: NgModule,
        args: [{
                declarations: [AdminComponent],
                imports: [
                    CommonModule,
                    AppHeaderAdminModule,
                    AppSidebarModule,
                    AppBreadcrumbModule.forRoot(),
                    AppFooterModule,
                    LayoutModule,
                    RouterModule,
                    PerfectScrollbarModule,
                    BsDropdownModule.forRoot()
                ],
                providers: [
                    CommonFunctionsService,
                ],
                exports: [
                    AdminComponent,
                    LayoutModule,
                    AppBreadcrumbModule
                ]
            }]
    }], null, null); })();

class LandingComponent {
    constructor(cf) {
        this.cf = cf;
        /**
         * @description Output quando clica no botão logout
         * Para esse método funcionar o parâmetro `enableLogout` devera estar setado como "true"
         */
        this.onLogout = new EventEmitter();
        /**
         * @description Logo
         * @default assets/dotz-images/logo_dotz.jpg
         */
        this.logo = 'assets/dotz-images/logo_dotz.jpg';
        /**
         * @description Quando o valor é true, é adicionado os botões padrão do site dotz (entrar e cadastrar)
         * @default true
         */
        this.isButtonEnable = true;
        /**
         * @description Remove o padding da imagem quando o valor for false. Quando o valor for true, irá adicionar um padding de 7 px na imagem
         * @default true
         */
        this.isFullLogo = true;
        /**
         * @description Remove o footer
         * @default true
         */
        this.hasFooter = true;
        /**
         * @description Caso o usuario esta logado ou nao
         * @default false
         */
        this.isLoggedIn = false;
        /**
        * @description Mostrar botao signup
        */
        this.showSignupButton = true;
        /**
        * @description Mostrar botao de login
        */
        this.showLoginButton = true;
        /**
         * @description nome que ira aparecer no header
         */
        this.username = 'Strike';
        /**
         * @description Rota default quando clica no logo
         */
        this.defaultRoute = '/';
        /**
         * @description URL que o usuario sera redirecionado quando clica no botao de login
         */
        this.loginURL = 'https://login.dotz.com.br/';
        /**
         * @description URL que o usuario sera redirecionado quando clica no botao de cadastro
         */
        this.signupURL = 'https://login.dotz.com.br?cadastro=true';
        /**
         * @description URL do iframe
         */
        this.accountsIframeUrl = 'https://login.dotz.com.br/';
    }
}
LandingComponent.ɵfac = function LandingComponent_Factory(t) { return new (t || LandingComponent)(ɵngcc0.ɵɵdirectiveInject(CommonFunctionsService)); };
LandingComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: LandingComponent, selectors: [["landing"]], inputs: { logo: "logo", isButtonEnable: "isButtonEnable", isFullLogo: "isFullLogo", hasFooter: "hasFooter", isLoggedIn: "isLoggedIn", showSignupButton: "showSignupButton", showLoginButton: "showLoginButton", username: "username", defaultRoute: "defaultRoute", loginURL: "loginURL", signupURL: "signupURL", accountsIframeUrl: "accountsIframeUrl" }, outputs: { onLogout: "onLogout" }, ngContentSelectors: _c0, decls: 6, vars: 15, consts: [[3, "isLoggedIn", "isFullLogo", "logo", "defaultRoute", "showLoginButton", "showSignupButton", "username", "signupURL", "loginURL", "isButtonEnable", "onLogout"], [1, "container"], [4, "ngIf"], ["id", "iframe-sso", 2, "display", "none", 3, "src"]], template: function LandingComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "ngx-header", 0);
        ɵngcc0.ɵɵlistener("onLogout", function LandingComponent_Template_ngx_header_onLogout_0_listener($event) { return ctx.onLogout.emit($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(3, LandingComponent_ngx_footer_3_Template, 1, 0, "ngx-footer", 2);
        ɵngcc0.ɵɵelement(4, "iframe", 3);
        ɵngcc0.ɵɵpipe(5, "safe");
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("isLoggedIn", ctx.isLoggedIn)("isFullLogo", ctx.isFullLogo)("logo", ctx.logo)("defaultRoute", ctx.defaultRoute)("showLoginButton", ctx.showLoginButton)("showSignupButton", ctx.showSignupButton)("username", ctx.username)("signupURL", ctx.signupURL)("loginURL", ctx.loginURL)("isButtonEnable", ctx.isButtonEnable);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hasFooter && !ctx.cf.isMobile());
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("src", ɵngcc0.ɵɵpipeBind2(5, 12, ctx.accountsIframeUrl, "resourceUrl"), ɵngcc0.ɵɵsanitizeResourceUrl);
    } }, directives: function () { return [HeaderComponent, ɵngcc4.NgIf, FooterComponent]; }, pipes: function () { return [SafePipe]; }, styles: [".container[_ngcontent-%COMP%]{min-height:50vh;padding:60px}@media (max-width:768px){.content[_ngcontent-%COMP%]{padding-top:83px!important;max-width:unset!important;width:100%}ngx-footer[_ngcontent-%COMP%]{visibility:hidden!important}}app-root[_ngcontent-%COMP%]{background-color:#fff!important}"] });
LandingComponent.ctorParameters = () => [
    { type: CommonFunctionsService }
];
LandingComponent.propDecorators = {
    onLogout: [{ type: Output }],
    logo: [{ type: Input }],
    isButtonEnable: [{ type: Input }],
    isFullLogo: [{ type: Input }],
    hasFooter: [{ type: Input }],
    isLoggedIn: [{ type: Input }],
    showSignupButton: [{ type: Input }],
    showLoginButton: [{ type: Input }],
    username: [{ type: Input }],
    defaultRoute: [{ type: Input }],
    loginURL: [{ type: Input }],
    signupURL: [{ type: Input }],
    accountsIframeUrl: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LandingComponent, [{
        type: Component,
        args: [{
                selector: 'landing',
                template: "<ngx-header \n    [isLoggedIn]=\"isLoggedIn\"\n    [isFullLogo]=\"isFullLogo\" \n    [logo]=\"logo\" \n    [defaultRoute]=\"defaultRoute\"\n    [showLoginButton]=\"showLoginButton\"\n    [showSignupButton]=\"showSignupButton\"\n    [username]=\"username\"\n    [signupURL]=\"signupURL\"\n    [loginURL]=\"loginURL\"\n    [isButtonEnable]=\"isButtonEnable\" \n    (onLogout)=\"onLogout.emit($event)\">\n</ngx-header>\n\n<div class=\"container\">\n    <ng-content></ng-content>\n</div>\n\n<ngx-footer *ngIf=\"hasFooter && !cf.isMobile()\"></ngx-footer>\n\n<iframe style=\"display:none\" [src]=\"accountsIframeUrl | safe: 'resourceUrl'\" id=\"iframe-sso\"></iframe>",
                styles: [".container{min-height:50vh;padding:60px}@media (max-width:768px){.content{padding-top:83px!important;max-width:unset!important;width:100%}ngx-footer{visibility:hidden!important}}app-root{background-color:#fff!important}"]
            }]
    }], function () { return [{ type: CommonFunctionsService }]; }, { onLogout: [{
            type: Output
        }], logo: [{
            type: Input
        }], isButtonEnable: [{
            type: Input
        }], isFullLogo: [{
            type: Input
        }], hasFooter: [{
            type: Input
        }], isLoggedIn: [{
            type: Input
        }], showSignupButton: [{
            type: Input
        }], showLoginButton: [{
            type: Input
        }], username: [{
            type: Input
        }], defaultRoute: [{
            type: Input
        }], loginURL: [{
            type: Input
        }], signupURL: [{
            type: Input
        }], accountsIframeUrl: [{
            type: Input
        }] }); })();

class HeaderComponent {
    constructor(cf) {
        this.cf = cf;
        this.onLogout = new EventEmitter();
        this.logo = 'assets/images/logo-dotz-cortado.jpg';
        this.defaultRoute = '/';
        this.showToogle = false;
    }
    goToHome() {
        window.location.href = '/';
    }
    showToggle() {
        setTimeout(() => {
            this.showToogle = this.showToogle ? false : true;
        }, 100);
        if (this.cf.isMobile()) {
            return;
        }
        setTimeout(() => {
            this.showToogle = false;
        }, 3000);
    }
    logout() {
        this.onLogout.emit(true);
    }
}
HeaderComponent.ɵfac = function HeaderComponent_Factory(t) { return new (t || HeaderComponent)(ɵngcc0.ɵɵdirectiveInject(CommonFunctionsService)); };
HeaderComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: HeaderComponent, selectors: [["ngx-header"]], inputs: { logo: "logo", defaultRoute: "defaultRoute", isButtonEnable: "isButtonEnable", isFullLogo: "isFullLogo", isLoggedIn: "isLoggedIn", username: "username", showSignupButton: "showSignupButton", showLoginButton: "showLoginButton", loginURL: "loginURL", signupURL: "signupURL" }, outputs: { onLogout: "onLogout" }, decls: 8, vars: 5, consts: [["id", "header"], [1, "container"], ["id", "logo", 1, "pull-left"], [1, "scrollto", 3, "href"], [3, "ngClass", "src"], ["id", "nav-menu-container", 4, "ngIf"], ["id", "toogle-mobile", 4, "ngIf"], ["id", "nav-menu-container"], ["class", "nav-menu", 4, "ngIf"], ["class", "nav-menu user-info-father", 3, "click", 4, "ngIf"], [1, "nav-menu"], ["id", "header-login-btn", "class", "unlogged-li", 4, "ngIf"], ["id", "header-signup-btn", "class", "unlogged-li", 4, "ngIf"], ["id", "header-login-btn", 1, "unlogged-li"], [3, "href"], [1, "help-text", "btn-entrar"], ["id", "header-signup-btn", 1, "unlogged-li"], [1, "help-text", "btn-voltar"], [1, "nav-menu", "user-info-father", 3, "click"], [1, "logged-li"], [1, "user-div"], ["src", "https://www.dotz.com.br/assets/dotz/img/new-site-content/ic_profile_header.png"], [1, "user-info", "logged-li"], ["id", "toogle-web", 4, "ngIf"], ["id", "toogle-web"], [3, "isLoggedIn", "defaultRoute", "username", "signupURL", "loginURL", "isButtonEnable", "onLogout"], ["id", "toogle-mobile"]], template: function HeaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "header", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "h1");
        ɵngcc0.ɵɵelementStart(4, "a", 3);
        ɵngcc0.ɵɵelement(5, "img", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(6, HeaderComponent_nav_6_Template, 3, 2, "nav", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(7, HeaderComponent_div_7_Template, 2, 6, "div", 6);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵpropertyInterpolate("href", ctx.defaultRoute, ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ctx.isFullLogo ? "logo-dotz-full" : "logo-dotz")("src", ctx.logo, ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isButtonEnable);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showToogle);
    } }, directives: function () { return [ɵngcc4.NgClass, ɵngcc4.NgIf, ToogleInformationComponent]; }, styles: [".logo-dotz[_ngcontent-%COMP%]{height:60px;position:absolute;padding:7px}.user-div[_ngcontent-%COMP%]{cursor:pointer;width:50px;height:50px;border-radius:50%;display:inline-block}.user-div[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{margin-top:-5px}.user-info[_ngcontent-%COMP%]{cursor:pointer}.user-info[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{color:#fff}.border-top[_ngcontent-%COMP%]{border-top:1px solid #aaa}.logo-dotz-full[_ngcontent-%COMP%]{height:60px;position:absolute}.fa-info-circle[_ngcontent-%COMP%]{font-size:40px}.help-text[_ngcontent-%COMP%]{display:block;margin-top:-34px!important;margin-left:42px!important}#header.header-scrolled[_ngcontent-%COMP%]{background:#fff;padding:20px 0;height:72px;transition:all .5s}#header[_ngcontent-%COMP%]{padding:30px 0;position:fixed;left:0;height:0;top:0;right:0;z-index:997;background-color:#f29433}#header[_ngcontent-%COMP%]   #logo[_ngcontent-%COMP%]   h1[_ngcontent-%COMP%]{font-size:34px;padding:0;line-height:1;font-family:Montserrat,sans-serif;font-weight:700;letter-spacing:3px;margin:-29.95px 0 0}#header[_ngcontent-%COMP%]   #logo[_ngcontent-%COMP%]   h1[_ngcontent-%COMP%]   a[_ngcontent-%COMP%], #header[_ngcontent-%COMP%]   #logo[_ngcontent-%COMP%]   h1[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:hover{color:#fff;font-size:22px;font-weight:600;padding-left:10px}#nav-menu-container[_ngcontent-%COMP%]{float:right;margin:0}.nav-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]{margin-top:-15px}.nav-menu[_ngcontent-%COMP%]{display:flex;flex-wrap:nowrap}.nav-menu[_ngcontent-%COMP%]   #logged-li[_ngcontent-%COMP%]{width:52px}.nav-menu[_ngcontent-%COMP%]   .unlogged-li[_ngcontent-%COMP%]{width:160px}.nav-menu[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{position:relative;white-space:nowrap}.nav-menu[_ngcontent-%COMP%], .nav-menu[_ngcontent-%COMP%]   *[_ngcontent-%COMP%]{margin:0;padding:0;list-style:none}.header-scrolled[_ngcontent-%COMP%]   .nav-menu[_ngcontent-%COMP%] > .menu-active[_ngcontent-%COMP%] > a[_ngcontent-%COMP%], .header-scrolled[_ngcontent-%COMP%]   .nav-menu[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:hover > a[_ngcontent-%COMP%]{color:#f7941d}.header-scrolled[_ngcontent-%COMP%]   .nav-menu[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:#000}.nav-menu[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{padding:0 8px 10px;text-decoration:none;display:inline-block;color:#fff;font-family:Montserrat,sans-serif;font-weight:700;font-size:18px;text-transform:uppercase;outline:none}#mobile-nav-toggle[_ngcontent-%COMP%]{display:inline;position:fixed;right:0;top:0;z-index:999;margin:20px 20px 0 0;border:0;background:none;font-size:24px;transition:all .4s;outline:none;cursor:pointer}#mobile-body-overly[_ngcontent-%COMP%]{width:100%;height:100%;z-index:997;top:0;left:0;position:fixed;background:rgba(0,0,0,.7)}body.mobile-nav-active[_ngcontent-%COMP%]   #mobile-nav[_ngcontent-%COMP%]{left:0}#mobile-nav[_ngcontent-%COMP%]{position:fixed;top:0;padding-top:18px;bottom:0;z-index:998;background:rgba(0,0,0,.8);left:-260px;width:260px;overflow-y:auto;transition:.4s}#mobile-nav[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{padding:0;margin:0;list-style:none}#mobile-nav[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{position:relative}#mobile-nav[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:#fff;font-size:13px;text-transform:uppercase;overflow:hidden;padding:10px 22px 10px 15px;position:relative;text-decoration:none;width:100%;display:block;outline:none;font-weight:700;font-family:Montserrat,sans-serif}#mobile-nav[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   .menu-has-children[_ngcontent-%COMP%]   i.fa-chevron-up[_ngcontent-%COMP%]{color:#18d26e}#mobile-nav[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   .menu-has-children[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{position:absolute;right:0;z-index:99;padding:15px;cursor:pointer;color:#fff}#mobile-nav[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   .menu-item-active[_ngcontent-%COMP%]{color:#18d26e}#mobile-nav[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{padding-left:30px}.btn-entrar[_ngcontent-%COMP%]{background-color:#f8df68;color:#172860}.btn-entrar[_ngcontent-%COMP%], .btn-voltar[_ngcontent-%COMP%]{-webkit-border-radius:10em;height:38px;border:none;border-radius:10em;padding:10px 0;font-size:14px;width:100px;display:inline-block;text-align:center}.btn-voltar[_ngcontent-%COMP%]{background-color:#243f75;color:#fff;margin-left:-1px!important}#toogle-mobile[_ngcontent-%COMP%]{display:none;padding-top:60px}@media (max-width:800px){#header-signup-btn[_ngcontent-%COMP%], #toogle-web[_ngcontent-%COMP%]{display:none}#toogle-mobile[_ngcontent-%COMP%]{padding-top:unset!important;display:block}}"] });
HeaderComponent.ctorParameters = () => [
    { type: CommonFunctionsService }
];
HeaderComponent.propDecorators = {
    onLogout: [{ type: Output }],
    logo: [{ type: Input }],
    isButtonEnable: [{ type: Input }],
    isFullLogo: [{ type: Input }],
    isLoggedIn: [{ type: Input }],
    username: [{ type: Input }],
    defaultRoute: [{ type: Input }],
    showSignupButton: [{ type: Input }],
    showLoginButton: [{ type: Input }],
    loginURL: [{ type: Input }],
    signupURL: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HeaderComponent, [{
        type: Component,
        args: [{
                selector: 'ngx-header',
                template: "<header id=\"header\">\n\n  <div class=\"container\">\n\n    <div id=\"logo\" class=\"pull-left\">\n      <h1>\n        <a href=\"{{ defaultRoute }}\" class=\"scrollto\">\n          <img [ngClass]=\"isFullLogo ? 'logo-dotz-full' : 'logo-dotz'\" [src]=\"logo\">\n        </a>\n      </h1>\n    </div>\n\n    <nav id=\"nav-menu-container\" *ngIf=\"isButtonEnable\">\n      <ul class=\"nav-menu\" *ngIf=\"!isLoggedIn\">\n        <li id=\"header-login-btn\" class=\"unlogged-li\" *ngIf=\"showLoginButton\">\n          <a [href]=\"loginURL\">\n            <button class=\"help-text btn-entrar\">Entrar</button>\n          </a>\n        </li>\n        <li id=\"header-signup-btn\" class=\"unlogged-li\" *ngIf=\"showSignupButton\">\n          <a [href]=\"signupURL\">\n            <button class=\"help-text btn-voltar\">Cadastrar</button>\n          </a>\n        </li>\n      </ul>\n\n      <ul class=\"nav-menu user-info-father\" *ngIf=\"isLoggedIn\" (click)=\"showToggle()\">\n        <li class=\"logged-li\">\n          <div class=\"user-div\">\n            <img src=\"https://www.dotz.com.br/assets/dotz/img/new-site-content/ic_profile_header.png\">\n          </div>\n        </li>\n        <li class=\"user-info logged-li\">\n          <p>Ol\u00E1 {{ username }}</p>\n\n          <div id=\"toogle-web\" *ngIf=\"showToogle\">\n            <app-toogle-information \n              [isLoggedIn]=\"isLoggedIn\"\n              [defaultRoute]=\"defaultRoute\"\n              [username]=\"username\"\n              [signupURL]=\"signupURL\"\n              [loginURL]=\"loginURL\"\n              [isButtonEnable]=\"isButtonEnable\" \n              (onLogout)=\"onLogout.emit()\">\n            </app-toogle-information>\n          </div>\n        </li>\n      </ul>\n    </nav>\n  </div>\n</header>\n\n<div id=\"toogle-mobile\" *ngIf=\"showToogle\">\n  <app-toogle-information\n    [isLoggedIn]=\"isLoggedIn\"\n    [defaultRoute]=\"defaultRoute\"\n    [username]=\"username\"\n    [signupURL]=\"signupURL\"\n    [loginURL]=\"loginURL\"\n    [isButtonEnable]=\"isButtonEnable\" \n    (onLogout)=\"onLogout.emit()\">\n  </app-toogle-information>\n</div>",
                styles: [".logo-dotz{height:60px;position:absolute;padding:7px}.user-div{cursor:pointer;width:50px;height:50px;border-radius:50%;display:inline-block}.user-div img{margin-top:-5px}.user-info{cursor:pointer}.user-info p{color:#fff}.border-top{border-top:1px solid #aaa}.logo-dotz-full{height:60px;position:absolute}.fa-info-circle{font-size:40px}.help-text{display:block;margin-top:-34px!important;margin-left:42px!important}#header.header-scrolled{background:#fff;padding:20px 0;height:72px;transition:all .5s}#header{padding:30px 0;position:fixed;left:0;height:0;top:0;right:0;z-index:997;background-color:#f29433}#header #logo h1{font-size:34px;padding:0;line-height:1;font-family:Montserrat,sans-serif;font-weight:700;letter-spacing:3px;margin:-29.95px 0 0}#header #logo h1 a,#header #logo h1 a:hover{color:#fff;font-size:22px;font-weight:600;padding-left:10px}#nav-menu-container{float:right;margin:0}.nav-menu>li{margin-top:-15px}.nav-menu{display:flex;flex-wrap:nowrap}.nav-menu #logged-li{width:52px}.nav-menu .unlogged-li{width:160px}.nav-menu li{position:relative;white-space:nowrap}.nav-menu,.nav-menu *{margin:0;padding:0;list-style:none}.header-scrolled .nav-menu>.menu-active>a,.header-scrolled .nav-menu li:hover>a{color:#f7941d}.header-scrolled .nav-menu a{color:#000}.nav-menu a{padding:0 8px 10px;text-decoration:none;display:inline-block;color:#fff;font-family:Montserrat,sans-serif;font-weight:700;font-size:18px;text-transform:uppercase;outline:none}#mobile-nav-toggle{display:inline;position:fixed;right:0;top:0;z-index:999;margin:20px 20px 0 0;border:0;background:none;font-size:24px;transition:all .4s;outline:none;cursor:pointer}#mobile-body-overly{width:100%;height:100%;z-index:997;top:0;left:0;position:fixed;background:rgba(0,0,0,.7)}body.mobile-nav-active #mobile-nav{left:0}#mobile-nav{position:fixed;top:0;padding-top:18px;bottom:0;z-index:998;background:rgba(0,0,0,.8);left:-260px;width:260px;overflow-y:auto;transition:.4s}#mobile-nav ul{padding:0;margin:0;list-style:none}#mobile-nav ul li{position:relative}#mobile-nav ul li a{color:#fff;font-size:13px;text-transform:uppercase;overflow:hidden;padding:10px 22px 10px 15px;position:relative;text-decoration:none;width:100%;display:block;outline:none;font-weight:700;font-family:Montserrat,sans-serif}#mobile-nav ul .menu-has-children i.fa-chevron-up{color:#18d26e}#mobile-nav ul .menu-has-children i{position:absolute;right:0;z-index:99;padding:15px;cursor:pointer;color:#fff}#mobile-nav ul .menu-item-active{color:#18d26e}#mobile-nav ul li li{padding-left:30px}.btn-entrar{background-color:#f8df68;color:#172860}.btn-entrar,.btn-voltar{-webkit-border-radius:10em;height:38px;border:none;border-radius:10em;padding:10px 0;font-size:14px;width:100px;display:inline-block;text-align:center}.btn-voltar{background-color:#243f75;color:#fff;margin-left:-1px!important}#toogle-mobile{display:none;padding-top:60px}@media (max-width:800px){#header-signup-btn,#toogle-web{display:none}#toogle-mobile{padding-top:unset!important;display:block}}"]
            }]
    }], function () { return [{ type: CommonFunctionsService }]; }, { onLogout: [{
            type: Output
        }], logo: [{
            type: Input
        }], defaultRoute: [{
            type: Input
        }], isButtonEnable: [{
            type: Input
        }], isFullLogo: [{
            type: Input
        }], isLoggedIn: [{
            type: Input
        }], username: [{
            type: Input
        }], showSignupButton: [{
            type: Input
        }], showLoginButton: [{
            type: Input
        }], loginURL: [{
            type: Input
        }], signupURL: [{
            type: Input
        }] }); })();

class ToogleInformationComponent {
    constructor(cf) {
        this.cf = cf;
        this.onLogout = new EventEmitter();
        this.logo = 'assets/images/logo-dotz-cortado.jpg';
        this.defaultRoute = '/';
    }
    goToHome() {
        window.location.href = '/';
    }
    logout() {
        this.onLogout.emit(true);
    }
}
ToogleInformationComponent.ɵfac = function ToogleInformationComponent_Factory(t) { return new (t || ToogleInformationComponent)(ɵngcc0.ɵɵdirectiveInject(CommonFunctionsService)); };
ToogleInformationComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ToogleInformationComponent, selectors: [["app-toogle-information"]], inputs: { logo: "logo", defaultRoute: "defaultRoute", isButtonEnable: "isButtonEnable", isFullLogo: "isFullLogo", isLoggedIn: "isLoggedIn", username: "username", showSignupButton: "showSignupButton", showLoginButton: "showLoginButton", loginURL: "loginURL", signupURL: "signupURL" }, outputs: { onLogout: "onLogout" }, decls: 27, vars: 1, consts: [[1, "toggle-information"], [1, "row"], [1, "col-sm-12", "username-div", "box"], [1, "username"], [1, "col-sm-3", "icons-div", "box", "text-center", 2, "border-right", "none"], ["href", "https://www.dotz.com.br/dashboard/extrato"], ["src", "https://www.dotz.com.br/assets/dotz/img/new-site-content/extrato_icon.png", "id", "extrato"], [1, "icons-div-name"], ["href", "https://www.dotz.com.br/dashboard/trocas"], ["src", "https://www.dotz.com.br/assets/dotz/img/new-site-content/trocas_icon.png", "id", "minhas-trocas"], ["href", "https://www.dotz.com.br/dashboard/clubedotz"], ["src", "https://www.dotz.com.br/assets/dotz/img/new-site-content/clubedotz_icon.png", "id", "clube-dotz"], [1, "col-sm-3", "icons-div", "box", "text-center"], ["href", "https://www.dotz.com.br/dashboard/meus-dados"], ["src", "https://www.dotz.com.br/assets/dotz/img/new-site-content/configuracoes_icon.png"], [1, "col-sm-12", "logout-div", "box", "text-right", "border-top"], ["src", "https://www.dotz.com.br/assets/dotz/img/new-site-content/sair_icon.png", 1, "logout-btn", 3, "click"]], template: function ToogleInformationComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 4);
        ɵngcc0.ɵɵelementStart(6, "a", 5);
        ɵngcc0.ɵɵelement(7, "img", 6);
        ɵngcc0.ɵɵelementStart(8, "p", 7);
        ɵngcc0.ɵɵtext(9, "Meu Extrato");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "div", 4);
        ɵngcc0.ɵɵelementStart(11, "a", 8);
        ɵngcc0.ɵɵelement(12, "img", 9);
        ɵngcc0.ɵɵelementStart(13, "p", 7);
        ɵngcc0.ɵɵtext(14, "Minhas Trocas");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(15, "div", 4);
        ɵngcc0.ɵɵelementStart(16, "a", 10);
        ɵngcc0.ɵɵelement(17, "img", 11);
        ɵngcc0.ɵɵelementStart(18, "p", 7);
        ɵngcc0.ɵɵtext(19, "Clube Dotz");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(20, "div", 12);
        ɵngcc0.ɵɵelementStart(21, "a", 13);
        ɵngcc0.ɵɵelement(22, "img", 14);
        ɵngcc0.ɵɵelementStart(23, "p", 7);
        ɵngcc0.ɵɵtext(24, "Configura\u00E7\u00F5es");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(25, "div", 15);
        ɵngcc0.ɵɵelementStart(26, "img", 16);
        ɵngcc0.ɵɵlistener("click", function ToogleInformationComponent_Template_img_click_26_listener() { return ctx.onLogout.emit(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate1("Ol\u00E1 ", ctx.username, "");
    } }, styles: [".row[_ngcontent-%COMP%]{margin-left:unset!important;margin-right:unset!important}.toggle-information[_ngcontent-%COMP%]{border-radius:10px;width:420px;margin-left:50px;position:absolute;margin-top:24px;background-color:#fff;right:0}.toggle-information[_ngcontent-%COMP%]   .username-div[_ngcontent-%COMP%]{border-bottom:1px solid #aaa}.toggle-information[_ngcontent-%COMP%]   .username-div[_ngcontent-%COMP%]   .username[_ngcontent-%COMP%]{color:#5f5f5f;font-weight:700;padding:10px 30px 10px 10px}.toggle-information[_ngcontent-%COMP%]   .logout-div[_ngcontent-%COMP%]{padding:10px}.toggle-information[_ngcontent-%COMP%]   .logout-div[_ngcontent-%COMP%]   .logout-btn[_ngcontent-%COMP%]{width:20px;color:#5f5f5f}.toggle-information[_ngcontent-%COMP%]   .icons-div[_ngcontent-%COMP%]{padding:20px 0 40px;height:100px}.toggle-information[_ngcontent-%COMP%]   .icons-div[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:35px}.toggle-information[_ngcontent-%COMP%]   .icons-div[_ngcontent-%COMP%]   .icons-div-name[_ngcontent-%COMP%]{font-size:13px!important;text-transform:capitalize!important;color:#5f5f5f}.toggle-information[_ngcontent-%COMP%]   .border-top[_ngcontent-%COMP%]{border-top:1px solid #aaa}.toggle-information[_ngcontent-%COMP%]   #extrato[_ngcontent-%COMP%]{width:36px}.toggle-information[_ngcontent-%COMP%]   #minhas-trocas[_ngcontent-%COMP%]{width:44px}.toggle-information[_ngcontent-%COMP%]   #clube-dotz[_ngcontent-%COMP%]{width:39px}.toggle-information[_ngcontent-%COMP%]   .logo-dotz-full[_ngcontent-%COMP%]{height:60px;position:absolute}.toggle-information[_ngcontent-%COMP%]   .fa-info-circle[_ngcontent-%COMP%]{font-size:40px}.toggle-information[_ngcontent-%COMP%]   .help-text[_ngcontent-%COMP%]{display:block;margin-top:-34px!important;margin-left:42px!important}.toggle-information[_ngcontent-%COMP%]   #header.header-scrolled[_ngcontent-%COMP%]{background:#fff;padding:20px 0;height:72px;transition:all .5s}.toggle-information[_ngcontent-%COMP%]   #header[_ngcontent-%COMP%]{padding:30px 0;height:50px;position:fixed;left:0;top:0;right:0;z-index:997;background-color:#f29433}.toggle-information[_ngcontent-%COMP%]   #header[_ngcontent-%COMP%]   #logo[_ngcontent-%COMP%]   h1[_ngcontent-%COMP%]{font-size:34px;padding:0;line-height:1;font-family:Montserrat,sans-serif;font-weight:700;letter-spacing:3px;margin:-29.95px 0 0}.toggle-information[_ngcontent-%COMP%]   #header[_ngcontent-%COMP%]   #logo[_ngcontent-%COMP%]   h1[_ngcontent-%COMP%]   a[_ngcontent-%COMP%], .toggle-information[_ngcontent-%COMP%]   #header[_ngcontent-%COMP%]   #logo[_ngcontent-%COMP%]   h1[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:hover{color:#fff;font-size:22px;font-weight:600;padding-left:10px}.toggle-information[_ngcontent-%COMP%]   #nav-menu-container[_ngcontent-%COMP%]{float:right;margin:0}.toggle-information[_ngcontent-%COMP%]   .nav-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]{margin-top:-15px;float:left}.toggle-information[_ngcontent-%COMP%]   .nav-menu[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{position:relative;white-space:nowrap}.toggle-information[_ngcontent-%COMP%]   .nav-menu[_ngcontent-%COMP%], .toggle-information[_ngcontent-%COMP%]   .nav-menu[_ngcontent-%COMP%]   *[_ngcontent-%COMP%]{margin:0;padding:0;list-style:none}.toggle-information[_ngcontent-%COMP%]   .header-scrolled[_ngcontent-%COMP%]   .nav-menu[_ngcontent-%COMP%] > .menu-active[_ngcontent-%COMP%] > a[_ngcontent-%COMP%], .toggle-information[_ngcontent-%COMP%]   .header-scrolled[_ngcontent-%COMP%]   .nav-menu[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:hover > a[_ngcontent-%COMP%]{color:#f7941d}.toggle-information[_ngcontent-%COMP%]   .header-scrolled[_ngcontent-%COMP%]   .nav-menu[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:#000}.toggle-information[_ngcontent-%COMP%]   .nav-menu[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{padding:0 8px 10px;text-decoration:none;display:inline-block;color:#fff;font-family:Montserrat,sans-serif;font-weight:700;font-size:18px;text-transform:uppercase;outline:none}.toggle-information[_ngcontent-%COMP%]   #mobile-nav-toggle[_ngcontent-%COMP%]{display:inline;position:fixed;right:0;top:0;z-index:999;margin:20px 20px 0 0;border:0;background:none;font-size:24px;transition:all .4s;outline:none;cursor:pointer}.toggle-information[_ngcontent-%COMP%]   #mobile-body-overly[_ngcontent-%COMP%]{width:100%;height:100%;z-index:997;top:0;left:0;position:fixed;background:rgba(0,0,0,.7)}.toggle-information[_ngcontent-%COMP%]   body.mobile-nav-active[_ngcontent-%COMP%]   #mobile-nav[_ngcontent-%COMP%]{left:0}.toggle-information[_ngcontent-%COMP%]   #mobile-nav[_ngcontent-%COMP%]{position:fixed;top:0;padding-top:18px;bottom:0;z-index:998;background:rgba(0,0,0,.8);left:-260px;width:260px;overflow-y:auto;transition:.4s}.toggle-information[_ngcontent-%COMP%]   #mobile-nav[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{padding:0;margin:0;list-style:none}.toggle-information[_ngcontent-%COMP%]   #mobile-nav[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{position:relative}.toggle-information[_ngcontent-%COMP%]   #mobile-nav[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:#fff;font-size:13px;text-transform:uppercase;overflow:hidden;padding:10px 22px 10px 15px;position:relative;text-decoration:none;width:100%;display:block;outline:none;font-weight:700;font-family:Montserrat,sans-serif}.toggle-information[_ngcontent-%COMP%]   #mobile-nav[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   .menu-has-children[_ngcontent-%COMP%]   i.fa-chevron-up[_ngcontent-%COMP%]{color:#18d26e}.toggle-information[_ngcontent-%COMP%]   #mobile-nav[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   .menu-has-children[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{position:absolute;right:0;z-index:99;padding:15px;cursor:pointer;color:#fff}.toggle-information[_ngcontent-%COMP%]   #mobile-nav[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   .menu-item-active[_ngcontent-%COMP%]{color:#18d26e}.toggle-information[_ngcontent-%COMP%]   #mobile-nav[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{padding-left:30px}.toggle-information[_ngcontent-%COMP%]   .btn-entrar[_ngcontent-%COMP%]{background-color:#f8df68;color:#172860}.toggle-information[_ngcontent-%COMP%]   .btn-entrar[_ngcontent-%COMP%], .toggle-information[_ngcontent-%COMP%]   .btn-voltar[_ngcontent-%COMP%]{-webkit-border-radius:10em;height:38px;border:none;border-radius:10em;padding:10px 0;font-size:14px;width:100px;display:inline-block;text-align:center}.toggle-information[_ngcontent-%COMP%]   .btn-voltar[_ngcontent-%COMP%]{background-color:#243f75;color:#fff;margin-left:-1px!important}@media (max-width:768px){.toggle-information[_ngcontent-%COMP%]{width:100%!important;position:relative!important;margin:auto!important;text-align:center!important}}"] });
ToogleInformationComponent.ctorParameters = () => [
    { type: CommonFunctionsService }
];
ToogleInformationComponent.propDecorators = {
    onLogout: [{ type: Output }],
    logo: [{ type: Input }],
    isButtonEnable: [{ type: Input }],
    isFullLogo: [{ type: Input }],
    isLoggedIn: [{ type: Input }],
    username: [{ type: Input }],
    defaultRoute: [{ type: Input }],
    showSignupButton: [{ type: Input }],
    showLoginButton: [{ type: Input }],
    loginURL: [{ type: Input }],
    signupURL: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ToogleInformationComponent, [{
        type: Component,
        args: [{
                selector: 'app-toogle-information',
                template: "<div class=\"toggle-information\">\n  <div class=\"row\">\n    <div class=\"col-sm-12 username-div box\">\n      <div class=\"username\">Ol\u00E1 {{ username }}</div>\n    </div>\n    <div class=\"col-sm-3 icons-div box text-center\" style=\"border-right: none\">\n      <a href=\"https://www.dotz.com.br/dashboard/extrato\">\n        <img src=\"https://www.dotz.com.br/assets/dotz/img/new-site-content/extrato_icon.png\" id=\"extrato\">\n        <p class=\"icons-div-name\">Meu Extrato</p>\n      </a>\n    </div>\n    <div class=\"col-sm-3 icons-div box text-center\" style=\"border-right: none\">\n      <a href=\"https://www.dotz.com.br/dashboard/trocas\">\n\n        <img src=\"https://www.dotz.com.br/assets/dotz/img/new-site-content/trocas_icon.png\"\n          id=\"minhas-trocas\">\n        <p class=\"icons-div-name\">Minhas Trocas</p>\n      </a>\n    </div>\n    <div class=\"col-sm-3 icons-div box text-center\" style=\"border-right: none\">\n      <a href=\"https://www.dotz.com.br/dashboard/clubedotz\">\n\n        <img src=\"https://www.dotz.com.br/assets/dotz/img/new-site-content/clubedotz_icon.png\"\n          id=\"clube-dotz\">\n        <p class=\"icons-div-name\">Clube Dotz</p>\n      </a>\n    </div>\n    <div class=\"col-sm-3 icons-div box text-center\">\n      <a href=\"https://www.dotz.com.br/dashboard/meus-dados\">\n\n        <img src=\"https://www.dotz.com.br/assets/dotz/img/new-site-content/configuracoes_icon.png\">\n        <p class=\"icons-div-name\">Configura\u00E7\u00F5es</p>\n      </a>\n    </div>\n    <div class=\"col-sm-12 logout-div box text-right border-top\">\n      <img (click)=\"onLogout.emit()\" class=\"logout-btn\" src=\"https://www.dotz.com.br/assets/dotz/img/new-site-content/sair_icon.png\">\n    </div>\n  </div>\n</div>",
                styles: [".row{margin-left:unset!important;margin-right:unset!important}.toggle-information{border-radius:10px;width:420px;margin-left:50px;position:absolute;margin-top:24px;background-color:#fff;right:0}.toggle-information .username-div{border-bottom:1px solid #aaa}.toggle-information .username-div .username{color:#5f5f5f;font-weight:700;padding:10px 30px 10px 10px}.toggle-information .logout-div{padding:10px}.toggle-information .logout-div .logout-btn{width:20px;color:#5f5f5f}.toggle-information .icons-div{padding:20px 0 40px;height:100px}.toggle-information .icons-div img{width:35px}.toggle-information .icons-div .icons-div-name{font-size:13px!important;text-transform:capitalize!important;color:#5f5f5f}.toggle-information .border-top{border-top:1px solid #aaa}.toggle-information #extrato{width:36px}.toggle-information #minhas-trocas{width:44px}.toggle-information #clube-dotz{width:39px}.toggle-information .logo-dotz-full{height:60px;position:absolute}.toggle-information .fa-info-circle{font-size:40px}.toggle-information .help-text{display:block;margin-top:-34px!important;margin-left:42px!important}.toggle-information #header.header-scrolled{background:#fff;padding:20px 0;height:72px;transition:all .5s}.toggle-information #header{padding:30px 0;height:50px;position:fixed;left:0;top:0;right:0;z-index:997;background-color:#f29433}.toggle-information #header #logo h1{font-size:34px;padding:0;line-height:1;font-family:Montserrat,sans-serif;font-weight:700;letter-spacing:3px;margin:-29.95px 0 0}.toggle-information #header #logo h1 a,.toggle-information #header #logo h1 a:hover{color:#fff;font-size:22px;font-weight:600;padding-left:10px}.toggle-information #nav-menu-container{float:right;margin:0}.toggle-information .nav-menu>li{margin-top:-15px;float:left}.toggle-information .nav-menu li{position:relative;white-space:nowrap}.toggle-information .nav-menu,.toggle-information .nav-menu *{margin:0;padding:0;list-style:none}.toggle-information .header-scrolled .nav-menu>.menu-active>a,.toggle-information .header-scrolled .nav-menu li:hover>a{color:#f7941d}.toggle-information .header-scrolled .nav-menu a{color:#000}.toggle-information .nav-menu a{padding:0 8px 10px;text-decoration:none;display:inline-block;color:#fff;font-family:Montserrat,sans-serif;font-weight:700;font-size:18px;text-transform:uppercase;outline:none}.toggle-information #mobile-nav-toggle{display:inline;position:fixed;right:0;top:0;z-index:999;margin:20px 20px 0 0;border:0;background:none;font-size:24px;transition:all .4s;outline:none;cursor:pointer}.toggle-information #mobile-body-overly{width:100%;height:100%;z-index:997;top:0;left:0;position:fixed;background:rgba(0,0,0,.7)}.toggle-information body.mobile-nav-active #mobile-nav{left:0}.toggle-information #mobile-nav{position:fixed;top:0;padding-top:18px;bottom:0;z-index:998;background:rgba(0,0,0,.8);left:-260px;width:260px;overflow-y:auto;transition:.4s}.toggle-information #mobile-nav ul{padding:0;margin:0;list-style:none}.toggle-information #mobile-nav ul li{position:relative}.toggle-information #mobile-nav ul li a{color:#fff;font-size:13px;text-transform:uppercase;overflow:hidden;padding:10px 22px 10px 15px;position:relative;text-decoration:none;width:100%;display:block;outline:none;font-weight:700;font-family:Montserrat,sans-serif}.toggle-information #mobile-nav ul .menu-has-children i.fa-chevron-up{color:#18d26e}.toggle-information #mobile-nav ul .menu-has-children i{position:absolute;right:0;z-index:99;padding:15px;cursor:pointer;color:#fff}.toggle-information #mobile-nav ul .menu-item-active{color:#18d26e}.toggle-information #mobile-nav ul li li{padding-left:30px}.toggle-information .btn-entrar{background-color:#f8df68;color:#172860}.toggle-information .btn-entrar,.toggle-information .btn-voltar{-webkit-border-radius:10em;height:38px;border:none;border-radius:10em;padding:10px 0;font-size:14px;width:100px;display:inline-block;text-align:center}.toggle-information .btn-voltar{background-color:#243f75;color:#fff;margin-left:-1px!important}@media (max-width:768px){.toggle-information{width:100%!important;position:relative!important;margin:auto!important;text-align:center!important}}"]
            }]
    }], function () { return [{ type: CommonFunctionsService }]; }, { onLogout: [{
            type: Output
        }], logo: [{
            type: Input
        }], defaultRoute: [{
            type: Input
        }], isButtonEnable: [{
            type: Input
        }], isFullLogo: [{
            type: Input
        }], isLoggedIn: [{
            type: Input
        }], username: [{
            type: Input
        }], showSignupButton: [{
            type: Input
        }], showLoginButton: [{
            type: Input
        }], loginURL: [{
            type: Input
        }], signupURL: [{
            type: Input
        }] }); })();

class ToogleInformationModule {
}
ToogleInformationModule.ɵfac = function ToogleInformationModule_Factory(t) { return new (t || ToogleInformationModule)(); };
ToogleInformationModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: ToogleInformationModule });
ToogleInformationModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ providers: [CommonFunctionsService], imports: [[
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ToogleInformationModule, { declarations: function () { return [ToogleInformationComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [ToogleInformationComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ToogleInformationModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule
                ],
                providers: [CommonFunctionsService],
                declarations: [ToogleInformationComponent],
                exports: [ToogleInformationComponent]
            }]
    }], null, null); })();

class HeaderModule {
}
HeaderModule.ɵfac = function HeaderModule_Factory(t) { return new (t || HeaderModule)(); };
HeaderModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: HeaderModule });
HeaderModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ providers: [CommonFunctionsService], imports: [[
            CommonModule,
            ToogleInformationModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(HeaderModule, { declarations: function () { return [HeaderComponent]; }, imports: function () { return [CommonModule, ToogleInformationModule]; }, exports: function () { return [HeaderComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HeaderModule, [{
        type: NgModule,
        args: [{
                declarations: [HeaderComponent],
                imports: [
                    CommonModule,
                    ToogleInformationModule,
                ],
                providers: [CommonFunctionsService],
                exports: [
                    HeaderComponent,
                ]
            }]
    }], null, null); })();

class BlankMobileFooterComponent {
    constructor(cf) {
        this.cf = cf;
    }
}
BlankMobileFooterComponent.ɵfac = function BlankMobileFooterComponent_Factory(t) { return new (t || BlankMobileFooterComponent)(ɵngcc0.ɵɵdirectiveInject(CommonFunctionsService)); };
BlankMobileFooterComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BlankMobileFooterComponent, selectors: [["ngx-blank-mobile-footer"]], decls: 19, vars: 0, consts: [["id", "tabbar_mobile"], [1, "col-sm-4"], ["href", "https://www.dotz.com.br/Troque-seus-Dotz.aspx"], ["id", "tabbar_troque_icone", 1, "div_icone"], ["id", "tabbar_troque", 1, "icone_tabbar"], ["id", "tabbar_troque_legenda", 1, "legenda_footer"], ["href", "https://www.dotz.com.br/Ganhe-Dotz.aspx"], ["id", "tabbar_ganhe_icone", 1, "div_icone"], ["id", "tabbar_ganhe", 1, "icone_tabbar"], ["id", "tabbar_ganhe_legenda", 1, "legenda_footer"], ["href", "https://www.dotz.com.br/Como-funciona.aspx"], ["id", "tabbar_sobre_icone", 1, "div_icone"], ["id", "tabbar_sobre", 1, "icone_tabbar"], ["id", "tabbar_sobre_legenda_big", 1, "legenda_footer", "tabbar_sobre_legenda_big"]], template: function BlankMobileFooterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "a", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelement(4, "div", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "p", 5);
        ɵngcc0.ɵɵtext(6, "Troque");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 1);
        ɵngcc0.ɵɵelementStart(8, "a", 6);
        ɵngcc0.ɵɵelementStart(9, "div", 7);
        ɵngcc0.ɵɵelement(10, "div", 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "p", 9);
        ɵngcc0.ɵɵtext(12, "Ganhe");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(13, "div", 1);
        ɵngcc0.ɵɵelementStart(14, "a", 10);
        ɵngcc0.ɵɵelementStart(15, "div", 11);
        ɵngcc0.ɵɵelement(16, "div", 12);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(17, "p", 13);
        ɵngcc0.ɵɵtext(18, "Sobre Dotz");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } }, styles: [".tabbar_sobre_legenda_big[_ngcontent-%COMP%]{font-size:14px}@media only screen and (min-device-width:320px) and (max-device-width:754px){.footer_mobile[_ngcontent-%COMP%]{display:flex inline!important}#ABMEFLI[_ngcontent-%COMP%]{display:none}.abmef[_ngcontent-%COMP%]{display:block}.footer_blocos[_ngcontent-%COMP%]{display:none}#texto_copyright[_ngcontent-%COMP%]{margin-left:10px!important}.footer_bottom_conteudo[_ngcontent-%COMP%]{margin-top:0;width:40%!important}#logo_footer[_ngcontent-%COMP%], .social[_ngcontent-%COMP%]{margin-top:0}.social[_ngcontent-%COMP%]{width:41%!important}}@media only screen and (min-device-width:320px) and (max-device-width:660px){#footer_menu[_ngcontent-%COMP%]{display:none}.footer_bottom_conteudo[_ngcontent-%COMP%]{display:block}#texto_copyright[_ngcontent-%COMP%]{margin-left:30px}#texto_ABEMF[_ngcontent-%COMP%], .footer_blocos[_ngcontent-%COMP%]{display:none}#tabbar_mobile[_ngcontent-%COMP%]{display:block;position:fixed;bottom:0;width:100%;background:#fff;border-top:2px solid #999;padding-top:5px;padding-bottom:15px;text-align:center;height:73px!important;z-index:999}#tabbar_mobile[_ngcontent-%COMP%]   .col-sm-3[_ngcontent-%COMP%]{width:33.3%;float:left;position:relative;min-height:1px;padding-right:15px;padding-left:15px}.legenda_footer[_ngcontent-%COMP%]{color:#a0a195;font-size:14px;font-weight:700}.legenda_footer_current[_ngcontent-%COMP%]{color:#ee9642}.icone_tabbar[_ngcontent-%COMP%]{height:40px;width:auto}#tabbar_troque[_ngcontent-%COMP%]{background:url(https://www.dotz.com.br/assets/dotz/img/new-site-content/troque_mobile_cinza.png);background-size:contain;background-repeat:no-repeat;background-position:50%}.current_icon[_ngcontent-%COMP%]   #tabbar_troque[_ngcontent-%COMP%]{background:url(https://www.dotz.com.br/assets/dotz/img/new-site-content/troque_mobile_laranja.png);background-size:contain;background-repeat:no-repeat;background-position:50%}.current_icon[_ngcontent-%COMP%]   #tabbar_ganhe[_ngcontent-%COMP%]{background:url(https://www.dotz.com.br/assets/dotz/img/new-site-content/ganhe_mobile_laranja.png);background-size:contain;background-repeat:no-repeat;background-position:50%}#tabbar_clube[_ngcontent-%COMP%]{background:url(https://www.dotz.com.br/assets/dotz/img/new-site-content/clubedotz_icon.png);background-size:contain;background-repeat:no-repeat;background-position:50%;filter:grayscale(100%)}#tabbar_ganhe[_ngcontent-%COMP%]{background:url(https://www.dotz.com.br/assets/dotz/img/new-site-content/ganhe_mobile_cinza.png);background-size:contain;background-repeat:no-repeat;background-position:50%}.current_icon[_ngcontent-%COMP%]   #tabbar_sobre[_ngcontent-%COMP%]{background:url(https://www.dotz.com.br/assets/dotz/img/new-site-content/conta_mobile_laranja.png);background-size:contain;background-repeat:no-repeat;background-position:50%}#tabbar_sobre[_ngcontent-%COMP%]{background:url(https://www.dotz.com.br/assets/dotz/img/new-site-content/conta_mobile_cinza.png);background-size:contain;background-repeat:no-repeat;background-position:50%}.footer_mobile[_ngcontent-%COMP%]{display:flex;justify-content:center}.menu-item-footer[_ngcontent-%COMP%]{display:block;list-style:none}.footer_mobile_titulos[_ngcontent-%COMP%]   #texto_footer[_ngcontent-%COMP%]{font-family:Hurme,Helvetica,Arial,sans-serif}.footer_mobile_titulos[_ngcontent-%COMP%]{width:50%}.menu-item-footer[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:#a0a195;font-size:12px;font-family:HurmeGeometricSans4-Bold}.icone_tabbar[_ngcontent-%COMP%]{height:35px!important}.tabbar_sobre_legenda_big[_ngcontent-%COMP%]{font-size:13px!important}}"] });
BlankMobileFooterComponent.ctorParameters = () => [
    { type: CommonFunctionsService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BlankMobileFooterComponent, [{
        type: Component,
        args: [{
                selector: 'ngx-blank-mobile-footer',
                template: "<div id=\"tabbar_mobile\">\n    <div class=\"col-sm-4\">\n        <a href=\"https://www.dotz.com.br/Troque-seus-Dotz.aspx\">\n            <div class=\"div_icone \" id=\"tabbar_troque_icone\">\n                <div class=\"icone_tabbar\" id=\"tabbar_troque\"></div>\n            </div>\n            <p class=\"legenda_footer \" id=\"tabbar_troque_legenda\">Troque</p>\n        </a>\n    </div>\n    <div class=\"col-sm-4\">\n        <a href=\"https://www.dotz.com.br/Ganhe-Dotz.aspx\">\n            <div class=\"div_icone\" id=\"tabbar_ganhe_icone\">\n                <div class=\"icone_tabbar\" id=\"tabbar_ganhe\"></div>\n            </div>\n            <p class=\"legenda_footer\" id=\"tabbar_ganhe_legenda\">Ganhe</p>\n        </a>\n    </div>\n    <div class=\"col-sm-4\">\n        <a href=\"https://www.dotz.com.br/Como-funciona.aspx\">\n            <div class=\"div_icone\" id=\"tabbar_sobre_icone\">\n                <div class=\"icone_tabbar \" id=\"tabbar_sobre\"></div>\n            </div>\n            <p class=\"legenda_footer tabbar_sobre_legenda_big\" id=\"tabbar_sobre_legenda_big\">Sobre Dotz</p>\n        </a>\n    </div>\n</div>",
                styles: [".tabbar_sobre_legenda_big{font-size:14px}@media only screen and (min-device-width:320px) and (max-device-width:754px){.footer_mobile{display:flex inline!important}#ABMEFLI{display:none}.abmef{display:block}.footer_blocos{display:none}#texto_copyright{margin-left:10px!important}.footer_bottom_conteudo{margin-top:0;width:40%!important}#logo_footer,.social{margin-top:0}.social{width:41%!important}}@media only screen and (min-device-width:320px) and (max-device-width:660px){#footer_menu{display:none}.footer_bottom_conteudo{display:block}#texto_copyright{margin-left:30px}#texto_ABEMF,.footer_blocos{display:none}#tabbar_mobile{display:block;position:fixed;bottom:0;width:100%;background:#fff;border-top:2px solid #999;padding-top:5px;padding-bottom:15px;text-align:center;height:73px!important;z-index:999}#tabbar_mobile .col-sm-3{width:33.3%;float:left;position:relative;min-height:1px;padding-right:15px;padding-left:15px}.legenda_footer{color:#a0a195;font-size:14px;font-weight:700}.legenda_footer_current{color:#ee9642}.icone_tabbar{height:40px;width:auto}#tabbar_troque{background:url(https://www.dotz.com.br/assets/dotz/img/new-site-content/troque_mobile_cinza.png);background-size:contain;background-repeat:no-repeat;background-position:50%}.current_icon #tabbar_troque{background:url(https://www.dotz.com.br/assets/dotz/img/new-site-content/troque_mobile_laranja.png);background-size:contain;background-repeat:no-repeat;background-position:50%}.current_icon #tabbar_ganhe{background:url(https://www.dotz.com.br/assets/dotz/img/new-site-content/ganhe_mobile_laranja.png);background-size:contain;background-repeat:no-repeat;background-position:50%}#tabbar_clube{background:url(https://www.dotz.com.br/assets/dotz/img/new-site-content/clubedotz_icon.png);background-size:contain;background-repeat:no-repeat;background-position:50%;filter:grayscale(100%)}#tabbar_ganhe{background:url(https://www.dotz.com.br/assets/dotz/img/new-site-content/ganhe_mobile_cinza.png);background-size:contain;background-repeat:no-repeat;background-position:50%}.current_icon #tabbar_sobre{background:url(https://www.dotz.com.br/assets/dotz/img/new-site-content/conta_mobile_laranja.png);background-size:contain;background-repeat:no-repeat;background-position:50%}#tabbar_sobre{background:url(https://www.dotz.com.br/assets/dotz/img/new-site-content/conta_mobile_cinza.png);background-size:contain;background-repeat:no-repeat;background-position:50%}.footer_mobile{display:flex;justify-content:center}.menu-item-footer{display:block;list-style:none}.footer_mobile_titulos #texto_footer{font-family:Hurme,Helvetica,Arial,sans-serif}.footer_mobile_titulos{width:50%}.menu-item-footer a{color:#a0a195;font-size:12px;font-family:HurmeGeometricSans4-Bold}.icone_tabbar{height:35px!important}.tabbar_sobre_legenda_big{font-size:13px!important}}"]
            }]
    }], function () { return [{ type: CommonFunctionsService }]; }, null); })();

class BlankFooterMobileModule {
}
BlankFooterMobileModule.ɵfac = function BlankFooterMobileModule_Factory(t) { return new (t || BlankFooterMobileModule)(); };
BlankFooterMobileModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BlankFooterMobileModule });
BlankFooterMobileModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ providers: [CommonFunctionsService], imports: [[
            CommonModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BlankFooterMobileModule, { declarations: function () { return [BlankMobileFooterComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [BlankMobileFooterComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BlankFooterMobileModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                ],
                declarations: [BlankMobileFooterComponent],
                providers: [CommonFunctionsService],
                exports: [
                    BlankMobileFooterComponent,
                ]
            }]
    }], null, null); })();

class FooterComponent {
    constructor(cf) {
        this.cf = cf;
    }
}
FooterComponent.ɵfac = function FooterComponent_Factory(t) { return new (t || FooterComponent)(ɵngcc0.ɵɵdirectiveInject(CommonFunctionsService)); };
FooterComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FooterComponent, selectors: [["ngx-footer"]], decls: 187, vars: 0, consts: [[1, "page-footer", "font-small", "stylish-color-dark", "pt-4"], [1, "container", "text-center", "text-md-left"], [1, "row"], [1, "col-sm-12", "col-md-2", "mx-auto"], [1, "font-weight-bold", "text-uppercase", "mt-3", "mb-4"], ["src", "https://www.dotz.com.br/assets/dotz/img/new-site-content/logo-small.png", 1, "logo-img"], [1, "clearfix", "w-100", "d-md-none"], [1, "footer-title", "font-weight-bold", "text-uppercase", "mt-3", "mb-4"], [1, "list-unstyled"], ["href", "https://www.dotz.com.br/Como-funciona.aspx"], [1, "cor_laranja"], ["aria-hidden", "true", 1, "fa", "fa-angle-right"], ["href", "https://www.dotz.com.br/Como-funciona.aspx#ganhe"], ["href", "https://www.dotz.com.br/Como-funciona.aspx#troque"], ["href", "https://dotznext.com/help-desk/ui/contact"], ["href", "https://www.dotz.com.br/Ganhe-Dotz"], ["href", "https://ganheonline.dotz.com.br"], ["href", "https://www.dotz.com.br/bancos"], ["href", "https://www.dotz.com.br/seguros-assistencias"], ["href", "https://www.dotz.com.br/clubedotz"], ["href", "https://www.dotz.com.br/Troque-seus-Dotz.aspx"], ["href", "https://dotz.com.br/viaja"], ["href", "https://www.dotz.com.br/Troque-seus-Dotz/Recarga-celular.aspx"], ["href", "https://www.dotz.com.br/categorias/experiencias.aspx"], ["href", "https://pagcontas.dotz.com.br"], ["href", "https://www.dotz.com.br/compredotz"], ["href", "https://www.dotz.com.br/login.aspx?item=%2fdashboard%2fextrato&user=extranet%5cAnonymous&site=website"], ["href", "https://www.dotz.com.br/login.aspx?item=%2fdashboard%2ftrocas&user=extranet%5cAnonymous&site=website"], ["href", "https://www.dotz.com.br/login.aspx?item=%2fdashboard%2fmeus-dados&user=extranet%5cAnonymous&site=website"], [1, "list-unstyled", "list-inline", "text-center", "py-2"], [1, "list-inline-item"], [1, "mb-1"], ["id", "download", "target", "_blank", "href", "https://itunes.apple.com/br/app/dotz/id653824660?mt=8&ign-mpt=uo%3D4"], ["src", "https://dotz.com.br/assets/dotz/img/new-site-content/download_app.png", 1, "stores"], ["id", "download", "target", "_blank", "href", "https://play.google.com/store/apps/details?id=br.com.edeploy.dotz"], ["src", "https://dotz.com.br/assets/dotz/img/new-site-content/download_google.png", 1, "stores"], [1, "col-sm-6", "mx-auto"], [1, "list-unstyled", "list-inline", "text-center"], ["href", "https://www.dotz.com.br/Site-Seguro", 1, "btn-floating", "btn-fb", "mx-1"], ["href", "https://www.dotz.com.br/Regulamento", 1, "btn-floating", "btn-tw", "mx-1"], ["href", "https://www.dotz.com.br/Politica-Privacidade", 1, "btn-floating", "btn-gplus", "mx-1"], ["href", "https://www.vagasdotz.com/vagas", 1, "btn-floating", "btn-li", "mx-1"], ["href", "http://aquitemdotz.com.br/incentivo", 1, "btn-floating", "btn-dribbble", "mx-1"], [1, "btn-floating", "btn-dribbble", "mx-1"], ["src", "https://www.dotz.com.br/assets/dotz/img/new-site-content/ABEMF.jpg", 1, "ABEMF"], ["href", "https://www.facebook.com/programadotz", "target", "_blank", 1, "btn-floating", "btn-fb", "mx-1"], [1, "fa", "fa-facebook-f", "social-medias"], ["href", "https://www.youtube.com/user/dotzuser", "target", "_blank", 1, "btn-floating", "btn-tw", "mx-1"], [1, "fa", "fa-youtube", "social-medias"], ["href", "https://twitter.com/Programa_dotz", "target", "_blank", 1, "btn-floating", "btn-li", "mx-1"], [1, "fa", "fa-twitter", "social-medias"], [1, "footer-copyright", "text-center", "py-3"]], template: function FooterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "footer", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelementStart(4, "h5", 4);
        ɵngcc0.ɵɵelement(5, "img", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(6, "hr", 6);
        ɵngcc0.ɵɵelementStart(7, "div", 3);
        ɵngcc0.ɵɵelementStart(8, "h5", 7);
        ɵngcc0.ɵɵtext(9, "Sobre a Dotz");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "ul", 8);
        ɵngcc0.ɵɵelementStart(11, "li");
        ɵngcc0.ɵɵelementStart(12, "a", 9);
        ɵngcc0.ɵɵtext(13, " Conhe\u00E7a o Programa Dotz ");
        ɵngcc0.ɵɵelementStart(14, "span", 10);
        ɵngcc0.ɵɵelement(15, "i", 11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(16, "li");
        ɵngcc0.ɵɵelementStart(17, "a", 12);
        ɵngcc0.ɵɵtext(18, "Como Ganhar Dotz ");
        ɵngcc0.ɵɵelementStart(19, "span", 10);
        ɵngcc0.ɵɵelement(20, "i", 11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(21, "li");
        ɵngcc0.ɵɵelementStart(22, "a", 13);
        ɵngcc0.ɵɵtext(23, "Pelo que voc\u00EA pode trocar ");
        ɵngcc0.ɵɵelementStart(24, "span", 10);
        ɵngcc0.ɵɵelement(25, "i", 11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(26, "li");
        ɵngcc0.ɵɵelementStart(27, "a", 14);
        ɵngcc0.ɵɵtext(28, "Fale conosco ");
        ɵngcc0.ɵɵelementStart(29, "span", 10);
        ɵngcc0.ɵɵelement(30, "i", 11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(31, "hr", 6);
        ɵngcc0.ɵɵelementStart(32, "div", 3);
        ɵngcc0.ɵɵelementStart(33, "h5", 7);
        ɵngcc0.ɵɵtext(34, "Ganhe");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(35, "ul", 8);
        ɵngcc0.ɵɵelementStart(36, "li");
        ɵngcc0.ɵɵelementStart(37, "a", 15);
        ɵngcc0.ɵɵtext(38, "Veja onde ganhar ");
        ɵngcc0.ɵɵelementStart(39, "span", 10);
        ɵngcc0.ɵɵelement(40, "i", 11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(41, "li");
        ɵngcc0.ɵɵelementStart(42, "a", 16);
        ɵngcc0.ɵɵtext(43, "Ganhe Dotz online ");
        ɵngcc0.ɵɵelementStart(44, "span", 10);
        ɵngcc0.ɵɵelement(45, "i", 11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(46, "li");
        ɵngcc0.ɵɵelementStart(47, "a", 17);
        ɵngcc0.ɵɵtext(48, "Ganhe com cart\u00F5es de cr\u00E9dito ");
        ɵngcc0.ɵɵelementStart(49, "span", 10);
        ɵngcc0.ɵɵelement(50, "i", 11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(51, "li");
        ɵngcc0.ɵɵelementStart(52, "a", 18);
        ɵngcc0.ɵɵtext(53, "Seguros e Assist\u00EAncias ");
        ɵngcc0.ɵɵelementStart(54, "span", 10);
        ɵngcc0.ɵɵelement(55, "i", 11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(56, "li");
        ɵngcc0.ɵɵelementStart(57, "a", 19);
        ɵngcc0.ɵɵtext(58, "Clube Dotz ");
        ɵngcc0.ɵɵelementStart(59, "span", 10);
        ɵngcc0.ɵɵelement(60, "i", 11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(61, "hr", 6);
        ɵngcc0.ɵɵelementStart(62, "div", 3);
        ɵngcc0.ɵɵelementStart(63, "h5", 7);
        ɵngcc0.ɵɵtext(64, "Troque");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(65, "ul", 8);
        ɵngcc0.ɵɵelementStart(66, "li");
        ɵngcc0.ɵɵelementStart(67, "a", 20);
        ɵngcc0.ɵɵtext(68, "Veja onde trocar ");
        ɵngcc0.ɵɵelementStart(69, "span", 10);
        ɵngcc0.ɵɵelement(70, "i", 11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(71, "li");
        ɵngcc0.ɵɵelementStart(72, "a", 20);
        ɵngcc0.ɵɵtext(73, "Produtos ");
        ɵngcc0.ɵɵelementStart(74, "span", 10);
        ɵngcc0.ɵɵelement(75, "i", 11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(76, "li");
        ɵngcc0.ɵɵelementStart(77, "a", 21);
        ɵngcc0.ɵɵtext(78, "Passagens a\u00E9reas ");
        ɵngcc0.ɵɵelementStart(79, "span", 10);
        ɵngcc0.ɵɵelement(80, "i", 11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(81, "li");
        ɵngcc0.ɵɵelementStart(82, "a", 22);
        ɵngcc0.ɵɵtext(83, "Recargas de Celular ");
        ɵngcc0.ɵɵelementStart(84, "span", 10);
        ɵngcc0.ɵɵelement(85, "i", 11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(86, "li");
        ɵngcc0.ɵɵelementStart(87, "a", 23);
        ɵngcc0.ɵɵtext(88, "Entretenimento ");
        ɵngcc0.ɵɵelementStart(89, "span", 10);
        ɵngcc0.ɵɵelement(90, "i", 11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(91, "li");
        ɵngcc0.ɵɵelementStart(92, "a", 24);
        ɵngcc0.ɵɵtext(93, "Pagamento de contas ");
        ɵngcc0.ɵɵelementStart(94, "span", 10);
        ɵngcc0.ɵɵelement(95, "i", 11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(96, "li");
        ɵngcc0.ɵɵelementStart(97, "a", 25);
        ɵngcc0.ɵɵtext(98, "Compre Dotz ");
        ɵngcc0.ɵɵelementStart(99, "span", 10);
        ɵngcc0.ɵɵelement(100, "i", 11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(101, "hr", 6);
        ɵngcc0.ɵɵelementStart(102, "div", 3);
        ɵngcc0.ɵɵelementStart(103, "h5", 7);
        ɵngcc0.ɵɵtext(104, "Minha Conta");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(105, "ul", 8);
        ɵngcc0.ɵɵelementStart(106, "li");
        ɵngcc0.ɵɵelementStart(107, "a", 26);
        ɵngcc0.ɵɵtext(108, "Meu extrato ");
        ɵngcc0.ɵɵelementStart(109, "span", 10);
        ɵngcc0.ɵɵelement(110, "i", 11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(111, "li");
        ɵngcc0.ɵɵelementStart(112, "a", 27);
        ɵngcc0.ɵɵtext(113, "Minhas trocas ");
        ɵngcc0.ɵɵelementStart(114, "span", 10);
        ɵngcc0.ɵɵelement(115, "i", 11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(116, "li");
        ɵngcc0.ɵɵelementStart(117, "a", 28);
        ɵngcc0.ɵɵtext(118, "Configura\u00E7\u00F5es ");
        ɵngcc0.ɵɵelementStart(119, "span", 10);
        ɵngcc0.ɵɵelement(120, "i", 11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(121, "li");
        ɵngcc0.ɵɵelementStart(122, "a", 19);
        ɵngcc0.ɵɵtext(123, "Clube Dotz ");
        ɵngcc0.ɵɵelementStart(124, "span", 10);
        ɵngcc0.ɵɵelement(125, "i", 11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(126, "hr");
        ɵngcc0.ɵɵelementStart(127, "ul", 29);
        ɵngcc0.ɵɵelementStart(128, "li", 30);
        ɵngcc0.ɵɵelementStart(129, "h5", 31);
        ɵngcc0.ɵɵtext(130, "Aplicativos");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(131, "li", 30);
        ɵngcc0.ɵɵelementStart(132, "a", 32);
        ɵngcc0.ɵɵelement(133, "img", 33);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(134, "a", 34);
        ɵngcc0.ɵɵelement(135, "img", 35);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(136, "hr");
        ɵngcc0.ɵɵelementStart(137, "div", 2);
        ɵngcc0.ɵɵelementStart(138, "div", 36);
        ɵngcc0.ɵɵelementStart(139, "ul", 37);
        ɵngcc0.ɵɵelementStart(140, "li", 30);
        ɵngcc0.ɵɵelementStart(141, "a", 38);
        ɵngcc0.ɵɵtext(142, " Site Seguro ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(143, "li", 30);
        ɵngcc0.ɵɵelementStart(144, "a", 39);
        ɵngcc0.ɵɵtext(145, " Regulamento ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(146, "li", 30);
        ɵngcc0.ɵɵelementStart(147, "a", 40);
        ɵngcc0.ɵɵtext(148, " Pol\u00EDtica de Privacidade ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(149, "li", 30);
        ɵngcc0.ɵɵelementStart(150, "a", 41);
        ɵngcc0.ɵɵtext(151, " Trabalhe Conosco ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(152, "li", 30);
        ɵngcc0.ɵɵelementStart(153, "a", 42);
        ɵngcc0.ɵɵtext(154, " Dotz para Empresas ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(155, "br");
        ɵngcc0.ɵɵelementStart(156, "li", 30);
        ɵngcc0.ɵɵelementStart(157, "strong");
        ɵngcc0.ɵɵtext(158, "Central de atendimento:");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(159, "br");
        ɵngcc0.ɵɵelementStart(160, "li", 30);
        ɵngcc0.ɵɵtext(161, " Principais capitais e regi\u00E3o metropolitana: ");
        ɵngcc0.ɵɵelementStart(162, "strong");
        ɵngcc0.ɵɵtext(163, "4007 1339");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(164, "li", 30);
        ɵngcc0.ɵɵtext(165, " Demais localidades: ");
        ɵngcc0.ɵɵelementStart(166, "strong");
        ɵngcc0.ɵɵtext(167, "0800 601 1339");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(168, "br");
        ɵngcc0.ɵɵelementStart(169, "li", 30);
        ɵngcc0.ɵɵelementStart(170, "a", 43);
        ɵngcc0.ɵɵtext(171, " Empresa associada \u00E0 ");
        ɵngcc0.ɵɵelement(172, "img", 44);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(173, "div", 2);
        ɵngcc0.ɵɵelementStart(174, "div", 36);
        ɵngcc0.ɵɵelementStart(175, "ul", 37);
        ɵngcc0.ɵɵelementStart(176, "li", 30);
        ɵngcc0.ɵɵelementStart(177, "a", 45);
        ɵngcc0.ɵɵelement(178, "i", 46);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(179, "li", 30);
        ɵngcc0.ɵɵelementStart(180, "a", 47);
        ɵngcc0.ɵɵelement(181, "i", 48);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(182, "li", 30);
        ɵngcc0.ɵɵelementStart(183, "a", 49);
        ɵngcc0.ɵɵelement(184, "i", 50);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(185, "div", 51);
        ɵngcc0.ɵɵtext(186, " @ 2019 Dotz. Todos os direitos reservados ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } }, styles: ["footer[_ngcontent-%COMP%]{background-color:#fff!important}.logo-img[_ngcontent-%COMP%]{width:70px}a[_ngcontent-%COMP%]{color:#777360}.stores[_ngcontent-%COMP%]{width:100px;cursor:pointer}.list-unstyled[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{color:#777360;font-size:12px;line-height:25px}.footer-title[_ngcontent-%COMP%]{font-weight:700;color:#172860;font-size:14px;display:block}.fab[_ngcontent-%COMP%]{color:#172860}i[_ngcontent-%COMP%]{cursor:pointer}.social-medias[_ngcontent-%COMP%]{font-size:22px}.btn-floating[_ngcontent-%COMP%]{cursor:pointer}.ABEMF[_ngcontent-%COMP%]{width:80px}ul[_ngcontent-%COMP%]{padding-left:unset!important}.cor_laranja[_ngcontent-%COMP%]{color:#f7941d;font-size:10px}@media (max-width:320px){footer[_ngcontent-%COMP%]{width:100%!important}}  .btn-dribbble{background-color:unset!important}"] });
FooterComponent.ctorParameters = () => [
    { type: CommonFunctionsService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FooterComponent, [{
        type: Component,
        args: [{
                selector: 'ngx-footer',
                template: "<!-- Footer -->\n<footer class=\"page-footer font-small stylish-color-dark pt-4\">\n\n   <!-- Footer Links -->\n   <div class=\"container text-center text-md-left\">\n\n      <!-- Grid row -->\n      <div class=\"row\">\n\n         <!-- Grid column -->\n         <div class=\"col-sm-12 col-md-2 mx-auto\">\n\n            <!-- Content -->\n            <h5 class=\"font-weight-bold text-uppercase mt-3 mb-4\">\n               <img src=\"https://www.dotz.com.br/assets/dotz/img/new-site-content/logo-small.png\" class=\"logo-img\">\n            </h5>\n\n         </div>\n         <!-- Grid column -->\n\n         <hr class=\"clearfix w-100 d-md-none\">\n\n         <!-- Grid column -->\n         <div class=\"col-sm-12 col-md-2 mx-auto\">\n\n            <!-- Links -->\n            <h5 class=\"footer-title font-weight-bold text-uppercase mt-3 mb-4\">Sobre a Dotz</h5>\n\n            <ul class=\"list-unstyled\">\n               <li>\n                  <a href=\"https://www.dotz.com.br/Como-funciona.aspx\">\n                     Conhe\u00E7a o Programa Dotz\n                     <span class=\"cor_laranja\"><i class=\"fa fa-angle-right\" aria-hidden=\"true\"></i></span>\n                  </a>\n               </li>\n               <li>\n                  <a href=\"https://www.dotz.com.br/Como-funciona.aspx#ganhe\">Como Ganhar Dotz <span\n                        class=\"cor_laranja\"><i class=\"fa fa-angle-right\" aria-hidden=\"true\"></i></span></a>\n               </li>\n               <li>\n                  <a href=\"https://www.dotz.com.br/Como-funciona.aspx#troque\">Pelo que voc\u00EA pode trocar <span\n                        class=\"cor_laranja\"><i class=\"fa fa-angle-right\" aria-hidden=\"true\"></i></span> </a>\n               </li>\n               <li>\n                  <a href=\"https://dotznext.com/help-desk/ui/contact\">Fale conosco <span class=\"cor_laranja\"><i class=\"fa fa-angle-right\"\n                           aria-hidden=\"true\"></i></span></a>\n               </li>\n            </ul>\n\n         </div>\n         <!-- Grid column -->\n\n         <hr class=\"clearfix w-100 d-md-none\">\n\n         <!-- Grid column -->\n         <div class=\"col-sm-12 col-md-2 mx-auto\">\n\n            <!-- Links -->\n            <h5 class=\"footer-title font-weight-bold text-uppercase mt-3 mb-4\">Ganhe</h5>\n\n            <ul class=\"list-unstyled\">\n               <li>\n                  <a href=\"https://www.dotz.com.br/Ganhe-Dotz\">Veja onde ganhar <span class=\"cor_laranja\"><i\n                           class=\"fa fa-angle-right\" aria-hidden=\"true\"></i></span></a>\n               </li>\n               <li>\n                  <a href=\"https://ganheonline.dotz.com.br\">Ganhe Dotz online <span class=\"cor_laranja\"><i\n                           class=\"fa fa-angle-right\" aria-hidden=\"true\"></i></span></a>\n               </li>\n               <li>\n                  <a href=\"https://www.dotz.com.br/bancos\">Ganhe com cart\u00F5es de cr\u00E9dito <span class=\"cor_laranja\"><i\n                           class=\"fa fa-angle-right\" aria-hidden=\"true\"></i></span> </a>\n               </li>\n               <li>\n                  <a href=\"https://www.dotz.com.br/seguros-assistencias\">Seguros e Assist\u00EAncias <span\n                        class=\"cor_laranja\"><i class=\"fa fa-angle-right\" aria-hidden=\"true\"></i></span></a>\n               </li>\n               <li>\n                  <a href=\"https://www.dotz.com.br/clubedotz\">Clube Dotz <span class=\"cor_laranja\"><i\n                           class=\"fa fa-angle-right\" aria-hidden=\"true\"></i></span></a>\n               </li>\n            </ul>\n\n         </div>\n         <!-- Grid column -->\n\n         <hr class=\"clearfix w-100 d-md-none\">\n\n         <!-- Grid column -->\n         <div class=\"col-sm-12 col-md-2 mx-auto\">\n\n            <!-- Links -->\n            <h5 class=\"footer-title font-weight-bold text-uppercase mt-3 mb-4\">Troque</h5>\n\n            <ul class=\"list-unstyled\">\n               <li>\n                  <a href=\"https://www.dotz.com.br/Troque-seus-Dotz.aspx\">Veja onde trocar <span class=\"cor_laranja\"><i\n                           class=\"fa fa-angle-right\" aria-hidden=\"true\"></i></span> </a>\n               </li>\n               <li>\n                  <a href=\"https://www.dotz.com.br/Troque-seus-Dotz.aspx\">Produtos <span class=\"cor_laranja\"><i\n                           class=\"fa fa-angle-right\" aria-hidden=\"true\"></i></span></a>\n               </li>\n               <li>\n                  <a href=\"https://dotz.com.br/viaja\">Passagens a\u00E9reas <span class=\"cor_laranja\"><i\n                           class=\"fa fa-angle-right\" aria-hidden=\"true\"></i></span></a>\n               </li>\n               <li>\n                  <a href=\"https://www.dotz.com.br/Troque-seus-Dotz/Recarga-celular.aspx\">Recargas de Celular <span\n                        class=\"cor_laranja\"><i class=\"fa fa-angle-right\" aria-hidden=\"true\"></i></span></a>\n               </li>\n               <li>\n                  <a href=\"https://www.dotz.com.br/categorias/experiencias.aspx\">Entretenimento <span\n                        class=\"cor_laranja\"><i class=\"fa fa-angle-right\" aria-hidden=\"true\"></i></span></a>\n               </li>\n               <li>\n                  <a href=\"https://pagcontas.dotz.com.br\">Pagamento de contas <span class=\"cor_laranja\"><i\n                           class=\"fa fa-angle-right\" aria-hidden=\"true\"></i></span></a>\n               </li>\n               <li>\n                  <a href=\"https://www.dotz.com.br/compredotz\">Compre Dotz <span class=\"cor_laranja\"><i\n                           class=\"fa fa-angle-right\" aria-hidden=\"true\"></i></span></a>\n               </li>\n            </ul>\n\n         </div>\n         <!-- Grid column -->\n\n\n         <hr class=\"clearfix w-100 d-md-none\">\n\n         <!-- Grid column -->\n         <div class=\"col-sm-12 col-md-2 mx-auto\">\n\n            <!-- Links -->\n            <h5 class=\"footer-title font-weight-bold text-uppercase mt-3 mb-4\">Minha Conta</h5>\n\n            <ul class=\"list-unstyled\">\n               <li>\n                  <a\n                     href=\"https://www.dotz.com.br/login.aspx?item=%2fdashboard%2fextrato&user=extranet%5cAnonymous&site=website\">Meu\n                     extrato <span class=\"cor_laranja\"><i class=\"fa fa-angle-right\" aria-hidden=\"true\"></i></span></a>\n               </li>\n               <li>\n                  <a\n                     href=\"https://www.dotz.com.br/login.aspx?item=%2fdashboard%2ftrocas&user=extranet%5cAnonymous&site=website\">Minhas\n                     trocas <span class=\"cor_laranja\"><i class=\"fa fa-angle-right\" aria-hidden=\"true\"></i></span></a>\n               </li>\n               <li>\n                  <a\n                     href=\"https://www.dotz.com.br/login.aspx?item=%2fdashboard%2fmeus-dados&user=extranet%5cAnonymous&site=website\">Configura\u00E7\u00F5es\n                     <span class=\"cor_laranja\"><i class=\"fa fa-angle-right\" aria-hidden=\"true\"></i></span></a>\n               </li>\n               <li>\n                  <a href=\"https://www.dotz.com.br/clubedotz\">Clube Dotz <span class=\"cor_laranja\"><i\n                           class=\"fa fa-angle-right\" aria-hidden=\"true\"></i></span></a>\n               </li>\n            </ul>\n\n         </div>\n         <!-- Grid column -->\n\n      </div>\n      <!-- Grid row -->\n\n   </div>\n   <!-- Footer Links -->\n\n   <hr>\n\n   <!-- Call to action -->\n   <ul class=\"list-unstyled list-inline text-center py-2\">\n      <li class=\"list-inline-item\">\n         <h5 class=\"mb-1\">Aplicativos</h5>\n      </li>\n      <li class=\"list-inline-item\">\n         <a id=\"download\" target=\"_blank\"\n            href=\"https://itunes.apple.com/br/app/dotz/id653824660?mt=8&amp;ign-mpt=uo%3D4\">\n            <img class=\"stores\" src=\"https://dotz.com.br/assets/dotz/img/new-site-content/download_app.png\">\n         </a>\n         <a id=\"download\" target=\"_blank\"\n            href=\"https://play.google.com/store/apps/details?id=br.com.edeploy.dotz\">\n            <img class=\"stores\" src=\"https://dotz.com.br/assets/dotz/img/new-site-content/download_google.png\">\n         </a>\n      </li>\n   </ul>\n   <!-- Call to action -->\n\n   <hr>\n\n   <div class=\"row\">\n      <div class=\"col-sm-6 mx-auto\">\n         <ul class=\"list-unstyled list-inline text-center\">\n            <li class=\"list-inline-item\">\n               <a href=\"https://www.dotz.com.br/Site-Seguro\" class=\"btn-floating btn-fb mx-1\">\n                  Site Seguro\n               </a>\n            </li>\n            <li class=\"list-inline-item\">\n               <a href=\"https://www.dotz.com.br/Regulamento\" class=\"btn-floating btn-tw mx-1\">\n                  Regulamento\n               </a>\n            </li>\n            <li class=\"list-inline-item\">\n               <a href=\"https://www.dotz.com.br/Politica-Privacidade\" class=\"btn-floating btn-gplus mx-1\">\n                  Pol\u00EDtica de Privacidade\n               </a>\n            </li>\n            <li class=\"list-inline-item\">\n               <a href=\"https://www.vagasdotz.com/vagas\" class=\"btn-floating btn-li mx-1\">\n                  Trabalhe Conosco\n               </a>\n            </li>\n            <li class=\"list-inline-item\">\n               <a href=\"http://aquitemdotz.com.br/incentivo\" class=\"btn-floating btn-dribbble mx-1\">\n                  Dotz para Empresas\n               </a>\n            </li>\n            <br/>\n            <li class=\"list-inline-item\">\n               <strong>Central de atendimento:</strong>\n            </li>\n            <br/>\n            <li class=\"list-inline-item\">\n                  Principais capitais\n                  e regi\u00E3o metropolitana:\n                  <strong>4007 1339</strong>\n            </li>\n            <li class=\"list-inline-item\">\n               Demais localidades: <strong>0800 601 1339</strong>\n            </li>\n            <br/>\n            <li class=\"list-inline-item\">\n               <a class=\"btn-floating btn-dribbble mx-1\">\n                  Empresa associada \u00E0 <img class=\"ABEMF\" src=\"https://www.dotz.com.br/assets/dotz/img/new-site-content/ABEMF.jpg\">\n               </a>\n            </li>\n         </ul>\n      </div>\n   </div>\n   <div class=\"row\">\n      <div class=\"col-sm-6 mx-auto\">\n         <!-- Social buttons -->\n         <ul class=\"list-unstyled list-inline text-center\">\n            <li class=\"list-inline-item\">\n               <a href=\"https://www.facebook.com/programadotz\" target=\"_blank\" class=\"btn-floating btn-fb mx-1\">\n                  <i class=\"fa fa-facebook-f social-medias\"> </i>\n               </a>\n            </li>\n            <li class=\"list-inline-item\">\n               <a href=\"https://www.youtube.com/user/dotzuser\" target=\"_blank\" class=\"btn-floating btn-tw mx-1\">\n                  <i class=\"fa fa-youtube social-medias\"> </i>\n               </a>\n            </li>\n            <li class=\"list-inline-item\">\n               <a href=\"https://twitter.com/Programa_dotz\" target=\"_blank\" class=\"btn-floating btn-li mx-1\">\n                  <i class=\"fa fa-twitter social-medias\"> </i>\n               </a>\n            </li>\n         </ul>\n         <!-- Social buttons -->\n      </div>\n   </div>\n\n\n   <!-- Copyright -->\n   <div class=\"footer-copyright text-center py-3\">\n      @ 2019 Dotz. Todos os direitos reservados\n   </div>\n   <!-- Copyright -->\n\n</footer>\n<!-- Footer -->",
                styles: ["footer{background-color:#fff!important}.logo-img{width:70px}a{color:#777360}.stores{width:100px;cursor:pointer}.list-unstyled li{color:#777360;font-size:12px;line-height:25px}.footer-title{font-weight:700;color:#172860;font-size:14px;display:block}.fab{color:#172860}i{cursor:pointer}.social-medias{font-size:22px}.btn-floating{cursor:pointer}.ABEMF{width:80px}ul{padding-left:unset!important}.cor_laranja{color:#f7941d;font-size:10px}@media (max-width:320px){footer{width:100%!important}}::ng-deep .btn-dribbble{background-color:unset!important}"]
            }]
    }], function () { return [{ type: CommonFunctionsService }]; }, null); })();

class FooterModule {
}
FooterModule.ɵfac = function FooterModule_Factory(t) { return new (t || FooterModule)(); };
FooterModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: FooterModule });
FooterModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ providers: [CommonFunctionsService], imports: [[
            CommonModule,
            RouterModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(FooterModule, { declarations: function () { return [FooterComponent]; }, imports: function () { return [CommonModule,
        RouterModule]; }, exports: function () { return [FooterComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FooterModule, [{
        type: NgModule,
        args: [{
                declarations: [FooterComponent],
                imports: [
                    CommonModule,
                    RouterModule,
                ],
                providers: [CommonFunctionsService],
                exports: [
                    FooterComponent,
                ]
            }]
    }], null, null); })();

class SafePipe {
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
    }
    transform(value, type) {
        switch (type) {
            case 'html': return this.sanitizer.bypassSecurityTrustHtml(value);
            case 'style': return this.sanitizer.bypassSecurityTrustStyle(value);
            case 'script': return this.sanitizer.bypassSecurityTrustScript(value);
            case 'url': return this.sanitizer.bypassSecurityTrustUrl(value);
            case 'resourceUrl': return this.sanitizer.bypassSecurityTrustResourceUrl(value);
            default: throw new Error(`Invalid safe type specified: ${type}`);
        }
    }
}
SafePipe.ɵfac = function SafePipe_Factory(t) { return new (t || SafePipe)(ɵngcc0.ɵɵdirectiveInject(ɵngcc5.DomSanitizer)); };
SafePipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "safe", type: SafePipe, pure: true });
SafePipe.ctorParameters = () => [
    { type: DomSanitizer }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SafePipe, [{
        type: Pipe,
        args: [{
                name: 'safe'
            }]
    }], function () { return [{ type: ɵngcc5.DomSanitizer }]; }, null); })();

class LandingModule {
}
LandingModule.ɵfac = function LandingModule_Factory(t) { return new (t || LandingModule)(); };
LandingModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: LandingModule });
LandingModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FooterModule,
            HeaderModule,
            BlankFooterMobileModule,
            RouterModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(LandingModule, { declarations: function () { return [LandingComponent, SafePipe]; }, imports: function () { return [CommonModule, FooterModule, HeaderModule, BlankFooterMobileModule, RouterModule]; }, exports: function () { return [LandingComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LandingModule, [{
        type: NgModule,
        args: [{
                declarations: [LandingComponent, SafePipe],
                imports: [
                    CommonModule,
                    FooterModule,
                    HeaderModule,
                    BlankFooterMobileModule,
                    RouterModule,
                ],
                exports: [
                    LandingComponent,
                ]
            }]
    }], null, null); })();

let resultEnvironment = {};
const browserWindow = window || {};
const browserWindowEnv = browserWindow['__env'] || {};
for (const key in browserWindowEnv) {
    const keyDecrypt = key;
    let valueDecrypt = window['__env'][key];
    resultEnvironment[keyDecrypt] = valueDecrypt;
}
const dynamicEnv = resultEnvironment;

const generatePath = (basePathName) => {
    if (basePathName) {
        try {
            return window['__env'][basePathName];
        }
        catch (err) { }
    }
    try {
        return window['__env']['UI_BASE_PATH'] || window['__env']['BASE_PATH'];
    }
    catch (err) {
        return '/';
    }
};
const ɵ0$2 = generatePath;
/**
 * @description Função para obter o basePath
 * @param { string } basePathName Custom Base Path
 */
const getBasePath = (basePathName) => {
    const basePath = generatePath(basePathName);
    window['_app_base'] = basePath;
    return basePath;
};

const init = (scope, form) => {
    scope['onFormSubmit'] = new BehaviorSubject(null);
    scope['onFormSubmitAsync'] = scope.onFormSubmit.asObservable();
    if (form) {
        scope['onValueChange'] = new BehaviorSubject(null);
        scope['onValueChangeAsync'] = scope.onFormSubmit.asObservable();
        form.valueChanges.subscribe(changes => {
            scope.onValueChange.next(changes);
        });
    }
};
const ɵ0$1 = init;
const submit = (form, scope) => {
    if (scope && scope.onFormSubmit) {
        scope['onFormSubmit'].next(form.value);
    }
    else {
        scope['onFormSubmit'] = new BehaviorSubject({});
        scope['onFormSubmit'].next(form.value);
    }
};
const ɵ1$1 = submit;
const send = (value = {}, scope) => {
    scope['onFormSubmit'].next(value);
};
const ɵ2 = send;
const onSubmit = (componentRef) => {
    if (componentRef.instance && !componentRef.instance.onFormSubmitAsync) {
        return new BehaviorSubject({}).asObservable();
    }
    return componentRef.instance.onFormSubmitAsync;
};
const ɵ3 = onSubmit;
const onValueChange = (componentRef) => {
    if (componentRef.instance && !componentRef.instance.onValueChangeAsync) {
        return new BehaviorSubject({}).asObservable();
    }
    return componentRef.instance.onValueChangeAsync;
};
const ɵ4 = onValueChange;
const formEvents = { submit, onSubmit, onValueChange, init, send };

;
class ValidatorBase {
    constructor() {
        this.formErrors = [];
    }
    getFormValidationErrors() {
        this.formErrors = [];
        Object.keys(this.form.controls).forEach(key => {
            const controlErrors = this.form.get(key).errors;
            if (controlErrors != null) {
                Object.keys(controlErrors).forEach(keyError => {
                    const errorPackage = {
                        formControlName: key,
                        error: keyError,
                        errorValue: controlErrors[keyError],
                    };
                    errorPackage.message = this.getErrorMessage(errorPackage);
                    const formFind = this.formErrors.find(formItem => (formItem && formItem.name) && (formItem.name === key));
                    if (!formFind) {
                        this.formErrors.push({ name: key, errors: [errorPackage] });
                    }
                    else {
                        this.formErrors = this.formErrors.map(formItem => {
                            if (formItem.name === key) {
                                formItem.errors.push(errorPackage);
                            }
                            return formItem;
                        });
                    }
                });
            }
        });
    }
    getErrorMessage(error) {
        let message;
        switch (error.error) {
            case 'minLength':
                message = `O campo ${error.formControlName} não contem a quantidade mínima de caracteres`;
                break;
            case 'maxLength':
                message = `O campo ${error.formControlName} excedeu a quantidade máxima de caracteres`;
                break;
            case 'required':
                message = `O campo ${error.formControlName} é obrigatório`;
                break;
            case 'isNumber':
                message = `O campo ${error.formControlName} deve ser um número`;
                break;
            case 'differentThanZero':
                message = `O campo ${error.formControlName} deve ser diferente de zero`;
                break;
            case 'positiveNumberOrZero':
                message = `O campo ${error.formControlName} deve ser positivo ou zero`;
                break;
            default:
                message = error && error.errorValue
                    ? error.errorValue
                    : `O campo ${error.formControlName} possui erros`;
                break;
        }
        return message;
    }
}
ValidatorBase.ɵfac = function ValidatorBase_Factory(t) { return new (t || ValidatorBase)(); };
ValidatorBase.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: ValidatorBase, factory: ValidatorBase.ɵfac });
ValidatorBase.propDecorators = {
    form: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ValidatorBase, [{
        type: Injectable
    }], function () { return []; }, { form: [{
            type: Input
        }] }); })();

class ValidatorComponent extends ValidatorBase {
    constructor() {
        super();
        this.class = 'danger';
    }
    ngOnInit() {
        this.form.valueChanges.pipe(startWith(() => this.form)).subscribe(() => {
            this.getFormValidationErrors();
        });
    }
}
ValidatorComponent.ɵfac = function ValidatorComponent_Factory(t) { return new (t || ValidatorComponent)(); };
ValidatorComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ValidatorComponent, selectors: [["dharma-validator"]], inputs: { class: "class", form: "form" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [["role", "alert", 3, "class", 4, "ngIf"], ["role", "alert"], [4, "ngFor", "ngForOf"]], template: function ValidatorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, ValidatorComponent_div_0_Template, 2, 4, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.form.status !== "VALID");
    } }, directives: [ɵngcc4.NgIf, ɵngcc4.NgForOf], styles: ["ul[_ngcontent-%COMP%]{list-style-type:none!important}"] });
ValidatorComponent.ctorParameters = () => [];
ValidatorComponent.propDecorators = {
    form: [{ type: Input }],
    class: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ValidatorComponent, [{
        type: Component,
        args: [{
                selector: 'dharma-validator',
                template: "<div class=\"alert alert-{{ class }}\" role=\"alert\" *ngIf=\"form.status !== 'VALID'\">\n   <ul *ngFor=\"let errorItem of formErrors\">\n      <li>\n         <p *ngFor=\"let error of errorItem?.errors\"> {{ error?.message }}</p>\n      </li>\n   </ul>\n</div>",
                styles: ["ul{list-style-type:none!important}"]
            }]
    }], function () { return []; }, { class: [{
            type: Input
        }], form: [{
            type: Input
        }] }); })();

class InputCheckComponent {
}
InputCheckComponent.ɵfac = function InputCheckComponent_Factory(t) { return new (t || InputCheckComponent)(); };
InputCheckComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: InputCheckComponent, selectors: [["dharma-input-check"]], inputs: { control: "control" }, decls: 1, vars: 1, consts: [["class", "icon-check", 4, "ngIf"], [1, "icon-check"]], template: function InputCheckComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, InputCheckComponent_small_0_Template, 2, 0, "small", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.control && ctx.control.status === "VALID");
    } }, directives: [ɵngcc4.NgIf], styles: [".icon-check[_ngcontent-%COMP%]{color:green;font-size:25px;margin-left:-20px}"] });
InputCheckComponent.propDecorators = {
    control: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(InputCheckComponent, [{
        type: Component,
        args: [{
                selector: 'dharma-input-check',
                template: "<small class=\"icon-check\" *ngIf=\"control && control.status === 'VALID'\">\u2713</small>",
                styles: [".icon-check{color:green;font-size:25px;margin-left:-20px}"]
            }]
    }], null, { control: [{
            type: Input
        }] }); })();

class ValidatorModule {
}
ValidatorModule.ɵfac = function ValidatorModule_Factory(t) { return new (t || ValidatorModule)(); };
ValidatorModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: ValidatorModule });
ValidatorModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ValidatorModule, { declarations: function () { return [ValidatorComponent, InputCheckComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [ValidatorComponent, InputCheckComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ValidatorModule, [{
        type: NgModule,
        args: [{
                declarations: [ValidatorComponent, InputCheckComponent],
                imports: [
                    CommonModule
                ],
                exports: [ValidatorComponent, InputCheckComponent]
            }]
    }], null, null); })();

const validateCPF = (cpf) => {
    cpf = cpf.replace(/\D/g, '');
    if (cpf.toString().length !== 11 || /^(\d)\1{10}$/.test(cpf)) {
        return false;
    }
    let result = true;
    [9, 10].forEach((j) => {
        let soma = 0, r;
        cpf.split(/(?=)/).splice(0, j).forEach(function (e, i) {
            soma += parseInt(e) * ((j + 2) - (i + 1));
        });
        r = soma % 11;
        r = (r < 2) ? 0 : (11 - r);
        if (r != cpf.substring(j, j + 1)) {
            result = false;
        }
    });
    return result;
};
const ɵ0 = validateCPF;
const validateCNPJ = (cnpj) => {
    cnpj = cnpj.replace(/[^\d]+/g, '');
    if (cnpj == '') {
        return false;
    }
    if (cnpj.length != 14) {
        return false;
    }
    // Elimina CNPJs invalidos conhecidos
    if (cnpj == "00000000000000" ||
        cnpj == "11111111111111" ||
        cnpj == "22222222222222" ||
        cnpj == "33333333333333" ||
        cnpj == "44444444444444" ||
        cnpj == "55555555555555" ||
        cnpj == "66666666666666" ||
        cnpj == "77777777777777" ||
        cnpj == "88888888888888" ||
        cnpj == "99999999999999") {
        return false;
    }
    // Valida DVs
    let tamanho = cnpj.length - 2;
    let numeros = cnpj.substring(0, tamanho);
    const digitos = cnpj.substring(tamanho);
    let soma = 0;
    let pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2) {
            pos = 9;
        }
    }
    let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != digitos.charAt(0)) {
        return false;
    }
    tamanho = tamanho + 1;
    numeros = cnpj.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2) {
            pos = 9;
        }
    }
    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != digitos.charAt(1)) {
        return false;
    }
    return true;
};
const ɵ1 = validateCNPJ;

// @dynamic
class ValidatorsUtil {
    static required(label) {
        const result = (control) => control.value ? null : { requiredCustom: `O campo ${label} é obrigatório` };
        return result;
    }
    // @dynamic
    static maxLength(max, label = 'preenchido') {
        return (control) => {
            if (!control.value || control.value === '') {
                return null;
            }
            return control.value && control.value.length <= max
                ? null
                : { maxLengthCustom: `O campo ${label} deve ter no máximo ${max} caracteres` };
        };
    }
    static minLength(min, label = 'preenchido') {
        return (control) => {
            if (!control.value || control.value === '') {
                return null;
            }
            return control.value && control.value.length < min
                ? { minLengthCustom: `O campo ${label} deve ter no minimo ${min} caracteres` }
                : null;
        };
    }
    static isNumber(label) {
        return (control) => {
            if (!control.value || control.value === '') {
                return null;
            }
            return !isNaN(+control.value) ? null : { isNumberCustom: `O campo ${label} deve ser um número` };
        };
    }
    static differentThanZero(label) {
        label = label ? label : 'preenchido';
        return (control) => {
            if (!control.value || control.value === '') {
                return null;
            }
            return +control.value >= 0 ? null : { differentThanZeroCustom: `O campo ${label} deve ser diferente de zero` };
        };
    }
    static positiveNumberOrZero(label) {
        label = label ? label : 'preenchido';
        return (control) => {
            if (!control.value) {
                return null;
            }
            return +control.value >= 0 ? null : { positiveNumberOrZeroCustom: `O campo ${label} deve ser positivo ou zero` };
        };
    }
    static isValidURL(label) {
        const pattern = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
        return (control) => {
            label = label ? label : 'URL';
            if (!control.value || control.value === '') {
                return null;
            }
            return pattern.test(control.value) ? null : { isValidURLCustom: label ? `O campo ${label} não é válida` : 'Digite uma URL válida' };
        };
    }
    static isValidEmail(label) {
        const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return (control) => {
            label = label ? label : 'Email';
            if (!control.value || control.value === '') {
                return null;
            }
            const result = regex.test(String(control.value).toLowerCase());
            return result ? null : { isValidEmailCustom: label ? `O campo ${label} não é válido` : 'Digite um email válido' };
        };
    }
    static isNameValid(label) {
        return (control) => {
            if (!control.value || control.value === '') {
                return null;
            }
            label = label ? label : 'nome';
            const name = control.value;
            const patt = /[0-9]|[\"\!\@\$\%\&\*\(\)\_\-\=\+]/g;
            return patt.test(name) ? { isNameValidCustom: `O campo ${label} não é válido` } : null;
        };
    }
    static forbiddenStringValidator(textString, label = 'campo') {
        return (control) => {
            if (!control.value || control.value === '') {
                return null;
            }
            const forbidden = textString === control.value;
            return forbidden ? { forbiddenStringValidatorCustom: `O campo ${label} não pode ser ${textString}` } : null;
        };
    }
    static isDateMoreThan(minYear, label) {
        return (control) => {
            if (!control.value || control.value === '') {
                return null;
            }
            label = label ? label : 'nome';
            const date = control.value;
            if (!date || date.length <= 9) {
                return null;
            }
            const dayObj = `${date[0]}${date[1]}`;
            const monthObj = `${date[3]}${date[4]}`;
            const yearObj = `${date[6]}${date[7]}${date[8]}${date[9]}`;
            const dateObj = new Date(+yearObj, +monthObj - 1, +dayObj);
            const month = dateObj.getUTCMonth();
            const day = dateObj.getUTCDate();
            const year = dateObj.getUTCFullYear();
            const result = new Date(year + minYear, month, day) <= new Date();
            return result ? null : { isDateMoreThanCustom: `É necessário ter no mínimo ${minYear} anos para continuar` };
        };
    }
    static isValidDocument() {
        return (control) => {
            const value = control.value;
            if (!value) {
                return null;
            }
            const isValidCPF = validateCPF(value);
            const isValidCNPJ = validateCNPJ(value);
            return (isValidCNPJ ? isValidCNPJ : isValidCPF) ? null : { invalidDocument: 'Documento inválido' };
        };
    }
}

/**
 * Generated bundle index. Do not edit.
 */

export { AdminComponent, AdminModule, AppBreadcrumbModule, BrandMinimizeDirective, CommonFunctionsService, FooterModule, HtmlAttributesDirective, InputCheckComponent, LandingModule, LayoutModule, MobileSidebarToggleDirective, SafePipe, SidebarMinimizeDirective, SidebarOffCanvasCloseDirective, SidebarToggleDirective, ValidatorBase, ValidatorComponent, ValidatorModule, ValidatorsUtil, dynamicEnv, formEvents, getBasePath, ɵ0$2 as ɵ0, ɵ1$1 as ɵ1, ɵ2, ɵ3, ɵ4, AppHeaderAdminModule as ɵa, AppHeaderAdminComponent as ɵb, AppFooterModule as ɵba, AppFooterComponent as ɵbb, AppBreadcrumbComponent as ɵbc, AppBreadcrumbService as ɵbd, LandingComponent as ɵbe, FooterComponent as ɵbf, HeaderModule as ɵbg, HeaderComponent as ɵbh, ToogleInformationModule as ɵbi, ToogleInformationComponent as ɵbj, BlankFooterMobileModule as ɵbk, BlankMobileFooterComponent as ɵbl, ClassToggler as ɵbm, LayoutModule as ɵc, AppSidebarModule as ɵd, AppSidebarFooterComponent as ɵe, AppSidebarFormComponent as ɵf, AppSidebarHeaderComponent as ɵg, AppSidebarMinimizerComponent as ɵh, AppSidebarService as ɵi, AppSidebarComponent as ɵj, AppSidebarNavItemsComponent as ɵk, SidebarNavHelper as ɵl, AppSidebarNavComponent as ɵm, AppSidebarNavDividerComponent as ɵn, AppSidebarNavDropdownComponent as ɵo, AppSidebarNavLinkContentComponent as ɵp, AppSidebarNavLinkComponent as ɵq, AppSidebarNavTitleComponent as ɵr, NavDropdownDirective as ɵs, NavDropdownToggleDirective as ɵt, AppSidebarNavLabelComponent as ɵu, AppSidebarNavIconPipe as ɵv, AppSidebarNavBadgePipe as ɵw, AppSidebarNavLinkPipe as ɵx, AppSidebarNavItemClassPipe as ɵy, AppBreadcrumbModule as ɵz };

//# sourceMappingURL=dharma-ui-common.js.map